"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4916],{

/***/ 2002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgClose = function SvgClose(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10"
    }, props), _path || (_path = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fill: "#000",
        fillRule: "evenodd",
        d: "m5.894 5 3.92-3.92A.632.632 0 1 0 8.92.185L5 4.105 1.08.186a.632.632 0 0 0-.895.895L4.105 5 .186 8.92a.632.632 0 1 0 .895.895L5 5.895l3.92 3.92a.632.632 0 1 0 .895-.895z"
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgClose);


/***/ }),

/***/ 96339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FZ": function() { return /* binding */ currentSmallerThanFinalDate; },
/* harmony export */   "jB": function() { return /* binding */ fireHotjarEventScript; },
/* harmony export */   "no": function() { return /* binding */ fireHotjarEvents; }
/* harmony export */ });
/* unused harmony export fireHotjarEvent */
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64487);

var fireHotjarEventScript = function(eventName) {
    return '(function(w){\n        if(!hj) return;\n        w.hj("event","'.concat(eventName, '");\n    })(window)');
};
var fireHotjarEvent = function(eventName) {
    try {
        if (window.hj) {
            window.hj("event", eventName);
        }
    } catch (e) {
        _sentry_nextjs__WEBPACK_IMPORTED_MODULE_0__/* .captureException */ .Tb(e);
    }
};
// fires a list of events to Hotjar
var fireHotjarEvents = function(eventNames) {
    // have only unique values
    var uniqueEventNames = eventNames.filter(function(element, index, array) {
        return array.indexOf(element) === index;
    });
    // fire each event, so filtering can be fully customized on Hotjar side
    uniqueEventNames.forEach(function(uniqueEventName) {
        return fireHotjarEvent(uniqueEventName);
    });
};
var currentSmallerThanFinalDate = function(hotjarFinalDate) {
    var currentDate = new Date();
    var finalDate = new Date(hotjarFinalDate);
    return currentDate.getTime() <= finalDate.getTime();
};


/***/ }),

/***/ 31766:
/***/ (function(module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _defineProperty = (__webpack_require__(79361)["default"]);
var MAIN_COUNTRY_CODES = (__webpack_require__(85010).MAIN_COUNTRY_CODES);
// ** FORM IDS **
var TYPEFORM_CONTACT_SALES_EMEA_SALES_AND_PARTNERS_FORM_ID = "Rb9pva6n";
var TYPEFORM_CONTACT_SALES_EMEA_SALES_ONLY_FORM_ID = "PlrwsC4F";
var TYPEFORM_CONTACT_SALES_EMEA_GERMAN_FORM_ID = "onptOGWz";
var TYPEFORM_CONTACT_SALES_FRENCH_FORM_ID = "B91EZP5w";
var TYPEFORM_CONTACT_SALES_PORTUGEESE_NO_SDR_FORM_ID = "fcCPz0Z1";
var TYPEFORM_CONTACT_SALES_SPANISH_NO_SDR_FORM_ID = "MCW2vdfv";
var TYPEFORM_CONTACT_SALES_ANZ_REGION_FORM_ID = "WYNld7NX";
var TYPEFORM_CONTACT_SALES_AMERICA_REGION_FORM_ID = "Fl3WSnnm";
var TYPEFORM_CONTACT_SALES_NO_SDR_FORM_ID = "idXP35wo";
// used for AB tests only
var TYPEFORM_CONTACT_SALES_AMERICA_REGION_TEST_VARIANT_FORM_ID = "xp0et7IG";
// used for testing only
var TEST_TYPEFORM_CONTACT_SALES_FORM_ID = "Qi8VILCS";
// ** SALES GEOGRAPHIC REGIONS **
var EMEA_GEO_REGION = "EMEA";
var AUSTRALIA_NEW_ZEALAND_GEO_REGION = "ANZ";
var AMERICA_GEO_REGION = "AMERICA";
var LATAM_GEO_REGION = "LATAM";
var REST_OF_THE_WORLD_GEO_REGION = "REST_OF_THE_WORLD";
var TEST_GEO_REGION = "TEST";
// *****************************
// **** FORM REGION TYPES: *******
// EMEA
var EMEA_SALES_AND_PARTNERS_REGION_TYPE = "EMEA_SALES_AND_PARTNERS";
var EMEA_SALES_ONLY_REGION_TYPE = "EMEA_SALES_ONLY";
var EMEA_PARTNERS_ONLY_REGION_TYPE = "EMEA_PARTNERS_ONLY";
var EMEA_FRENCH_SALES_AND_PARTNERS_REGION_TYPE = "EMEA_FRENCH_SALES_AND_PARTNERS";
var PORTUGAL_NO_SDR_TYPE = "PORTUGAL_NO_SDR";
var BRAZIL_NO_SDR_TYPE = "BRAZIL_NO_SDR";
var SPAIN_NO_SDR_TYPE = "SPAIN_NO_SDR";
var EMEA_GERMAN_SALES_AND_PARTNERS_REGION_TYPE = "EMEA_GERMAN_SALES_AND_PARTNERS_REGION";
var LATAM_SPANISH_REGIONS_NO_SDR_TYPE = "LATAM_SPANISH_NO_SDR";
// ANZ
var AUSTRALIA_NZ_SALES_ONLY_TYPE = "ANZ_SALES_ONLY";
// AMERICA
var AMERICA_SALES_ONLY_TYPE = "AMERICA_SALES_ONLY";
// DEFAULT
var DEFAULT_NO_SDR_TYPE = "DEFAULT_NO_SDR";
// TEST
var TEST_REGION_TYPE = "TEST_SALES_ONLY";
var _obj;
// *****************************
var CONTACT_SALES_REGIONS = (_obj = {}, _defineProperty(_obj, EMEA_SALES_AND_PARTNERS_REGION_TYPE, {
    countries: [
        MAIN_COUNTRY_CODES.NETHERLANDS_ISO2,
        MAIN_COUNTRY_CODES.BELGIUM_ISO2,
        MAIN_COUNTRY_CODES.SWEDEN_ISO2,
        MAIN_COUNTRY_CODES.NORWAY_ISO2,
        MAIN_COUNTRY_CODES.DENMARK_ISO2,
        MAIN_COUNTRY_CODES.LUXEMBOURG_ISO2,
        MAIN_COUNTRY_CODES.ICELAND_ISO2,
        MAIN_COUNTRY_CODES.FINLAND_ISO2
    ],
    formId: TYPEFORM_CONTACT_SALES_EMEA_SALES_AND_PARTNERS_FORM_ID,
    formType: EMEA_SALES_AND_PARTNERS_REGION_TYPE,
    region: EMEA_GEO_REGION,
    prefetchImages: [
        "https://images.typeform.com/images/Aw2xNHE6PiND/image/default",
        "https://images.typeform.com/images/Aw2xNHE6PiND/image/default-firstframe.png"
    ]
}), _defineProperty(_obj, EMEA_SALES_ONLY_REGION_TYPE, {
    countries: [
        MAIN_COUNTRY_CODES.UNITED_KINGDOM_ISO2,
        MAIN_COUNTRY_CODES.ISRAEL_ISO2,
        MAIN_COUNTRY_CODES.IRELAND_ISO2
    ],
    formId: TYPEFORM_CONTACT_SALES_EMEA_SALES_ONLY_FORM_ID,
    formType: EMEA_SALES_ONLY_REGION_TYPE,
    region: EMEA_GEO_REGION,
    prefetchImages: [
        "https://images.typeform.com/images/zQ2kQjnuBzW3/image/default",
        "https://images.typeform.com/images/zQ2kQjnuBzW3/image/default-firstframe.png"
    ]
}), _defineProperty(_obj, EMEA_GERMAN_SALES_AND_PARTNERS_REGION_TYPE, {
    countries: [
        MAIN_COUNTRY_CODES.GERMANY_ISO2,
        MAIN_COUNTRY_CODES.SWITZERLAND_ISO2,
        MAIN_COUNTRY_CODES.AUSTRIA_ISO2
    ],
    formId: TYPEFORM_CONTACT_SALES_EMEA_GERMAN_FORM_ID,
    formType: EMEA_GERMAN_SALES_AND_PARTNERS_REGION_TYPE,
    region: EMEA_GEO_REGION,
    prefetchImages: [
        "https://images.typeform.com/images/Jue6uWpkSzyq/image/default",
        "https://images.typeform.com/images/Jue6uWpkSzyq/image/default-firstframe.png"
    ]
}), _defineProperty(_obj, EMEA_PARTNERS_ONLY_REGION_TYPE, {
    // Can be removed and merged with DEFAULT_NO_SDR_TYPE once we release to entire world
    countries: [
        MAIN_COUNTRY_CODES.ARMENIA_ISO2,
        MAIN_COUNTRY_CODES.AZERBAIJAN_ISO2,
        MAIN_COUNTRY_CODES.BAHRAIN_ISO2,
        MAIN_COUNTRY_CODES.BELARUS_ISO2,
        MAIN_COUNTRY_CODES.BULGARIA_ISO2,
        MAIN_COUNTRY_CODES.CROATIA_ISO2,
        MAIN_COUNTRY_CODES.CYPRUS_ISO2,
        MAIN_COUNTRY_CODES.CZECHIA_ISO2,
        MAIN_COUNTRY_CODES.EGYPT_ISO2,
        MAIN_COUNTRY_CODES.ESTONIA_ISO2,
        MAIN_COUNTRY_CODES.GEORGIA_ISO2,
        MAIN_COUNTRY_CODES.GREECE_ISO2,
        MAIN_COUNTRY_CODES.HUNGARY_ISO2,
        MAIN_COUNTRY_CODES.ITALY_ISO2,
        MAIN_COUNTRY_CODES.KAZAKHSTAN_ISO2,
        MAIN_COUNTRY_CODES.KENYA_ISO2,
        MAIN_COUNTRY_CODES.KUWAIT_ISO2,
        MAIN_COUNTRY_CODES.LATVIA_ISO2,
        MAIN_COUNTRY_CODES.LITHUANIA_ISO2,
        MAIN_COUNTRY_CODES.MAURITIUS_ISO2,
        MAIN_COUNTRY_CODES.MOZAMBIQUE_ISO2,
        MAIN_COUNTRY_CODES.NIGERIA_ISO2,
        MAIN_COUNTRY_CODES.OMAN_ISO2,
        MAIN_COUNTRY_CODES.POLAND_ISO2,
        MAIN_COUNTRY_CODES.QATAR_ISO2,
        MAIN_COUNTRY_CODES.ROMANIA_ISO2,
        MAIN_COUNTRY_CODES.RUSSIA_ISO2,
        MAIN_COUNTRY_CODES.RWANDA_ISO2,
        MAIN_COUNTRY_CODES.SAUDI_ARABIA_ISO2,
        MAIN_COUNTRY_CODES.SLOVAKIA_ISO2,
        MAIN_COUNTRY_CODES.SLOVENIA_ISO2,
        MAIN_COUNTRY_CODES.SOUTH_AFRICA_ISO2,
        MAIN_COUNTRY_CODES.SOUTH_SUDAN_ISO2,
        MAIN_COUNTRY_CODES.TANZANIA_ISO2,
        MAIN_COUNTRY_CODES.TURKEY_ISO2,
        MAIN_COUNTRY_CODES.UGANDA_ISO2,
        MAIN_COUNTRY_CODES.UKRAINE_ISO2,
        MAIN_COUNTRY_CODES.UNITED_ARAB_EMIRATES_ISO2,
        MAIN_COUNTRY_CODES.UZBEKISTAN_ISO2
    ],
    formId: TYPEFORM_CONTACT_SALES_NO_SDR_FORM_ID,
    formType: EMEA_PARTNERS_ONLY_REGION_TYPE,
    region: EMEA_GEO_REGION,
    prefetchImages: [
        "https://images.typeform.com/images/2YTm6WS6wcLe/image/default",
        "https://images.typeform.com/images/2YTm6WS6wcLe/image/default-firstframe.png"
    ]
}), _defineProperty(_obj, EMEA_FRENCH_SALES_AND_PARTNERS_REGION_TYPE, {
    countries: [
        MAIN_COUNTRY_CODES.FRANCE_ISO2
    ],
    formId: TYPEFORM_CONTACT_SALES_FRENCH_FORM_ID,
    formType: EMEA_FRENCH_SALES_AND_PARTNERS_REGION_TYPE,
    region: EMEA_GEO_REGION,
    prefetchImages: [
        "https://images.typeform.com/images/rZDcCEwqLVtd/image/default",
        "https://images.typeform.com/images/rZDcCEwqLVtd/image/default-firstframe.png"
    ]
}), _defineProperty(_obj, AUSTRALIA_NZ_SALES_ONLY_TYPE, {
    countries: [
        MAIN_COUNTRY_CODES.AUSTRALIA_ISO2,
        MAIN_COUNTRY_CODES.NEW_ZEALAND_ISO2
    ],
    formId: TYPEFORM_CONTACT_SALES_ANZ_REGION_FORM_ID,
    formType: AUSTRALIA_NZ_SALES_ONLY_TYPE,
    region: AUSTRALIA_NEW_ZEALAND_GEO_REGION,
    prefetchImages: [
        "https://images.typeform.com/images/2wA8X5swymX2/image/default",
        "https://images.typeform.com/images/2wA8X5swymX2/image/default-firstframe.png"
    ]
}), _defineProperty(_obj, AMERICA_SALES_ONLY_TYPE, {
    countries: [
        MAIN_COUNTRY_CODES.UNITED_STATES_ISO2,
        MAIN_COUNTRY_CODES.CANADA_ISO2
    ],
    formId: TYPEFORM_CONTACT_SALES_AMERICA_REGION_FORM_ID,
    formType: AMERICA_SALES_ONLY_TYPE,
    region: AMERICA_GEO_REGION,
    prefetchImages: [
        "https://images.typeform.com/images/KCQAM5ifzaty/image/default",
        "https://images.typeform.com/images/KCQAM5ifzaty/image/default-firstframe.png"
    ],
    // Test variant
    variantFormId: TYPEFORM_CONTACT_SALES_AMERICA_REGION_TEST_VARIANT_FORM_ID,
    variantPrefetchImages: [
        "https://images.typeform.com/images/uJRuZPNTVcVz/image/default",
        "https://images.typeform.com/images/uJRuZPNTVcVz/image/default-firstframe.png"
    ]
}), _defineProperty(_obj, PORTUGAL_NO_SDR_TYPE, {
    countries: [
        MAIN_COUNTRY_CODES.PORTUGAL_ISO2
    ],
    formId: TYPEFORM_CONTACT_SALES_PORTUGEESE_NO_SDR_FORM_ID,
    formType: PORTUGAL_NO_SDR_TYPE,
    region: EMEA_GEO_REGION,
    prefetchImages: [
        "https://images.typeform.com/images/6NuLbnPVhJxy/image/default",
        "https://images.typeform.com/images/6NuLbnPVhJxy/image/default-firstframe.png"
    ]
}), _defineProperty(_obj, BRAZIL_NO_SDR_TYPE, {
    countries: [
        MAIN_COUNTRY_CODES.BRAZIL_ISO2
    ],
    formId: TYPEFORM_CONTACT_SALES_PORTUGEESE_NO_SDR_FORM_ID,
    formType: BRAZIL_NO_SDR_TYPE,
    region: LATAM_GEO_REGION,
    prefetchImages: [
        "https://images.typeform.com/images/6NuLbnPVhJxy/image/default",
        "https://images.typeform.com/images/6NuLbnPVhJxy/image/default-firstframe.png"
    ]
}), _defineProperty(_obj, SPAIN_NO_SDR_TYPE, {
    countries: [
        MAIN_COUNTRY_CODES.SPAIN_ISO2
    ],
    formId: TYPEFORM_CONTACT_SALES_SPANISH_NO_SDR_FORM_ID,
    formType: SPAIN_NO_SDR_TYPE,
    region: EMEA_GEO_REGION,
    prefetchImages: [
        "https://images.typeform.com/images/FV6CXnihkcXG/image/default",
        "https://images.typeform.com/images/FV6CXnihkcXG/image/default-firstframe.png"
    ]
}), _defineProperty(_obj, LATAM_SPANISH_REGIONS_NO_SDR_TYPE, {
    countries: [
        MAIN_COUNTRY_CODES.MEXICO_ISO2,
        MAIN_COUNTRY_CODES.COSTA_RICA_ISO2,
        MAIN_COUNTRY_CODES.EL_SALVADOR_ISO2,
        MAIN_COUNTRY_CODES.GUATEMALA_ISO2,
        MAIN_COUNTRY_CODES.HONDURAS_ISO2,
        MAIN_COUNTRY_CODES.NICARAGUA_ISO2,
        MAIN_COUNTRY_CODES.PANAMA_ISO2,
        MAIN_COUNTRY_CODES.CUBA_ISO2,
        MAIN_COUNTRY_CODES.DOMINICAN_REPUBLIC_ISO2,
        MAIN_COUNTRY_CODES.PUERTO_RICO_ISO2,
        MAIN_COUNTRY_CODES.ARGENTINA_ISO2,
        MAIN_COUNTRY_CODES.BOLIVIA_ISO2,
        MAIN_COUNTRY_CODES.CHILE_ISO2,
        MAIN_COUNTRY_CODES.COLUMBIA_ISO2,
        MAIN_COUNTRY_CODES.ECUADOR_ISO2,
        MAIN_COUNTRY_CODES.PARAGUAY_ISO2,
        MAIN_COUNTRY_CODES.PERU_ISO2,
        MAIN_COUNTRY_CODES.URUGUAY_ISO2,
        MAIN_COUNTRY_CODES.VENEZUELA_ISO2,
        MAIN_COUNTRY_CODES.EQUATORIAL_GUINEA_ISO2
    ],
    formId: TYPEFORM_CONTACT_SALES_SPANISH_NO_SDR_FORM_ID,
    formType: LATAM_SPANISH_REGIONS_NO_SDR_TYPE,
    region: LATAM_GEO_REGION,
    prefetchImages: [
        "https://images.typeform.com/images/FV6CXnihkcXG/image/default",
        "https://images.typeform.com/images/FV6CXnihkcXG/image/default-firstframe.png"
    ]
}), _defineProperty(_obj, DEFAULT_NO_SDR_TYPE, {
    countries: [],
    formId: TYPEFORM_CONTACT_SALES_NO_SDR_FORM_ID,
    formType: DEFAULT_NO_SDR_TYPE,
    region: REST_OF_THE_WORLD_GEO_REGION,
    excludeCountries: [
        MAIN_COUNTRY_CODES.JAPAN_ISO2
    ],
    prefetchImages: [
        "https://images.typeform.com/images/2YTm6WS6wcLe/image/default",
        "https://images.typeform.com/images/2YTm6WS6wcLe/image/default-firstframe.png"
    ]
}), _defineProperty(_obj, TEST_REGION_TYPE, {
    countries: [],
    formId: TEST_TYPEFORM_CONTACT_SALES_FORM_ID,
    formType: TEST_REGION_TYPE,
    region: TEST_GEO_REGION,
    prefetchImages: []
}), _obj);
module.exports = {
    CONTACT_SALES_REGIONS: CONTACT_SALES_REGIONS
};


/***/ }),

/***/ 13979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FC": function() { return /* binding */ isTypeformFullyReleasedForCountry; },
/* harmony export */   "Ks": function() { return /* binding */ getTypeformImagesPrefetchByCountry; },
/* harmony export */   "PM": function() { return /* binding */ TYPEFORM_DESKTOP_DEVICE_TYPE; },
/* harmony export */   "Ux": function() { return /* binding */ AMERICA_GEO_REGION; },
/* harmony export */   "Wz": function() { return /* binding */ getContactSalesRegionByCountry; },
/* harmony export */   "ZZ": function() { return /* binding */ EMEA_GEO_REGION; },
/* harmony export */   "_X": function() { return /* binding */ openContactSalesTypeform; },
/* harmony export */   "hr": function() { return /* binding */ AUSTRALIA_NEW_ZEALAND_GEO_REGION; },
/* harmony export */   "nk": function() { return /* binding */ isTypeformDisabledForRegion; }
/* harmony export */ });
/* unused harmony export TYPEFORM_MOBILE_DEVICE_TYPE */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(14924);
/* harmony import */ var _typeform_embed__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59018);
/* harmony import */ var _typeform_embed__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_typeform_embed__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _typeform_embed_build_css_popup_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56051);
/* harmony import */ var _typeform_embed_build_css_popup_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_typeform_embed_build_css_popup_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _services_bigbrain_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65488);
/* harmony import */ var _services_cookies_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67798);
/* harmony import */ var services_ab_tests_monetization_ab_tests_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46724);
/* harmony import */ var _constants_cookies__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13019);
/* harmony import */ var _constants_cookies__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_constants_cookies__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(65023);
/* harmony import */ var client_services_hubspot_service_hubspot_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22638);
/* harmony import */ var services_sales_enrichment_sales_enrichment_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29919);
/* harmony import */ var services_pricing_pricing_model_services__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3223);
/* harmony import */ var services_typeform_form_service__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6941);
/* harmony import */ var services_typeform_form_service__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(services_typeform_form_service__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var services_monday_platform_existing_accounts_service__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14124);

function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}












var TYPEFORM_DESKTOP_DEVICE_TYPE = "Desktop";
var TYPEFORM_MOBILE_DEVICE_TYPE = "Mobile";
// ** TYPEFORM PARAMS **
var TYPEFORM_CONTACT_SALES_VISITOR_ID_PARAM = "visitor_id";
var TYPEFORM_CONTACT_SALES_COUNTRY_PARAM = "country";
var TYPEFORM_CONTACT_SALES_REGION_PARAM = "region";
var TYPEFORM_CONTACT_SALES_KEEP_SESSION_PARAM = "keepSession";
var TYPEFORM_CONTACT_SALES_DEVICE_PARAM = "Device";
var TYPEFORM_CONTACT_SALES_LEAD_SOURCE_PARAM = "lead_source";
var TYPEFORM_CONTACT_SALES_PRICING_VERSION = "website_pricing_version";
var TYPEFORM_FORM_TYPE_PARAM = "form_type_typeform";
var TYPEFORM_HUBSPOT_UTK_PARAM = "hubspot_utk";
var TYPEFORM_HUBSPOT_PAGE_URL_PARAM = "hubspot_page_url";
var TYPEFORM_HUBSPOT_PAGE_NAME_PARAM = "hubspot_page_name";
// *****************************
// ** SALES GEOGRAPHIC REGIONS **
var EMEA_GEO_REGION = "EMEA";
var AUSTRALIA_NEW_ZEALAND_GEO_REGION = "ANZ";
var AMERICA_GEO_REGION = "AMERICA";
var getContactSalesRegionByCountry = function(countryCode) {
    var typeformData = (0,services_typeform_form_service__WEBPACK_IMPORTED_MODULE_9__.getTypeformContactSalesData)({
        country: countryCode
    });
    return typeformData === null || typeformData === void 0 ? void 0 : typeformData.region;
};
var isTypeformDisabledForRegion = function(countryCode) {
    // const typeformData = getTypeformContactSalesData({ country: countryCode });
    // disable for EMEA - "Iron Swords"
    // if (typeformData?.region === EMEA_GEO_REGION) return true;
    return false;
};
var isTypeformFullyReleasedForCountry = function(countryCode) {
    var _typeformData_excludeCountries;
    var typeformData = (0,services_typeform_form_service__WEBPACK_IMPORTED_MODULE_9__.getTypeformContactSalesData)({
        country: countryCode
    });
    if (typeformData === null || typeformData === void 0 ? void 0 : (_typeformData_excludeCountries = typeformData.excludeCountries) === null || _typeformData_excludeCountries === void 0 ? void 0 : _typeformData_excludeCountries.includes(countryCode)) return false;
    return true; // Fully released to all traffic except specific exclusions
};
var getTypeformImagesPrefetchByCountry = function(countryCode, getNewVariantForTest) {
    var typeformData = (0,services_typeform_form_service__WEBPACK_IMPORTED_MODULE_9__.getTypeformContactSalesData)({
        country: countryCode,
        getNewVariantForTest: getNewVariantForTest
    });
    return (typeformData === null || typeformData === void 0 ? void 0 : typeformData.prefetchImages) || [];
};
var openContactSalesTypeform = function(param) {
    var country = param.country, deviceType = param.deviceType, _isTest = param.isTest, isTest = _isTest === void 0 ? false : _isTest, getNewVariantForTest = param.getNewVariantForTest, pricingData = param.pricingData, onCloseCallback = param.onCloseCallback, onSubmitCallback = param.onSubmitCallback, onReadyCallback = param.onReadyCallback;
    var typeformData = (0,services_typeform_form_service__WEBPACK_IMPORTED_MODULE_9__.getTypeformContactSalesData)({
        country: country,
        isTest: isTest,
        getNewVariantForTest: getNewVariantForTest
    });
    var formId = typeformData.formId, region = typeformData.region, formType = typeformData.formType;
    // fire AB test
    var visitorId = (0,_services_cookies_service__WEBPACK_IMPORTED_MODULE_3__/* .getCookie */ .ej)(_constants_cookies__WEBPACK_IMPORTED_MODULE_5__.BIG_BRAIN_VISITOR_ID) || "";
    var pricingVersion = (0,services_pricing_pricing_model_services__WEBPACK_IMPORTED_MODULE_8__/* .getPricingVersionForSales */ .qM)(pricingData);
    var enrichmentData = (0,services_sales_enrichment_sales_enrichment_service__WEBPACK_IMPORTED_MODULE_7__/* .getEnrichmentEntriesForSales */ .Xk)();
    var _obj;
    var hidden = _object_spread_props(_object_spread({}, enrichmentData.reduce(function(data, item) {
        return data[item.name] = item.value, data;
    }, {})), (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, TYPEFORM_CONTACT_SALES_REGION_PARAM, region), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, TYPEFORM_CONTACT_SALES_COUNTRY_PARAM, country), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, TYPEFORM_CONTACT_SALES_KEEP_SESSION_PARAM, "true"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, TYPEFORM_CONTACT_SALES_VISITOR_ID_PARAM, visitorId), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, TYPEFORM_CONTACT_SALES_DEVICE_PARAM, deviceType), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, TYPEFORM_CONTACT_SALES_LEAD_SOURCE_PARAM, client_services_hubspot_service_hubspot_constants__WEBPACK_IMPORTED_MODULE_6__/* .leadSourceDefaultValue */ .Ts), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, TYPEFORM_CONTACT_SALES_PRICING_VERSION, pricingVersion), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, TYPEFORM_FORM_TYPE_PARAM, formType), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, TYPEFORM_HUBSPOT_UTK_PARAM, (0,_services_cookies_service__WEBPACK_IMPORTED_MODULE_3__/* .getCookie */ .ej)("hubspotutk")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, TYPEFORM_HUBSPOT_PAGE_URL_PARAM, window.location.href), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, TYPEFORM_HUBSPOT_PAGE_NAME_PARAM, document.title), _obj));
    var toggle = (0,_typeform_embed__WEBPACK_IMPORTED_MODULE_0__.createPopup)(formId, {
        onQuestionChanged: function(data) {
            (0,_services_bigbrain_service__WEBPACK_IMPORTED_MODULE_2__.trackEvent)(constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_12__.TYPEFORM_CONTACT_SALES_QUESTION_CHANGED, {
                kind: data === null || data === void 0 ? void 0 : data.ref,
                info1: formId,
                info2: country,
                info3: (0,services_monday_platform_existing_accounts_service__WEBPACK_IMPORTED_MODULE_10__/* .isExistingAccount */ .vn)()
            });
        },
        onSubmit: function(data) {
            (0,_services_bigbrain_service__WEBPACK_IMPORTED_MODULE_2__.trackEvent)(constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_12__.TYPEFORM_CONTACT_SALES_FORM_SUBMITTED, {
                kind: data === null || data === void 0 ? void 0 : data.responseId,
                info1: formId,
                info2: country,
                info3: (0,services_monday_platform_existing_accounts_service__WEBPACK_IMPORTED_MODULE_10__/* .isExistingAccount */ .vn)()
            });
            if (pricingData) {
                var abTests = pricingData.abTests, cookies = pricingData.cookies, forcePricing = pricingData.forcePricing, isV13PricingVersion = pricingData.isV13PricingVersion;
                (0,services_ab_tests_monetization_ab_tests_service__WEBPACK_IMPORTED_MODULE_4__/* .enterV13TestIfNeeded */ .p)(abTests, cookies, forcePricing, isV13PricingVersion);
            }
            onSubmitCallback === null || onSubmitCallback === void 0 ? void 0 : onSubmitCallback();
        },
        onReady: function() {
            (0,_services_bigbrain_service__WEBPACK_IMPORTED_MODULE_2__.trackEvent)(constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_12__.TYPEFORM_CONTACT_SALES_FORM_LOADED, {
                info1: formId,
                info2: country,
                info3: (0,services_monday_platform_existing_accounts_service__WEBPACK_IMPORTED_MODULE_10__/* .isExistingAccount */ .vn)()
            });
            onReadyCallback === null || onReadyCallback === void 0 ? void 0 : onReadyCallback();
        },
        onClose: function() {
            (0,_services_bigbrain_service__WEBPACK_IMPORTED_MODULE_2__.trackEvent)(constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_12__.TYPEFORM_CONTACT_SALES_FORM_CLOSED, {
                info1: formId,
                info2: country,
                info3: (0,services_monday_platform_existing_accounts_service__WEBPACK_IMPORTED_MODULE_10__/* .isExistingAccount */ .vn)()
            });
            onCloseCallback === null || onCloseCallback === void 0 ? void 0 : onCloseCallback();
        },
        hidden: hidden
    }).toggle;
    toggle();
};


/***/ }),

/***/ 15814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ banner; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./client/components/system/monday-markup-language/monday-markup-language-component.js + 11 modules
var monday_markup_language_component = __webpack_require__(36239);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button.js + 17 modules
var button_button = __webpack_require__(11068);
// EXTERNAL MODULE: ./static/svg/icons/close.svg
var icons_close = __webpack_require__(2002);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./services/cookies-service.js
var cookies_service = __webpack_require__(67798);
// EXTERNAL MODULE: ./constants/cookies.js
var cookies = __webpack_require__(13019);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button-consts.js
var button_consts = __webpack_require__(75650);
// EXTERNAL MODULE: ./components/core/new-button/button-component.js + 1 modules
var button_component = __webpack_require__(35061);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/components/basic-header/constants.js
var constants = __webpack_require__(72428);
;// CONCATENATED MODULE: ./segments/desktop/core-components/banner/banner.scss.js




var bannerHeight = "72px";
var bannerTextLinHeight = "24px";
var StyledBanner = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1o7tdaf0"
})("height:", bannerHeight, ";display:flex;justify-content:center;position:relative;&.top-margin{margin-top:", constants/* default.SECONDARY_HEADER_HEIGHT */.Z.SECONDARY_HEADER_HEIGHT, "px;}.banner-content{display:flex;width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;.image-wrapper{display:flex;flex-grow:0;.banner-image{height:", bannerHeight, ";}}&.with-sticky-images{width:auto;align-items:center;.banner-image{height:", bannerTextLinHeight, ";}}.banner-text-and-cta{display:flex;justify-content:center;align-items:center;flex-grow:1;.banner-text-and-link{display:flex;align-items:center;.banner-text{display:inline;font-size:1rem;line-height:", bannerTextLinHeight, ";text-align:center;}.banner-icon-wrapper{display:flex;margin-right:8px;.picture-component{display:flex;}}}.banner-cta-wrapper{display:inline-block;margin-left:24px;min-width:190px;.ladda-button{padding:12px 20px;background:", colors/* default.white */.Z.white, ";", function(param) {
    var buttonTextColor = param.buttonTextColor;
    return buttonTextColor && "color: ".concat(colors/* default */.Z[buttonTextColor], ";");
}, "}}}}.close-icon-wrapper{position:absolute;top:10px;right:10px;cursor:pointer;svg{width:12px;height:12px;path{fill:", colors/* default.white */.Z.white, ";}}}&.hide-banner{display:none;}@media (max-width:", vp_sizes/* MIN_HEADER_DESKTOP_MENU */.dD, "px){&.top-margin{margin-top:0px;}.banner-content{width:initial;.image-wrapper{.banner-picture{display:flex;align-items:center;.banner-image{height:50px;}}}.banner-text-and-cta{margin-left:20px;margin-right:35px;justify-content:center;flex-grow:0;flex-direction:column;.banner-cta-wrapper{margin-left:0;min-width:unset;align-self:start;.secondary-button{font-size:0.8125rem;}}.banner-text-and-link{display:flex;align-items:center;flex-direction:column;gap:10px;.banner-text{font-size:1rem;text-align:left;font-weight:400;}.banner-link{font-size:1rem;}}}}}@media (max-width:600px){.banner-content{.banner-text-and-cta{.banner-text-and-link{display:inline-block;text-align:center;max-width:274px;.banner-text{font-size:0.8125rem;}.banner-link{font-size:0.8125rem;}.banner-cta-wrapper{margin-left:16px;}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/banner/default-props.js

/* harmony default export */ var default_props = ({
    bannerText: "<monday-bold>Is your team working from home?</monday-bold> Use monday.com to get remote work done",
    bannerCta: "Start Collaborating",
    withCloseIcon: true,
    theme: "dodger-blue",
    buttonConfig: {
        buttonSize: button_component.SM
    },
    extraData: {}
});

// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
;// CONCATENATED MODULE: ./segments/desktop/core-components/banner/banner.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


















var BANNER_EXPIRE_DAYS = 7;
var SIGNUP_BANNER_PLACEMENT = "top_with_background_banner";
var Banner = function(props) {
    var bannerText = props.bannerText, bannerLinkData = props.bannerLinkData, bannerCta = props.bannerCta, bannerleftImage = props.bannerleftImage, bannerRightImage = props.bannerRightImage, withCloseIcon = props.withCloseIcon, theme = props.theme, buttonConfig = props.buttonConfig, isMobileOrTabletBrowser = props.isMobileOrTabletBrowser, isSecondaryMenuNeeded = props.isSecondaryMenuNeeded, placement = props.placement, hideBannerWithBackground = props.hideBannerWithBackground, stickImagesToText = props.stickImagesToText, extraData = props.extraData, bannerHeight = props.bannerHeight, mobileBannerText = props.mobileBannerText, bannerIcon = props.bannerIcon, bannerIconHeight = props.bannerIconHeight;
    var ref = (0,react.useState)(hideBannerWithBackground && withCloseIcon), hideBanner = ref[0], setHideBanner = ref[1]; // for now only banner that can be closed use the cookie
    var getThemes = function() {
        return _object_spread_props(_object_spread({}, segments_service/* themes */.np), {
            "dodger-blue": {
                color: colors/* default.white */.Z.white,
                background: colors/* default.dodger-blue */.Z["dodger-blue"]
            }
        });
    };
    var getThemeStyle = function() {
        return getThemes()[theme] || {};
    };
    var themeStyle = getThemeStyle();
    var onCloseBanner = function() {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.TOP_BANNER_CLOSED_CLICK);
        (0,cookies_service/* setCookie */.d8)(cookies.HIDE_BANNER_WITH_BACKGROUND_COOKIE_NAME, true, {
            expires: BANNER_EXPIRE_DAYS
        });
        setHideBanner(true);
    };
    var onBannerLinkClicked = function(link) {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.BANNER_LINK_CLICKED, {
            kind: link
        });
    };
    var getBannerButtonProps = function() {
        var buttonProps = {
            ctaText: bannerCta,
            placement: placement || SIGNUP_BANNER_PLACEMENT,
            buttonSpinnerColor: themeStyle.background,
            parentSegment: "Banner",
            useCtaText: true,
            extraData: extraData
        };
        if (isMobileOrTabletBrowser) {
            var MOBILE_NOT_ALLOWED_BUTTON_TYPES = [
                button_consts/* REGULAR_BUTTON_TYPE */.ys
            ];
            var buttonType = buttonConfig.buttonType;
            var buttonDisplayType = buttonConfig.buttonDisplayType;
            var extraButtonProps = {};
            if (MOBILE_NOT_ALLOWED_BUTTON_TYPES.includes(buttonType)) {
                extraButtonProps.buttonType = button_consts/* SECONDARY_BUTTON_TYPE */.jE;
            }
            if (buttonConfig.buttonType === button_consts/* YOUTUBE_POPUP_LINK_TYPE */.F9 && MOBILE_NOT_ALLOWED_BUTTON_TYPES.includes(buttonDisplayType)) {
                extraButtonProps.buttonDisplayType = button_consts/* SECONDARY_BUTTON_TYPE */.jE;
            }
            buttonProps = _object_spread_props(_object_spread({}, buttonProps, extraButtonProps), {
                buttonSize: button_component.SM
            });
        }
        return buttonProps;
    };
    var getBannerText = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_markup_language_component/* default */.Z, {
            className: "banner-text",
            text: mobileBannerText && isMobileOrTabletBrowser ? mobileBannerText : bannerText,
            style: bannerIcon ? {
                textAlign: "left"
            } : {}
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBanner, {
        className: classnames_default()("banner", {
            "hide-banner": hideBanner,
            "top-margin": isSecondaryMenuNeeded
        }),
        buttonTextColor: theme,
        style: bannerHeight ? _object_spread_props(_object_spread({}, themeStyle), {
            height: bannerHeight
        }) : themeStyle,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("banner-content", {
                    "with-sticky-images": stickImagesToText
                }),
                children: [
                    bannerleftImage && !isMobileOrTabletBrowser && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "image-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                            src: bannerleftImage,
                            className: "banner-image",
                            pictureClass: "banner-picture"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "banner-text-and-cta",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "banner-text-and-link",
                            style: bannerIcon ? {
                                display: "flex",
                                "flex-direction": "row"
                            } : {},
                            children: [
                                bannerIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "banner-icon-wrapper",
                                    style: {
                                        height: bannerIconHeight
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                        src: bannerIcon
                                    })
                                }),
                                getBannerText(),
                                bannerLinkData && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "banner-link",
                                    href: bannerLinkData.src,
                                    style: {
                                        color: themeStyle.color
                                    },
                                    target: "_blank",
                                    rel: "noreferrer",
                                    onClick: function() {
                                        return onBannerLinkClicked(bannerLinkData.src);
                                    },
                                    children: bannerLinkData.text
                                }),
                                buttonConfig && buttonConfig.buttonType && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "banner-cta-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* default */.Z, _object_spread({}, buttonConfig, getBannerButtonProps()))
                                })
                            ]
                        })
                    }),
                    bannerRightImage && !isMobileOrTabletBrowser && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "image-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                            src: bannerRightImage,
                            className: "banner-image",
                            pictureClass: "banner-picture"
                        })
                    })
                ]
            }),
            withCloseIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "close-icon-wrapper",
                onClick: onCloseBanner,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_close/* default */.Z, {})
            })
        ]
    });
};
Banner.defaultProps = default_props;
/* harmony default export */ var banner = ((0,generic_config_context/* withGenericConfig */.P)(Banner));


/***/ }),

/***/ 62414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ starsClusters; }
/* harmony export */ });
/* harmony import */ var constants_clusters__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16961);
/* harmony import */ var constants_clusters__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_clusters__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styles_color_consts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(273);


var starsClusters = [
    {
        text: "Creative & design",
        image: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/design_icon.png",
        colorName: "sofia-pink",
        clusterId: constants_clusters__WEBPACK_IMPORTED_MODULE_0__.DESIGN_AND_CREATIVE
    },
    {
        text: "IT",
        image: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/it_icon.png",
        colorName: "purple-v2",
        clusterId: constants_clusters__WEBPACK_IMPORTED_MODULE_0__.IT
    },
    {
        text: "Software development",
        image: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/dev_icon.png",
        colorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.DEV_GREEN_COLOR_NAME,
        clusterId: constants_clusters__WEBPACK_IMPORTED_MODULE_0__.SOFTWARE
    },
    {
        text: "Marketing",
        image: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/marketing_icon.png",
        colorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.MARKETING_RED_COLOR_NAME,
        clusterId: constants_clusters__WEBPACK_IMPORTED_MODULE_0__.MARKETING
    },
    {
        text: "Project management",
        image: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/pmo_icon.png",
        colorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.PROJECTS_ORANGE_COLOR_NAME,
        clusterId: constants_clusters__WEBPACK_IMPORTED_MODULE_0__.GENERIC_CLUSTER,
        useCaseId: constants_clusters__WEBPACK_IMPORTED_MODULE_0__.PROJECT_MANAGEMENT_USE_CASE
    },
    {
        text: "Sales & CRM",
        image: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/crm_icon.png",
        colorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.CRM_GREEN_COLOR_NAME,
        clusterId: constants_clusters__WEBPACK_IMPORTED_MODULE_0__.CRM
    },
    {
        text: "Task management",
        image: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/task_icon.png",
        colorName: "light-blue-v2",
        clusterId: constants_clusters__WEBPACK_IMPORTED_MODULE_0__.GENERIC_CLUSTER
    },
    {
        text: "HR",
        image: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/hr_icon.png",
        colorName: "sunset",
        clusterId: constants_clusters__WEBPACK_IMPORTED_MODULE_0__.HR
    },
    {
        text: "Operations",
        image: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/operations_icon.png",
        colorName: "aquamarine",
        clusterId: constants_clusters__WEBPACK_IMPORTED_MODULE_0__.OPERATIONS
    }
];
/* harmony default export */ __webpack_exports__["Z"] = ({
    tagsWidth: "140px",
    clusters: starsClusters,
    buttonConfig: {
        buttonColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.IRIS_COLOR_NAME
    }
});


/***/ }),

/***/ 76416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ PRESELECTED_TAG_PARAM_NAME; },
  "Z": function() { return /* binding */ square_tags; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./constants/clusters/types.js
var types = __webpack_require__(10945);
// EXTERNAL MODULE: ./services/clusters-service.js + 1 modules
var clusters_service = __webpack_require__(25866);
// EXTERNAL MODULE: ./constants/clusters.js
var constants_clusters = __webpack_require__(16961);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/signup-button/signup-button.js + 1 modules
var signup_button = __webpack_require__(85850);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/secondary-button/secondary-button.js + 1 modules
var secondary_button = __webpack_require__(95736);
// EXTERNAL MODULE: ./styles/colors-utils.js
var colors_utils = __webpack_require__(61012);
// EXTERNAL MODULE: ./client/services/hotjar-service/hotjar-service.js
var hotjar_service = __webpack_require__(96339);
// EXTERNAL MODULE: ./utils/url.js
var url = __webpack_require__(8339);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
// EXTERNAL MODULE: ./services/utils-service.js
var utils_service = __webpack_require__(20618);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
// EXTERNAL MODULE: ./constants/data-layer-event-types.js
var data_layer_event_types = __webpack_require__(34496);
var data_layer_event_types_default = /*#__PURE__*/__webpack_require__.n(data_layer_event_types);
// EXTERNAL MODULE: ./client/services/gtm-service/gtm-service.js
var gtm_service = __webpack_require__(60775);
// EXTERNAL MODULE: ./node_modules/monday-ui-react-core/dist/icons/Check.js
var Check = __webpack_require__(74565);
var Check_default = /*#__PURE__*/__webpack_require__.n(Check);
;// CONCATENATED MODULE: ./segments/desktop/core-components/square-tags/square-tag/components/tag-checkbox.js





var TagCheckbox = function(param) {
    var checkColor = param.checkColor, isSelected = param.isSelected, selectedBorderColor = param.selectedBorderColor, tagBorderColor = param.tagBorderColor, selectedBackgroundColor = param.selectedBackgroundColor;
    var checkboxColor = (0,react.useMemo)(function() {
        return checkColor && colors/* default */.Z[checkColor];
    }, [
        checkColor
    ]);
    var checkboxBorderColor = (0,react.useMemo)(function() {
        return isSelected && selectedBorderColor ? colors/* default */.Z[selectedBorderColor] : colors/* default */.Z[tagBorderColor];
    }, [
        isSelected,
        selectedBorderColor,
        tagBorderColor
    ]);
    var checkboxBackgroundColor = (0,react.useMemo)(function() {
        return isSelected && selectedBackgroundColor && colors/* default */.Z[selectedBackgroundColor];
    }, [
        selectedBackgroundColor,
        isSelected
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("checkbox", {
            "custom-check-color": checkColor
        }),
        style: {
            color: checkboxColor,
            borderColor: checkboxBorderColor,
            backgroundColor: checkboxBackgroundColor
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Check_default()), {})
    });
};
/* harmony default export */ var tag_checkbox = (TagCheckbox);

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
// EXTERNAL MODULE: ./segments/desktop/constants.js
var constants = __webpack_require__(73759);
// EXTERNAL MODULE: ./utils/general.js
var general = __webpack_require__(56093);
;// CONCATENATED MODULE: ./segments/desktop/core-components/square-tags/square-tag/square-tag-component.scss.js






var BORDER_COLOR = (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.LIGHT_WORK_OS_IRIS_COLOR_NAME], 0.5);
var StyledSquareTagComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1h5ozrm0"
})("display:flex;flex-direction:column;align-items:center;position:relative;justify-content:center;z-index:", z_index/* TOP_LAYER */.nA, ";cursor:pointer;.background-circle{transition:opacity 100ms ease-in-out;position:absolute;width:80px;height:80px;border-radius:50%;background-color:currentColor;opacity:0%;filter:blur(30px);z-index:", z_index/* ZERO */.xE, ";}.star-image{.star-picture{display:flex;.star-icon{height:40px;}}}.star-text{transition:opacity 100ms ease-in-out;text-align:center;font-size:0.875rem;color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";opacity:85%;padding-top:4px;padding-right:8px;padding-left:8px;}&:active{outline:none;}&.selected,&:hover{.background-circle{opacity:40%;}.star-text{opacity:100%;z-index:", z_index/* LAYER_ONE */.KW, ";}}&.selectable-cluster{justify-content:unset;border:1px solid rgba(255,255,255,0.3);border-radius:8px;margin:8px;padding:8px 8px 16px 8px;height:calc(100% - 16px);transition:border 0.1s ease-in-out;.checkbox{border:1px solid rgba(255,255,255,0.3);transition:all 0.05s ease-in-out;width:20px;height:20px;border-radius:4px;align-self:start;svg{path{fill:transparent;}}}&.selected,&:hover{transition:border 0.1s ease-in-out;border-color:currentColor;.background-circle{opacity:0;}.checkbox{border-color:currentColor;}}&.selected{.checkbox{background-color:currentColor;svg{path{fill:", colors/* default */.Z[color_consts.SPACE_BLUE_COLOR_NAME], ';}}}.checkbox.custom-check-color{svg{path{fill:currentColor;}}}}&.cluster-selected{animation:breatheIn 0.3s linear;}}&.light-theme::after{position:absolute;content:"";background:white;z-index:-1;top:0;bottom:0;left:0;right:0;border-radius:8px;', (0,constants.getComponentShadow)(), "}&.light-theme{border-color:transparent;&.show-border-in-light-theme{&::after{box-shadow:none;}&:not(.selected):not(.hovered){border-color:", colors/* default */.Z[color_consts.UI_BORDER_LIGHT_COLOR_NAME], ";.checkbox{border-color:", colors/* default */.Z[color_consts.UI_BORDER_LIGHT_COLOR_NAME], ";}}}// remove buggy drop-shadow filter behavior in safari in hover interaction and use border instead\n    @media not all and (min-resolution:0.001dpcm){@supports (-webkit-appearance:none){border-color:", BORDER_COLOR, ";&::after{filter:none;}}}.checkbox{border-color:", BORDER_COLOR, ";svg{path{fill:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";}}}.star-text{color:", colors/* default */.Z[color_consts.BRAND_BLACK_TEXT_COLOR], ";}&.selected{.checkbox{background-color:currentColor;svg{path{fill:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";}}}}}@keyframes breatheIn{0%{transform:scale(1);}15%{transform:scale(0.995);}20%{transform:scale(0.99);}25%{transform:scale(0.985);}32%{transform:scale(0.98);}50%{transform:scale(0.975);}68%{transform:scale(0.98);}75%{transform:scale(0.985);}80%{transform:scale(0.99);}85%{transform:scale(0.995);}100%{transform:scale(1);}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/square-tags/square-tag/square-tag-component.js
function square_tag_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            square_tag_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}













var SquareTagComponent = function(props) {
    var CLUSTER_CLICK_ANIMATION_TIME = 300;
    var ref = (0,react.useState)(false), isHovered = ref[0], setIsHovered = ref[1];
    var ref1 = (0,react.useState)(false), wasClusterSelected = ref1[0], setWasClusterSelected = ref1[1];
    var starText = props.starText, starImage = props.starImage, starColorName = props.starColorName, onStarClick = props.onStarClick, tagScheme = props.tagScheme, isSelected = props.isSelected, isDarkTheme = props.isDarkTheme, checkboxScheme = props.checkboxScheme, textScheme = props.textScheme, showBorderInLightTheme = props.showBorderInLightTheme, productType = props.productType;
    var blurTag = function(e) {
        var _e_target_closest, _e_target;
        e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : (_e_target_closest = _e_target.closest(".square-tag-component")) === null || _e_target_closest === void 0 ? void 0 : _e_target_closest.blur();
    };
    var getCurrentColor = (0,react.useCallback)(function(selectedColor, hoverColor, baseColor) {
        if (isSelected) return colors/* default */.Z[selectedColor];
        return isHovered ? colors/* default */.Z[hoverColor] : colors/* default */.Z[baseColor];
    }, [
        isHovered,
        isSelected
    ]);
    var tagBackgroundColor = (0,react.useMemo)(function() {
        return getCurrentColor(tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.selectedBackgroundColor, tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.hoverColor, null);
    }, [
        getCurrentColor,
        tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.hoverColor,
        tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.selectedBackgroundColor
    ]);
    var tagTextColor = (0,react.useMemo)(function() {
        return getCurrentColor(textScheme === null || textScheme === void 0 ? void 0 : textScheme.selectedColor, textScheme === null || textScheme === void 0 ? void 0 : textScheme.hoverColor, textScheme === null || textScheme === void 0 ? void 0 : textScheme.color);
    }, [
        getCurrentColor,
        textScheme === null || textScheme === void 0 ? void 0 : textScheme.selectedColor,
        textScheme === null || textScheme === void 0 ? void 0 : textScheme.hoverColor,
        textScheme === null || textScheme === void 0 ? void 0 : textScheme.color
    ]);
    var onClick = function(e) {
        blurTag(e);
        onTagSelection();
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.GRID_TAG_CLICKED, {
            kind: starText,
            info1: productType
        });
        (0,gtm_service/* fireGtmEvent */.k2)((data_layer_event_types_default()).TAG_SELECTED, {
            name: starText
        });
    };
    var onTagSelection = function() {
        setWasClusterSelected(true);
        setTimeout(function() {
            return setWasClusterSelected(false);
        }, CLUSTER_CLICK_ANIMATION_TIME);
        onStarClick && onStarClick();
    };
    var tagBorderColor = (0,react.useMemo)(function() {
        if ((tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.selectedBackgroundColor) && isSelected) return colors/* default */.Z[tagScheme.selectedBackgroundColor];
        return (tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.hoverColor) && isHovered ? colors/* default */.Z[tagScheme.hoverColor] : colors/* default */.Z[tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.borderColor];
    }, [
        isHovered,
        isSelected,
        tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.borderColor,
        tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.hoverColor,
        tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.selectedBackgroundColor
    ]);
    var onMouseOver = function() {
        setIsHovered(true);
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.GRID_TAG_HOVERED, {
            kind: starText
        });
    };
    var onMouseLeave = function() {
        return setIsHovered(false);
    };
    var starColor = colors/* default */.Z[tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.selectedBackgroundColor] || colors/* default */.Z[starColorName] || colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSquareTagComponent, {
        className: classnames_default()("square-tag-component", {
            selected: isSelected,
            hovered: isHovered,
            "selectable-cluster": true,
            "light-theme": !isDarkTheme,
            "cluster-selected": wasClusterSelected,
            "show-border-in-light-theme": showBorderInLightTheme
        }),
        style: {
            color: starColor,
            borderColor: tagBorderColor,
            backgroundColor: tagBackgroundColor
        },
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave,
        onClick: onClick,
        onKeyDown: (0,accessibility_service/* generateOnKeyDownHandler */.vR)(onTagSelection),
        tabIndex: 0,
        role: "checkbox",
        "aria-checked": isSelected,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "background-circle"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(tag_checkbox, _object_spread_props(_object_spread({}, checkboxScheme), {
                isSelected: isSelected,
                tagBorderColor: tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.borderColor
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "star-image",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                    className: "star-icon",
                    pictureClass: "star-picture",
                    src: starImage
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "star-text",
                style: {
                    color: tagTextColor
                },
                children: starText
            })
        ]
    });
};
/* harmony default export */ var square_tag_component = (SquareTagComponent);
SquareTagComponent.defaultProps = {
    starText: "Marketing",
    starImage: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/products/product-icons/icons_3d/Marketing_icon_circle.png",
    starColorName: "marketing-red"
};

// EXTERNAL MODULE: ./segments/desktop/core-components/square-tags/default-props.js
var default_props = __webpack_require__(62414);
;// CONCATENATED MODULE: ./segments/desktop/core-components/square-tags/square-tags.scss.js




var StyledSquareTags = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "estbk6w0"
})("margin:auto;display:flex;flex-direction:column;position:relative;align-items:center;justify-content:center;.clusters-stars{margin-top:48px;margin-bottom:56px;display:flex;.star-wrapper{width:140px;position:relative;user-select:none;max-width:170px;min-width:140px;}}.buttons-wrapper{display:flex;align-items:center;.signup-button-wrapper{transform:scale(1);button.signup-button{background-image:var(--background);color:var(--text-color);&:hover{background-image:var(--background-hover);}&:disabled{background-image:var(--background);color:var(--text-color);}}&.cluster-selected{animation:breatheOut 0.3s linear;}.sign-up-combo-with-text-underline{.sign-up-combo-wrapper{.signup-combo-buttons-button{justify-content:center;.secondary-button-wrapper{.secondary-button{.with-underline{background:unset;.secondary-button-text{padding-left:8px;}}}&:hover{.secondary-button{.with-underline{.secondary-button-text{transition:color 0.15 ease-in-out;color:", (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.WHITE_COLOR_NAME], 0.8), ";}svg path{transition:fill 0.15 ease-in-out;fill:", (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.WHITE_COLOR_NAME], 0.8), ";}}}}}}}.text-wrapper{margin-top:32px;font-size:0.8125rem;text-align:center;padding-left:3px;}}}}@keyframes breatheOut{0%{transform:scale(1);}15%{transform:scale(1.01);}20%{transform:scale(1.02);}25%{transform:scale(1.03);}32%{transform:scale(1.04);}50%{transform:scale(1.05);}68%{transform:scale(1.04);}75%{transform:scale(1.03);}80%{transform:scale(1.02);}85%{transform:scale(1.01);}100%{transform:scale(1);}}");

// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./node_modules/lodash/shuffle.js
var shuffle = __webpack_require__(69983);
var shuffle_default = /*#__PURE__*/__webpack_require__.n(shuffle);
;// CONCATENATED MODULE: ./segments/desktop/core-components/square-tags/square-tags.js

function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function square_tags_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}
function square_tags_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function square_tags_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        square_tags_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




















var DARK_THEME_BUTTON_OPACITY = "cc";
var LIGHT_THEME_BUTTON_OPACITY = "ee";
var SIGNUP_BUTTON_ANIMATION_START_TIME = 100;
var SIGNUP_BUTTON_ANIMATION_END_TIME = 400;
var PRESELECTED_TAG_PARAM_NAME = "selectedTag";
var getSelectedTagsInitialState = function(clusters) {
    var initialState = {};
    clusters.forEach(function(sc) {
        return initialState[sc.text] = false;
    });
    return initialState;
};
var SquareTags = function(props) {
    var buttonConfig = props.buttonConfig, clusters = props.clusters, theme = props.theme, secondaryButtonConfig = props.secondaryButtonConfig, tagsWidth = props.tagsWidth, marginTop = props.marginTop, palette = props.palette, showBorderInLightTheme = props.showBorderInLightTheme, randomizeTags = props.randomizeTags, productType = props.productType;
    var ref = (0,react.useState)(getSelectedTagsInitialState(clusters)), selectedTags = ref[0], setSelectedTags = ref[1];
    var ref1 = (0,react.useState)(false), wasClusterSelected = ref1[0], setWasClusterSelected = ref1[1];
    var getSelectedTagFromUrl = function() {
        var selectedTagId = (0,url.getUrlParamValueFromCurrentLocation)(PRESELECTED_TAG_PARAM_NAME);
        if (!selectedTagId) return;
        var selectedTag = clusters.find(function(cluster) {
            return cluster.clusterId === selectedTagId || cluster.useCaseId === selectedTagId;
        });
        return selectedTag;
    };
    var getSelectedTagsMarkedWithInitiallySelected = function() {
        var selectedClusters = clusters.reduce(function(acc, obj) {
            if (obj.initiallySelected) {
                acc[obj.text] = true;
            }
            return acc;
        }, {});
        return selectedClusters;
    };
    var renderedClusters = (0,react.useMemo)(function() {
        return randomizeTags ? shuffle_default()(clusters) : clusters;
    }, [
        clusters,
        randomizeTags
    ]);
    (0,react.useEffect)(function() {
        var selectedTagFromUrl = getSelectedTagFromUrl() || {};
        setSelectedTags(square_tags_object_spread_props(square_tags_object_spread({}, selectedTags, getSelectedTagsMarkedWithInitiallySelected()), (0,_define_property/* default */.Z)({}, selectedTagFromUrl.text, true)));
    }, []);
    var onTagComponentClick = function(star) {
        setSelectedTags(square_tags_object_spread_props(square_tags_object_spread({}, selectedTags), (0,_define_property/* default */.Z)({}, star.text, !selectedTags[star.text])));
        setTimeout(function() {
            return setWasClusterSelected(true);
        }, SIGNUP_BUTTON_ANIMATION_START_TIME);
        setTimeout(function() {
            return setWasClusterSelected(false);
        }, SIGNUP_BUTTON_ANIMATION_END_TIME);
    };
    var renderSquareTags = function() {
        return renderedClusters === null || renderedClusters === void 0 ? void 0 : renderedClusters.map(function(cluster) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "star-wrapper",
                style: {
                    width: tagsWidth
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(square_tag_component, {
                    starText: cluster.text,
                    starImage: cluster.image,
                    tagScheme: palette === null || palette === void 0 ? void 0 : palette.tagScheme,
                    checkboxScheme: palette === null || palette === void 0 ? void 0 : palette.checkboxScheme,
                    textScheme: palette === null || palette === void 0 ? void 0 : palette.textScheme,
                    starColorName: cluster.colorName,
                    onStarClick: function() {
                        return onTagComponentClick(cluster);
                    },
                    isSelected: selectedTags[cluster === null || cluster === void 0 ? void 0 : cluster.text],
                    isSelectableMode: true,
                    isDarkTheme: isDarkTheme,
                    showBorderInLightTheme: showBorderInLightTheme,
                    productType: productType
                })
            }, cluster.text);
        });
    };
    var getSelectedClusters = function() {
        return renderedClusters.filter(function(c) {
            return selectedTags[c.text];
        });
    };
    var isAtLeastOneClusterSelected = function() {
        return Object.values(selectedTags).map(function(star) {
            return star;
        }).reduce(function(acc, s) {
            return acc || s;
        }, false);
    };
    var getButtonColorBySelectedClusters = function(isDarkTheme, isHover) {
        var _buttonColor = buttonConfig.buttonColor, buttonColor = _buttonColor === void 0 ? color_consts.GRADIANT_WORKOS_IRIS_COLOR_NAME : _buttonColor, removeGradient = buttonConfig.removeGradient;
        if (removeGradient) return colors/* default */.Z[buttonColor];
        var OPACITY_VALUE = isDarkTheme ? DARK_THEME_BUTTON_OPACITY : LIGHT_THEME_BUTTON_OPACITY;
        var selectedClusters = getSelectedClusters();
        if (!isAtLeastOneClusterSelected || selectedClusters.length === 0) {
            return isHover ? (0,colors_utils/* getHoverColor */.n)(colors/* default */.Z[buttonColor]) : colors/* default */.Z[buttonColor];
        }
        // if only 1 cluster was selected, fill the button with a gradient built of the same color
        if (selectedClusters.length === 1) {
            var colorName = selectedClusters[0].colorName;
            var color = isHover ? (0,colors_utils/* getHoverColor */.n)(colors/* default */.Z[colorName]) : colors/* default */.Z[colorName];
            return "linear-gradient(90deg, ".concat(color).concat(OPACITY_VALUE, " 0%, ").concat(color).concat(OPACITY_VALUE, " 100%)");
        }
        var colorsString = "";
        var chunkSize = 100 / (selectedClusters.length - 1);
        // building the linear gradient string
        // for example, if 3 clusters are selected, the linear gradient stop locations should be 0%, 50% and 100%
        selectedClusters.forEach(function(selectedStarsItem, index) {
            // add separator in every chunk instead of last chunk
            var separator = index === selectedClusters.length - 1 ? "" : ", ";
            var starItemColor = isHover ? (0,colors_utils/* getHoverColor */.n)(colors/* default */.Z[selectedStarsItem.colorName]) : colors/* default */.Z[selectedStarsItem.colorName];
            colorsString += "".concat(starItemColor).concat(OPACITY_VALUE, " ").concat(chunkSize * index, "%").concat(separator);
        });
        return "linear-gradient(90deg, ".concat(colorsString, ")");
    };
    var getButtonTextColor = function() {
        var buttonColor = buttonConfig.buttonColor, removeGradient = buttonConfig.removeGradient;
        if (removeGradient) {
            return buttonColor === color_consts.WHITE_COLOR_NAME ? colors/* default */.Z[color_consts.BRAND_BLACK_BACKGROUND_COLOR] : colors/* default */.Z[color_consts.WHITE_COLOR_NAME];
        }
        var selectedClusters = getSelectedClusters();
        if (buttonColor === color_consts.WHITE_COLOR_NAME && selectedClusters.length === 0) {
            return colors/* default */.Z[color_consts.SPACE_BLUE_COLOR_NAME];
        }
        return colors/* default */.Z[color_consts.WHITE_COLOR_NAME];
    };
    var saveClustersOnSignup = function() {
        var selectedClusters = getSelectedClusters();
        var clustersToUpdate = selectedClusters.map(function(cluster) {
            var clusterId = cluster.clusterId, useCaseId = cluster.useCaseId;
            var res = [];
            if (clusterId) {
                res.push({
                    clusterId: clusterId,
                    clusterType: types.CLUSTER_TYPE
                });
            }
            if (useCaseId) {
                var extraData = clusterId ? {
                    parent_cluster_id: clusterId
                } : {};
                res.push({
                    clusterId: useCaseId,
                    clusterType: types.USE_CASE_TYPE,
                    extraData: extraData
                });
            }
            return res;
        });
        var flattenedArray = clustersToUpdate.flat();
        if (flattenedArray.length > 0) {
            // fire each cluster id as an event, so filtering can be fully customized on Hotjar side
            (0,hotjar_service/* fireHotjarEvents */.no)(flattenedArray.map(function(cluster) {
                return "tag_selected_".concat(cluster.clusterType, "_").concat(cluster.clusterId);
            }));
            (0,clusters_service/* updateUserClustersListWithMultipleClusters */.aC)(flattenedArray, constants_clusters.HP_TAGS_SELECTION);
        }
    };
    var isDarkTheme = (0,react.useMemo)(function() {
        return [
            segments_service/* SPACE_BLUE_GRADIANT_THEME_ID */.I7,
            segments_service/* BRAND_DARK_COLOR_THEME_ID */.qp
        ].includes(theme) || !(0,utils_service.isEmpty)(palette);
    }, [
        palette,
        theme
    ]);
    var additionalSignUpButtonConfig = {
        beforeSubmitCallback: saveClustersOnSignup,
        displayedOnDarkTheme: isDarkTheme
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSquareTags, {
        className: "square-tags",
        style: {
            "--background": getButtonColorBySelectedClusters(isDarkTheme),
            "--background-hover": getButtonColorBySelectedClusters(isDarkTheme, true),
            "--text-color": getButtonTextColor()
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "clusters-stars",
                role: "group",
                style: {
                    marginTop: marginTop
                },
                children: renderSquareTags()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "buttons-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("signup-button-wrapper", {
                            "cluster-selected": wasClusterSelected
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_button/* default */.Z, square_tags_object_spread({}, buttonConfig, additionalSignUpButtonConfig))
                    }),
                    secondaryButtonConfig && /*#__PURE__*/ (0,jsx_runtime.jsx)(secondary_button/* default */.Z, square_tags_object_spread({}, secondaryButtonConfig))
                ]
            })
        ]
    });
};
SquareTags.defaultProps = default_props/* default */.Z;
/* harmony default export */ var square_tags = ((0,generic_config_context/* withGenericConfig */.P)(SquareTags));


/***/ }),

/***/ 33054:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xN": function() { return /* binding */ CUSTOMERS_MENU_ID; },
  "Nl": function() { return /* binding */ DESKTOP_HEADER_BASE_CLASS_NAME; },
  "Qc": function() { return /* binding */ FEATURES_MENU_ID; },
  "Yp": function() { return /* binding */ ICON_TYPES; },
  "wP": function() { return /* binding */ PLATFORM_MENU_ID; },
  "VG": function() { return /* binding */ PRODUCTS_MENU_ID; },
  "Gu": function() { return /* binding */ RESOURCES_MENU_ID; },
  "e1": function() { return /* binding */ SOLUTIONS_MENU_ID; },
  "tS": function() { return /* binding */ SectionsHeadersMenuItemsMapping; },
  "jm": function() { return /* binding */ StructuredHeaderMenuComponentMapping; },
  "M2": function() { return /* binding */ StructuredHeaderMenuMapping; },
  "qq": function() { return /* binding */ TAG_TYPES; },
  "$Q": function() { return /* binding */ TEAMS_MENU_ID; },
  "sI": function() { return /* binding */ USE_CASES_MENU_ID; },
  "EH": function() { return /* binding */ isDesktopMinisiteSecondaryMenuActive; },
  "VK": function() { return /* binding */ mobileProductsSectionMenuItems; },
  "Y0": function() { return /* binding */ shouldRenderSecondaryMenu; }
});

// UNUSED EXPORTS: ADD_ONS_SECTION_ID, BY_BUSINESS_SIZE_SECTION_ID, BY_INDUSTRY_SECTION_ID, BY_TEAM_SECTION_ID, CRM_SECTION_ID, DEV_SECTION_ID, GET_INVOLVED_SECTION_ID, INTEGRATIONS_SECTION_ID, KEY_FEATURES_SECTION_ID, LEADING_COMPANIES_SECTION_ID, MENU_SECTION_CLASSNAMES, MENU_SECTION_ITEM_TYPE, PRODUCTS_MORE_SECTION_ID, PRODUCTS_PRODUCTS_SECTION_ID, RESOURCES_BUILD_SECTION_ID, RESOURCES_CONNECT_SECTION_ID, RESOURCES_EXPLORE_SECTION_ID, RESOURCES_LEARN_SECTION_ID, SERVICE_SECTION_ID, TOP_STORIES_SECTION_ID, WORK_MANAGEMENT_SECTION_ID

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./static/svg/header/workcanvas_colored.svg
var _g, _defs;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgWorkcanvasColored = function SvgWorkcanvasColored(props) {
    return /*#__PURE__*/ react.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20"
    }, props), _g || (_g = /*#__PURE__*/ react.createElement("g", {
        clipPath: "url(#clip0_10556_100)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M1.936 1.953h16.128v16.282H1.936z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#113357",
        fillRule: "evenodd",
        d: "M17.195 2.831H2.805v14.526h14.39zM1.936 1.953v16.282h16.128V1.953z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M15.484 0H20v4.559h-4.516z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#113357",
        fillRule: "evenodd",
        d: "M19.13.878h-2.776V3.68h2.776zM15.484 0v4.559H20V0z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M0 0h4.516v4.559H0z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#113357",
        fillRule: "evenodd",
        d: "M3.646.878H.87V3.68h2.776zM0 0v4.559h4.516V0z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M15.484 15.441H20V20h-4.516z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#113357",
        fillRule: "evenodd",
        d: "M19.13 16.319h-2.776v2.803h2.776zm-3.646-.878V20H20v-4.559z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M0 15.441h4.516V20H0z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#113357",
        fillRule: "evenodd",
        d: "M3.646 16.319H.87v2.803h2.776zM0 15.44V20h4.516v-4.559z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#113357",
        d: "M10.208 14.694q-1.111 0-1.94-.363a4 4 0 0 1-1.362-1.011 4.2 4.2 0 0 1-.814-1.422 5.3 5.3 0 0 1-.266-1.66v-.3q0-.885.282-1.69a4.4 4.4 0 0 1 .83-1.454 3.85 3.85 0 0 1 1.36-.995q.83-.363 1.895-.363 1.158 0 2.05.458.893.442 1.424 1.248.532.805.595 1.849h-2.457a1.55 1.55 0 0 0-.47-.98q-.391-.41-1.142-.41-.626 0-1.05.315-.405.315-.61.87-.203.552-.203 1.31 0 .695.188 1.265a1.8 1.8 0 0 0 .595.869q.422.3 1.095.3.501 0 .845-.174.36-.19.564-.506a1.7 1.7 0 0 0 .266-.758h2.442q-.048 1.074-.595 1.896a3.8 3.8 0 0 1-1.456 1.264q-.908.442-2.066.442"
    }))), _defs || (_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("clipPath", {
        id: "clip0_10556_100"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M0 0h20v20H0z"
    })))));
};
/* harmony default export */ var workcanvas_colored = (SvgWorkcanvasColored);

;// CONCATENATED MODULE: ./static/svg/header/workforms_colored.svg
var _path, _path2, workforms_colored_defs;
function workforms_colored_extends() {
    workforms_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return workforms_colored_extends.apply(this, arguments);
}

var SvgWorkformsColored = function SvgWorkformsColored(props) {
    return /*#__PURE__*/ react.createElement("svg", workforms_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 15,
        height: 20,
        fill: "none",
        viewBox: "0 0 15 20"
    }, props), _path || (_path = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint0_linear_642_352343)",
        fillRule: "evenodd",
        d: "M2.885 0a2.885 2.885 0 0 0 0 5.77h9.23a2.885 2.885 0 0 0 0-5.77zm0 6.92a2.885 2.885 0 0 0 0 5.77h5.192a2.885 2.885 0 0 0 0-5.77z",
        clipRule: "evenodd"
    })), _path2 || (_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint1_linear_642_352343)",
        fillRule: "evenodd",
        d: "M5.77 2.885a2.885 2.885 0 1 1-5.77 0 2.885 2.885 0 0 1 5.77 0m0 6.92a2.885 2.885 0 1 1-5.77 0 2.885 2.885 0 0 1 5.77 0m-2.885 9.81a2.885 2.885 0 1 0 0-5.77 2.885 2.885 0 0 0 0 5.77",
        clipRule: "evenodd"
    })), workforms_colored_defs || (workforms_colored_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint0_linear_642_352343",
        x1: -5.192,
        x2: 1.082,
        y1: -4.326,
        y2: 18.73,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        stopColor: "#DE0B76"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#F58A25",
        stopOpacity: 0
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint1_linear_642_352343",
        x1: 2.308,
        x2: 16.418,
        y1: -1.154,
        y2: 21.548,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        stopColor: "#C21E71"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#DE5948",
        stopOpacity: 0.457
    })))));
};
/* harmony default export */ var workforms_colored = (SvgWorkformsColored);

;// CONCATENATED MODULE: ./static/svg/header/marketing_colored.svg
var marketing_colored_path, marketing_colored_path2;
function marketing_colored_extends() {
    marketing_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return marketing_colored_extends.apply(this, arguments);
}

var SvgMarketingColored = function SvgMarketingColored(props) {
    return /*#__PURE__*/ react.createElement("svg", marketing_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 28,
        height: 28,
        fill: "none",
        viewBox: "0 0 28 28"
    }, props), marketing_colored_path || (marketing_colored_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeWidth: 2.5,
        d: "M1.25-1.25h2.707",
        transform: "matrix(.34684 .93793 -.95008 .312 10.22 17.544)"
    })), marketing_colored_path2 || (marketing_colored_path2 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinejoin: "round",
        strokeWidth: 2.5,
        d: "M7.942 17.543 7 14.435 18.306 6l3.062 10.729z"
    })));
};
/* harmony default export */ var marketing_colored = (SvgMarketingColored);

;// CONCATENATED MODULE: ./static/svg/header/dev_colored.svg
var dev_colored_path;
function dev_colored_extends() {
    dev_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return dev_colored_extends.apply(this, arguments);
}

var SvgDevColored = function SvgDevColored(props) {
    return /*#__PURE__*/ react.createElement("svg", dev_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 28,
        height: 28,
        fill: "none",
        viewBox: "0 0 28 28"
    }, props), dev_colored_path || (dev_colored_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeWidth: 2.175,
        d: "m10.835 8.999-4.834 4.826M10.897 18.688l-4.834-4.826M16.914 8.999l4.833 4.826M16.851 18.688l4.834-4.826"
    })));
};
/* harmony default export */ var dev_colored = (SvgDevColored);

;// CONCATENATED MODULE: ./static/svg/header/it_colored_1.svg
var it_colored_1_path;
function it_colored_1_extends() {
    it_colored_1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return it_colored_1_extends.apply(this, arguments);
}

var SvgItColored1 = function SvgItColored1(props) {
    return /*#__PURE__*/ react.createElement("svg", it_colored_1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 28,
        height: 28,
        fill: "none",
        viewBox: "0 0 28 28"
    }, props), it_colored_1_path || (it_colored_1_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M6 19h15M21 10H6M19 8v4M10 17v4"
    })));
};
/* harmony default export */ var it_colored_1 = (SvgItColored1);

;// CONCATENATED MODULE: ./static/svg/header/operations_colored.svg
var _circle, _circle2;
function operations_colored_extends() {
    operations_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return operations_colored_extends.apply(this, arguments);
}

var SvgOperationsColored = function SvgOperationsColored(props) {
    return /*#__PURE__*/ react.createElement("svg", operations_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 28,
        height: 28,
        fill: "none",
        viewBox: "0 0 28 28"
    }, props), _circle || (_circle = /*#__PURE__*/ react.createElement("circle", {
        cx: 14,
        cy: 15,
        r: 6,
        stroke: "#000",
        strokeWidth: 2
    })), _circle2 || (_circle2 = /*#__PURE__*/ react.createElement("circle", {
        cx: 14,
        cy: 15,
        r: 2.1,
        stroke: "#000",
        strokeWidth: 1.8
    })));
};
/* harmony default export */ var operations_colored = (SvgOperationsColored);

;// CONCATENATED MODULE: ./static/svg/header/pmo_colored.svg
var pmo_colored_path;
function pmo_colored_extends() {
    pmo_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return pmo_colored_extends.apply(this, arguments);
}

var SvgPmoColored = function SvgPmoColored(props) {
    return /*#__PURE__*/ react.createElement("svg", pmo_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 28,
        height: 28,
        fill: "none",
        viewBox: "0 0 28 28"
    }, props), pmo_colored_path || (pmo_colored_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeWidth: 2.5,
        d: "M7.434 7.401h8.922M11.444 14.302h8.923M7.25 21.203h8.923"
    })));
};
/* harmony default export */ var pmo_colored = (SvgPmoColored);

;// CONCATENATED MODULE: ./static/svg/header/sales_colored_1.svg
var sales_colored_1_path;
function sales_colored_1_extends() {
    sales_colored_1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return sales_colored_1_extends.apply(this, arguments);
}

var SvgSalesColored1 = function SvgSalesColored1(props) {
    return /*#__PURE__*/ react.createElement("svg", sales_colored_1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 28,
        height: 28,
        fill: "none",
        viewBox: "0 0 28 28"
    }, props), sales_colored_1_path || (sales_colored_1_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2.5,
        d: "M5 20.5 9.5 15l5 3 6-10m0 0L15 9.5M20.5 8l1.5 5"
    })));
};
/* harmony default export */ var sales_colored_1 = (SvgSalesColored1);

;// CONCATENATED MODULE: ./static/svg/header/hr_colored_1.svg
var hr_colored_1_path;
function hr_colored_1_extends() {
    hr_colored_1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return hr_colored_1_extends.apply(this, arguments);
}

var SvgHrColored1 = function SvgHrColored1(props) {
    return /*#__PURE__*/ react.createElement("svg", hr_colored_1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 28,
        height: 28,
        fill: "none",
        viewBox: "0 0 28 28"
    }, props), hr_colored_1_path || (hr_colored_1_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2.5,
        d: "M18 22v-9M10 22v-9M18 8V7M10 8V7"
    })));
};
/* harmony default export */ var hr_colored_1 = (SvgHrColored1);

;// CONCATENATED MODULE: ./static/svg/header/enterprise_colored_1.svg
var enterprise_colored_1_path;
function enterprise_colored_1_extends() {
    enterprise_colored_1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return enterprise_colored_1_extends.apply(this, arguments);
}

var SvgEnterpriseColored1 = function SvgEnterpriseColored1(props) {
    return /*#__PURE__*/ react.createElement("svg", enterprise_colored_1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 28,
        height: 28,
        fill: "none",
        viewBox: "0 0 28 28"
    }, props), enterprise_colored_1_path || (enterprise_colored_1_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeMiterlimit: 10,
        strokeWidth: 1.5,
        d: "M2.857 25.143h22.286M18.434 6.733h-8.72v18.41h8.72zM23.019 15.453h-3.876v9.69h3.876zM9.304 15.453H5.43v9.69h3.875zM15.714 3.714h-3.428v2.572h3.428zM14 3.714V2M14.857 10.571h-1.714M14.857 14h-1.714M14.857 17.429h-1.714"
    })));
};
/* harmony default export */ var enterprise_colored_1 = (SvgEnterpriseColored1);

;// CONCATENATED MODULE: ./static/svg/header/retail_colored.svg
var retail_colored_g, retail_colored_defs;
function retail_colored_extends() {
    retail_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return retail_colored_extends.apply(this, arguments);
}

var SvgRetailColored = function SvgRetailColored(props) {
    return /*#__PURE__*/ react.createElement("svg", retail_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20"
    }, props), retail_colored_g || (retail_colored_g = /*#__PURE__*/ react.createElement("g", {
        stroke: "#6161FF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        clipPath: "url(#clip0_878_1279)"
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M2.143 12.143v6.429a.715.715 0 0 0 .714.714h14.286a.715.715 0 0 0 .714-.715v-6.428M11.428 12.143v7.143M2.143 14.286h9.285M.714 5.714l2.143-5h14.286l2.143 5zM6.828 5.714v1.429A2.857 2.857 0 0 1 3.971 10h-.4A2.857 2.857 0 0 1 .714 7.143V5.714"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M13.214 5.714v1.429A2.857 2.857 0 0 1 10.357 10h-.715a2.857 2.857 0 0 1-2.857-2.857V5.714M19.286 5.714v1.429A2.857 2.857 0 0 1 16.428 10h-.357a2.857 2.857 0 0 1-2.857-2.857V5.714"
    }))), retail_colored_defs || (retail_colored_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("clipPath", {
        id: "clip0_878_1279"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M0 0h20v20H0z"
    })))));
};
/* harmony default export */ var retail_colored = (SvgRetailColored);

;// CONCATENATED MODULE: ./static/svg/header/construction_colored.svg
var construction_colored_path;
function construction_colored_extends() {
    construction_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return construction_colored_extends.apply(this, arguments);
}

var SvgConstructionColored = function SvgConstructionColored(props) {
    return /*#__PURE__*/ react.createElement("svg", construction_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "none",
        viewBox: "0 0 22 22"
    }, props), construction_colored_path || (construction_colored_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#6161FF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeMiterlimit: 10,
        strokeWidth: 1.5,
        d: "M18.394 21c-1.091-3.152-4.121-5.455-7.636-5.455C7.242 15.545 4.09 17.848 3 21M10.636 4.636V1M3.97 8.152h13.333M5.667 9.485c.12 2.667 2.303 4.848 4.97 4.848 2.787 0 4.969-2.181 4.969-4.97V7.183c0-2.788-2.182-4.97-4.97-4.97-2.666 0-4.848 2.182-4.97 4.849z"
    })));
};
/* harmony default export */ var construction_colored = (SvgConstructionColored);

;// CONCATENATED MODULE: ./static/svg/header/media_colored.svg
var media_colored_g, media_colored_defs;
function media_colored_extends() {
    media_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return media_colored_extends.apply(this, arguments);
}

var SvgMediaColored = function SvgMediaColored(props) {
    return /*#__PURE__*/ react.createElement("svg", media_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20"
    }, props), media_colored_g || (media_colored_g = /*#__PURE__*/ react.createElement("g", {
        stroke: "#6161FF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        clipPath: "url(#clip0_878_1292)"
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M5 9.286A4.286 4.286 0 1 0 5 .714a4.286 4.286 0 0 0 0 8.572M15 9.286a2.857 2.857 0 1 0 0-5.714 2.857 2.857 0 0 0 0 5.714M14.286 12.857H6.429c-.79 0-1.429.64-1.429 1.429v3.571c0 .79.64 1.429 1.429 1.429h7.857c.789 0 1.428-.64 1.428-1.429v-3.571c0-.79-.64-1.429-1.428-1.429M19.286 14.286v3.571"
    }))), media_colored_defs || (media_colored_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("clipPath", {
        id: "clip0_878_1292"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M0 0h20v20H0z"
    })))));
};
/* harmony default export */ var media_colored = (SvgMediaColored);

;// CONCATENATED MODULE: ./static/svg/header/small_business_colored_1.svg
var small_business_colored_1_path, small_business_colored_1_path2;
function small_business_colored_1_extends() {
    small_business_colored_1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return small_business_colored_1_extends.apply(this, arguments);
}

var SvgSmallBusinessColored1 = function SvgSmallBusinessColored1(props) {
    return /*#__PURE__*/ react.createElement("svg", small_business_colored_1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 28,
        height: 28,
        fill: "none",
        viewBox: "0 0 28 28"
    }, props), small_business_colored_1_path || (small_business_colored_1_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeMiterlimit: 10,
        strokeWidth: 1.5,
        d: "M22 6H7v16h15zM13 11h3"
    })), small_business_colored_1_path2 || (small_business_colored_1_path2 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "M12 22v-7h5v7"
    })));
};
/* harmony default export */ var small_business_colored_1 = (SvgSmallBusinessColored1);

;// CONCATENATED MODULE: ./static/svg/header/nonprofit_colored.svg
var nonprofit_colored_path;
function nonprofit_colored_extends() {
    nonprofit_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return nonprofit_colored_extends.apply(this, arguments);
}

var SvgNonprofitColored = function SvgNonprofitColored(props) {
    return /*#__PURE__*/ react.createElement("svg", nonprofit_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 28,
        height: 28,
        fill: "none",
        viewBox: "0 0 28 28"
    }, props), nonprofit_colored_path || (nonprofit_colored_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.703,
        d: "m14.212 13.387-4.197-3.883c-2.288-2.298 1.05-6.748 4.197-3.148 3.149-3.589 6.518.86 4.198 3.148zM10.678 18.637c.516.258 2.28.774 3.097.774 1.806 0 2.394-.318 3.097-.516 1.032-.292 1.458-.997 1.568-1.324m0 0c.074-.223.125.276 0-.225-.517-2.064-2.6-.291-4.665-.55-2.065-.257-4.646-1.514-5.678-1.514S5 16.022 5 17.346c0 1 .774 2.065 2.065 3.064s3.87 1.806 6.452 1.806c3.145 0 4.645-1.066 5.935-1.806.448-.257 3.613-2.84 3.871-3.613.333-1-.234-1.311-.774-1.515-.774-.292-1.419.5-2.064.999-1.29.999-1.29 1.066-2.045 1.29"
    })));
};
/* harmony default export */ var nonprofit_colored = (SvgNonprofitColored);

;// CONCATENATED MODULE: ./static/svg/header/docs_colored.svg
var docs_colored_path, docs_colored_path2, _path3;
function docs_colored_extends() {
    docs_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return docs_colored_extends.apply(this, arguments);
}

var SvgDocsColored = function SvgDocsColored(props) {
    return /*#__PURE__*/ react.createElement("svg", docs_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "none",
        viewBox: "0 0 22 22"
    }, props), docs_colored_path || (docs_colored_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        d: "M5 17.273V4a1 1 0 0 1 1-1h6.728a1 1 0 0 1 .753.342l3.272 3.74A1 1 0 0 1 17 7.74v9.533a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1Z"
    })), docs_colored_path2 || (docs_colored_path2 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        d: "M13.143 7.114V3.447c0-.157.194-.232.299-.115L16.742 7c.1.11.021.286-.127.286h-3.3a.17.17 0 0 1-.172-.172Z"
    })), _path3 || (_path3 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        d: "M7.857 9.962h4.104M7.682 13.409h5.545"
    })));
};
/* harmony default export */ var docs_colored = (SvgDocsColored);

;// CONCATENATED MODULE: ./static/svg/header/files_colored.svg
var _rect, files_colored_path, files_colored_path2;
function files_colored_extends() {
    files_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return files_colored_extends.apply(this, arguments);
}

var SvgFilesColored = function SvgFilesColored(props) {
    return /*#__PURE__*/ React.createElement("svg", files_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "none",
        viewBox: "0 0 22 22"
    }, props), _rect || (_rect = /*#__PURE__*/ React.createElement("rect", {
        width: 10.667,
        height: 11.833,
        x: 6.833,
        y: 3.5,
        stroke: "#000",
        rx: 0.667
    })), files_colored_path || (files_colored_path = /*#__PURE__*/ React.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        d: "M15.167 7h-6M15.167 10.5h-6"
    })), files_colored_path2 || (files_colored_path2 = /*#__PURE__*/ React.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeMiterlimit: 1.414,
        d: "M4 7.667v10.266c0 .129.104.233.233.233h7.934"
    })));
};
/* harmony default export */ var files_colored = ((/* unused pure expression or super */ null && (SvgFilesColored)));

;// CONCATENATED MODULE: ./static/svg/header/forms_icon_new.svg
var forms_icon_new_path, forms_icon_new_path2, forms_icon_new_path3, _path4, _path5, _path6, _path7, _path8, _path9;
function forms_icon_new_extends() {
    forms_icon_new_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return forms_icon_new_extends.apply(this, arguments);
}

var SvgFormsIconNew = function SvgFormsIconNew(props) {
    return /*#__PURE__*/ react.createElement("svg", forms_icon_new_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "none",
        viewBox: "0 0 22 22"
    }, props), forms_icon_new_path || (forms_icon_new_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#6C6CFF",
        stroke: "#6C6CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 0.5,
        d: "M5 6.405a.405.405 0 1 0 .81 0 .405.405 0 0 0-.81 0"
    })), forms_icon_new_path2 || (forms_icon_new_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "#6C6CFF",
        d: "M8.218 6.405H18Z"
    })), forms_icon_new_path3 || (forms_icon_new_path3 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#6C6CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 0.5,
        d: "M8.218 6.405H18"
    })), _path4 || (_path4 = /*#__PURE__*/ react.createElement("path", {
        fill: "#6C6CFF",
        stroke: "#6C6CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 0.5,
        d: "M5 10.804a.405.405 0 1 0 .81 0 .405.405 0 0 0-.81 0"
    })), _path5 || (_path5 = /*#__PURE__*/ react.createElement("path", {
        fill: "#6C6CFF",
        d: "M8.218 10.804H18Z"
    })), _path6 || (_path6 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#6C6CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 0.5,
        d: "M8.218 10.804H18"
    })), _path7 || (_path7 = /*#__PURE__*/ react.createElement("path", {
        fill: "#6C6CFF",
        stroke: "#6C6CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 0.5,
        d: "M5 15.203a.405.405 0 1 0 .81 0 .405.405 0 0 0-.81 0"
    })), _path8 || (_path8 = /*#__PURE__*/ react.createElement("path", {
        fill: "#6C6CFF",
        d: "M8.218 15.203H18Z"
    })), _path9 || (_path9 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#6C6CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 0.5,
        d: "M8.218 15.203H18"
    })));
};
/* harmony default export */ var forms_icon_new = (SvgFormsIconNew);

;// CONCATENATED MODULE: ./static/svg/header/gantt_colored.svg
var gantt_colored_path;
function gantt_colored_extends() {
    gantt_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return gantt_colored_extends.apply(this, arguments);
}

var SvgGanttColored = function SvgGanttColored(props) {
    return /*#__PURE__*/ react.createElement("svg", gantt_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "none",
        viewBox: "0 0 22 22"
    }, props), gantt_colored_path || (gantt_colored_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 6H2M14 11H6M19.242 16H12"
    })));
};
/* harmony default export */ var gantt_colored = (SvgGanttColored);

;// CONCATENATED MODULE: ./static/svg/header/ai-icon.svg
var ai_icon_path, ai_icon_path2;
function ai_icon_extends() {
    ai_icon_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return ai_icon_extends.apply(this, arguments);
}

var SvgAiIcon = function SvgAiIcon(props) {
    return /*#__PURE__*/ react.createElement("svg", ai_icon_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "none",
        viewBox: "0 0 22 22"
    }, props), ai_icon_path || (ai_icon_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#6161FF",
        d: "M8.797 6.616a.213.213 0 0 1 .406 0l1.496 4.55a.21.21 0 0 0 .136.135l4.549 1.496a.213.213 0 0 1 0 .406l-4.55 1.496a.21.21 0 0 0-.135.136l-1.496 4.549a.213.213 0 0 1-.406 0l-1.496-4.55a.21.21 0 0 0-.136-.135l-4.549-1.496a.213.213 0 0 1 0-.406l4.55-1.496a.21.21 0 0 0 .135-.136z"
    })), ai_icon_path2 || (ai_icon_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "#6161FF",
        d: "M16.297 2.616a.213.213 0 0 1 .406 0l.63 1.915a.21.21 0 0 0 .136.136l1.915.63a.213.213 0 0 1 0 .406l-1.915.63a.21.21 0 0 0-.137.136l-.63 1.915a.213.213 0 0 1-.405 0l-.63-1.915a.21.21 0 0 0-.136-.136l-1.915-.63a.213.213 0 0 1 0-.406l1.915-.63a.21.21 0 0 0 .136-.136z"
    })));
};
/* harmony default export */ var ai_icon = (SvgAiIcon);

;// CONCATENATED MODULE: ./static/svg/header/kanban_colored.svg
var kanban_colored_path, kanban_colored_rect;
function kanban_colored_extends() {
    kanban_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return kanban_colored_extends.apply(this, arguments);
}

var SvgKanbanColored = function SvgKanbanColored(props) {
    return /*#__PURE__*/ react.createElement("svg", kanban_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "none",
        viewBox: "0 0 22 22"
    }, props), kanban_colored_path || (kanban_colored_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinejoin: "round",
        d: "M4 3.5h4.5V14a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5V4a.5.5 0 0 1 .5-.5ZM13.5 3.5H18a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5z"
    })), kanban_colored_rect || (kanban_colored_rect = /*#__PURE__*/ react.createElement("rect", {
        width: 5,
        height: 15,
        x: 8.5,
        y: 3.5,
        stroke: "#000",
        strokeLinejoin: "round",
        rx: 0.5
    })));
};
/* harmony default export */ var kanban_colored = (SvgKanbanColored);

;// CONCATENATED MODULE: ./static/svg/header/automations_colored.svg
var automations_colored_rect, automations_colored_path, automations_colored_path2, automations_colored_path3;
function automations_colored_extends() {
    automations_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return automations_colored_extends.apply(this, arguments);
}

var SvgAutomationsColored = function SvgAutomationsColored(props) {
    return /*#__PURE__*/ react.createElement("svg", automations_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "none",
        viewBox: "0 0 22 22"
    }, props), automations_colored_rect || (automations_colored_rect = /*#__PURE__*/ react.createElement("rect", {
        width: 12.047,
        height: 10.951,
        x: 5.183,
        y: 6.287,
        stroke: "#000",
        rx: 2.259
    })), automations_colored_path || (automations_colored_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        d: "M8.974 10.072v2.285M13.35 10.072v2.285"
    })), automations_colored_path2 || (automations_colored_path2 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3 10.701c0-.624.506-1.13 1.13-1.13h1.06v4.381H4.13A1.13 1.13 0 0 1 3 12.823zM17.234 9.572h1.061c.624 0 1.13.505 1.13 1.13v2.121a1.13 1.13 0 0 1-1.13 1.13h-1.06z"
    })), automations_colored_path3 || (automations_colored_path3 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        d: "M11.162 3.5v2.285"
    })));
};
/* harmony default export */ var automations_colored = (SvgAutomationsColored);

;// CONCATENATED MODULE: ./static/svg/header/integrations_colored.svg
var integrations_colored_path, integrations_colored_path2, integrations_colored_path3;
function integrations_colored_extends() {
    integrations_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return integrations_colored_extends.apply(this, arguments);
}

var SvgIntegrationsColored = function SvgIntegrationsColored(props) {
    return /*#__PURE__*/ react.createElement("svg", integrations_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "none",
        viewBox: "0 0 22 22"
    }, props), integrations_colored_path || (integrations_colored_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        d: "m3.5 8.735 3.036 3.036M7.738 4.5l3.036 3.036M14.393 14.981l2.753 2.754"
    })), integrations_colored_path2 || (integrations_colored_path2 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        d: "m5.745 12.735 6.78-6.78 3.67 3.671c.89.89.89 2.333 0 3.223l-3.556 3.556a2.28 2.28 0 0 1-3.223 0z"
    })), integrations_colored_path3 || (integrations_colored_path3 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        d: "m4.031 14.342 9.5-9.328"
    })));
};
/* harmony default export */ var integrations_colored = (SvgIntegrationsColored);

;// CONCATENATED MODULE: ./static/svg/header/dashboards_colored.svg
var dashboards_colored_rect, dashboards_colored_path;
function dashboards_colored_extends() {
    dashboards_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return dashboards_colored_extends.apply(this, arguments);
}

var SvgDashboardsColored = function SvgDashboardsColored(props) {
    return /*#__PURE__*/ react.createElement("svg", dashboards_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "none",
        viewBox: "0 0 22 22"
    }, props), dashboards_colored_rect || (dashboards_colored_rect = /*#__PURE__*/ react.createElement("rect", {
        width: 14,
        height: 14,
        x: 3.5,
        y: 3.5,
        stroke: "#000",
        rx: 1.375
    })), dashboards_colored_path || (dashboards_colored_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        d: "M7.183 14.687V11M10.936 14.687V8.188M14.69 14.687V6.312"
    })));
};
/* harmony default export */ var dashboards_colored = (SvgDashboardsColored);

;// CONCATENATED MODULE: ./static/svg/header/project_management_colored_2.svg
var project_management_colored_2_path, project_management_colored_2_path2, project_management_colored_2_rect;
function project_management_colored_2_extends() {
    project_management_colored_2_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return project_management_colored_2_extends.apply(this, arguments);
}

var SvgProjectManagementColored2 = function SvgProjectManagementColored2(props) {
    return /*#__PURE__*/ react.createElement("svg", project_management_colored_2_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 28,
        height: 28,
        fill: "none",
        viewBox: "0 0 28 28"
    }, props), project_management_colored_2_path || (project_management_colored_2_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "M11.403 17.439H8.258A1.265 1.265 0 0 1 7 16.176V6.628a1.256 1.256 0 0 1 1.258-1.262h11.32c.335 0 .654.132.89.369s.369.558.369.893V9.21M7.33 9.184h10.377"
    })), project_management_colored_2_path2 || (project_management_colored_2_path2 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeWidth: 1.5,
        d: "M10.657 4.809v1.358M17.982 4.75v1.358"
    })), project_management_colored_2_rect || (project_management_colored_2_rect = /*#__PURE__*/ react.createElement("rect", {
        width: 6,
        height: 6,
        x: 15,
        y: 14,
        stroke: "#000",
        strokeWidth: 1.5,
        rx: 0.804
    })));
};
/* harmony default export */ var project_management_colored_2 = (SvgProjectManagementColored2);

;// CONCATENATED MODULE: ./static/svg/header/monday_work_management_square.svg
var monday_work_management_square_path, monday_work_management_square_path2, monday_work_management_square_path3, monday_work_management_square_defs;
function monday_work_management_square_extends() {
    monday_work_management_square_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return monday_work_management_square_extends.apply(this, arguments);
}

var SvgMondayWorkManagementSquare = function SvgMondayWorkManagementSquare(props) {
    return /*#__PURE__*/ react.createElement("svg", monday_work_management_square_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 72,
        height: 72,
        fill: "none",
        viewBox: "0 0 72 72"
    }, props), monday_work_management_square_path || (monday_work_management_square_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#6C6CFF",
        d: "M16.367 52.545c-2.709-1.847-3.367-5.482-1.47-8.12l16.007-22.259c1.172-1.63 3.045-2.497 4.945-2.486 1.896-.008 3.766.86 4.936 2.486l16.012 22.266c1.896 2.637 1.238 6.272-1.47 8.119-2.71 1.846-6.442 1.205-8.339-1.432L35.844 35.623l-11.139 15.49c-1.896 2.637-5.63 3.278-8.338 1.432"
    })), monday_work_management_square_path2 || (monday_work_management_square_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint0_linear_2108_574604)",
        d: "M16.372 18.724c-2.709 1.847-3.367 5.482-1.47 8.119l16 22.25c1.168 1.624 3.032 2.49 4.925 2.486 1.904.015 3.783-.853 4.958-2.486l16-22.25c1.897-2.637 1.239-6.272-1.47-8.119s-6.442-1.206-8.338 1.432L35.843 35.637 24.71 20.156c-1.897-2.638-5.63-3.279-8.338-1.432"
    })), monday_work_management_square_path3 || (monday_work_management_square_path3 = /*#__PURE__*/ react.createElement("path", {
        fill: "#7E7EFF",
        d: "m28.532 25.47-7.31 10.163 7.31 10.164 7.31-10.164z"
    })), monday_work_management_square_defs || (monday_work_management_square_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint0_linear_2108_574604",
        x1: 39.285,
        x2: 37.456,
        y1: 34.624,
        y2: 52.175,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        stopColor: "#8F8FFF"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#BABAFD"
    })))));
};
/* harmony default export */ var monday_work_management_square = (SvgMondayWorkManagementSquare);

// EXTERNAL MODULE: ./static/svg/header/monday_crm_square.svg
var monday_crm_square = __webpack_require__(91276);
// EXTERNAL MODULE: ./static/svg/header/monday_marketer_square.svg
var monday_marketer_square = __webpack_require__(93216);
// EXTERNAL MODULE: ./static/svg/header/monday_projects_square.svg
var monday_projects_square = __webpack_require__(52165);
// EXTERNAL MODULE: ./static/svg/header/monday_dev_square.svg
var monday_dev_square = __webpack_require__(1828);
;// CONCATENATED MODULE: ./static/svg/header/wm_logo.svg
var wm_logo_path, wm_logo_path2, wm_logo_path3, wm_logo_path4, wm_logo_path5, wm_logo_path6, wm_logo_path7, wm_logo_defs;
function wm_logo_extends() {
    wm_logo_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return wm_logo_extends.apply(this, arguments);
}

var SvgWmLogo = function SvgWmLogo(props) {
    return /*#__PURE__*/ react.createElement("svg", wm_logo_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 25,
        height: 25,
        fill: "none",
        viewBox: "0 0 25 25"
    }, props), wm_logo_path || (wm_logo_path = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint0_linear_1860_128182)",
        d: "M15.436 2.592c0-1.421-1.097-2.573-2.45-2.573s-2.45 1.152-2.45 2.573v2.829c0 1.421 1.096 2.574 2.45 2.574 1.353 0 2.45-1.153 2.45-2.574z"
    })), wm_logo_path2 || (wm_logo_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint1_linear_1860_128182)",
        d: "M5.846 6.202c-1.288-.44-2.67.3-3.089 1.65-.418 1.352.287 2.803 1.575 3.243l2.562.874c1.288.439 2.67-.3 3.09-1.651.417-1.352-.288-2.803-1.575-3.242z"
    })), wm_logo_path3 || (wm_logo_path3 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint2_linear_1860_128182)",
        d: "M6.148 16.894c-.796 1.15-.553 2.759.541 3.594s2.628.58 3.424-.57l1.584-2.289c.796-1.15.553-2.759-.542-3.594-1.094-.835-2.627-.58-3.423.57z"
    })), wm_logo_path4 || (wm_logo_path4 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint3_linear_1860_128182)",
        d: "M15.93 19.889c.796 1.15 2.329 1.405 3.424.57s1.337-2.444.54-3.594l-1.583-2.289c-.796-1.15-2.328-1.405-3.423-.57s-1.338 2.444-.542 3.594z"
    })), wm_logo_path5 || (wm_logo_path5 = /*#__PURE__*/ react.createElement("path", {
        fill: "#6161FF",
        d: "M13.01 13.86c1.342 0 2.43-1.143 2.43-2.553s-1.088-2.552-2.43-2.552-2.432 1.142-2.432 2.552 1.089 2.553 2.432 2.553M5.077 11.206c1.35 0 2.445-1.15 2.445-2.566 0-1.418-1.094-2.567-2.445-2.567S2.633 7.223 2.633 8.64s1.094 2.566 2.444 2.566M12.986 5.142c1.353 0 2.449-1.151 2.449-2.571S14.339 0 12.986 0s-2.449 1.151-2.449 2.57c0 1.42 1.096 2.572 2.45 2.572M8.129 20.986c1.355 0 2.453-1.153 2.453-2.576 0-1.422-1.098-2.575-2.453-2.575s-2.453 1.153-2.453 2.575 1.098 2.576 2.453 2.576M17.92 20.959c1.352 0 2.448-1.15 2.448-2.57s-1.095-2.57-2.447-2.57-2.448 1.15-2.448 2.57 1.096 2.57 2.448 2.57"
    })), wm_logo_path6 || (wm_logo_path6 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint4_linear_1860_128182)",
        d: "M20.154 6.201c1.288-.439 2.67.3 3.089 1.651.418 1.352-.287 2.803-1.575 3.242l-2.562.874c-1.288.44-2.671-.3-3.09-1.65-.417-1.352.288-2.803 1.575-3.243z"
    })), wm_logo_path7 || (wm_logo_path7 = /*#__PURE__*/ react.createElement("path", {
        fill: "#6161FF",
        d: "M20.923 11.206c-1.35 0-2.445-1.15-2.445-2.567s1.095-2.566 2.445-2.566 2.444 1.149 2.444 2.566c0 1.418-1.094 2.567-2.444 2.567"
    })), wm_logo_defs || (wm_logo_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint0_linear_1860_128182",
        x1: 12.97,
        x2: 13.029,
        y1: -4.924,
        y2: 8.508,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.411,
        stopColor: "#6C6CFF",
        stopOpacity: 0.9
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#6C6CFF",
        stopOpacity: 0.1
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint1_linear_1860_128182",
        x1: -1.726,
        x2: 10.566,
        y1: 6.341,
        y2: 10.092,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.411,
        stopColor: "#6C6CFF",
        stopOpacity: 0.9
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#6C6CFF",
        stopOpacity: 0.1
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint2_linear_1860_128182",
        x1: 3.935,
        x2: 11.898,
        y1: 24.497,
        y2: 13.963,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.411,
        stopColor: "#6C6CFF",
        stopOpacity: 0.9
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#6C6CFF",
        stopOpacity: 0.1
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint3_linear_1860_128182",
        x1: 22.134,
        x2: 14.085,
        y1: 24.448,
        y2: 13.987,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.411,
        stopColor: "#6C6CFF",
        stopOpacity: 0.9
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#6C6CFF",
        stopOpacity: 0.1
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint4_linear_1860_128182",
        x1: 27.726,
        x2: 15.434,
        y1: 6.341,
        y2: 10.091,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.411,
        stopColor: "#6C6CFF",
        stopOpacity: 0.9
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#6C6CFF",
        stopOpacity: 0.1
    })))));
};
/* harmony default export */ var wm_logo = (SvgWmLogo);

;// CONCATENATED MODULE: ./static/svg/header/mobile_crm_logo.svg
var mobile_crm_logo_path, _ellipse, _ellipse2, mobile_crm_logo_path2, mobile_crm_logo_defs;
function mobile_crm_logo_extends() {
    mobile_crm_logo_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return mobile_crm_logo_extends.apply(this, arguments);
}

var SvgMobileCrmLogo = function SvgMobileCrmLogo(props) {
    return /*#__PURE__*/ react.createElement("svg", mobile_crm_logo_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 25,
        height: 25,
        fill: "none",
        viewBox: "0 0 25 25"
    }, props), mobile_crm_logo_path || (mobile_crm_logo_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#00A0A0",
        d: "M16.646 12.818a.563.563 0 0 1-.572.595H8.926a.563.563 0 0 0-.572.595 8.46 8.46 0 0 0 1.87 4.743 8.32 8.32 0 0 0 4.817 2.914 8.26 8.26 0 0 0 5.554-.832 8.4 8.4 0 0 0 3.77-4.2c.739-1.798.836-3.8.276-5.662a8.4 8.4 0 0 0-3.345-4.553 8.27 8.27 0 0 0-7.124-1.032 8.3 8.3 0 0 0-1.691.747 8.4 8.4 0 0 1 3.079 3.131l.002-.036.017.03a8.5 8.5 0 0 1 1.067 3.56"
    })), _ellipse || (_ellipse = /*#__PURE__*/ react.createElement("ellipse", {
        cx: 8.333,
        cy: 13.414,
        fill: "#fff",
        rx: 8.333,
        ry: 8.413
    })), _ellipse2 || (_ellipse2 = /*#__PURE__*/ react.createElement("ellipse", {
        cx: 8.333,
        cy: 13.414,
        fill: "url(#paint0_linear_1_20)",
        rx: 8.333,
        ry: 8.413
    })), mobile_crm_logo_path2 || (mobile_crm_logo_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint1_linear_1_20)",
        d: "M12.502 20.7a8.43 8.43 0 0 0 4.165-7.287c.007-.34-.021-.595-.021-.595a.57.57 0 0 1-.572.595H8.926a.563.563 0 0 0-.572.595 8.46 8.46 0 0 0 1.87 4.743 8.4 8.4 0 0 0 2.278 1.95"
    })), mobile_crm_logo_defs || (mobile_crm_logo_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint0_linear_1_20",
        x1: 2.538,
        x2: 16.723,
        y1: 8.363,
        y2: 15.544,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        stopColor: "#00D2D2"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#00D2D2",
        stopOpacity: 0.29
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint1_linear_1_20",
        x1: 17.571,
        x2: 4.308,
        y1: 17.755,
        y2: 15.018,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        stopColor: "#00A0A0"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#00D2D2"
    })))));
};
/* harmony default export */ var mobile_crm_logo = (SvgMobileCrmLogo);

;// CONCATENATED MODULE: ./static/svg/header/mobile_marketer_logo.svg
var mobile_marketer_logo_g, mobile_marketer_logo_defs;
function mobile_marketer_logo_extends() {
    mobile_marketer_logo_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return mobile_marketer_logo_extends.apply(this, arguments);
}

var SvgMobileMarketerLogo = function SvgMobileMarketerLogo(props) {
    return /*#__PURE__*/ react.createElement("svg", mobile_marketer_logo_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 25,
        height: 25,
        fill: "none",
        viewBox: "0 0 25 25"
    }, props), mobile_marketer_logo_g || (mobile_marketer_logo_g = /*#__PURE__*/ react.createElement("g", {
        clipPath: "url(#clip0_1_21)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#CA0C6B",
        d: "M9.455 11.386v9.679c0 .36.292.653.653.653h4.784a.654.654 0 0 0 .654-.654v-8.791a1.681 1.681 0 0 1 3.363 0v8.792c0 .36.293.653.654.653h4.783a.654.654 0 0 0 .654-.654v-9.678C25 7.307 21.52 4 17.227 4s-7.772 3.307-7.772 7.386"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint0_linear_1_21)",
        d: "M0 11.386v9.679c0 .36.293.653.654.653h4.783a.654.654 0 0 0 .654-.654v-8.791a1.681 1.681 0 0 1 3.363 0v8.792c0 .36.293.653.654.653h4.784a.654.654 0 0 0 .654-.654v-9.678C15.546 7.307 12.066 4 7.773 4S0 7.307 0 11.386"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#F8C3DD",
        d: "M0 16.026h6.09v5.153a.54.54 0 0 1-.54.54H.54a.54.54 0 0 1-.54-.54zM9.455 16.026h6.09v5.153a.54.54 0 0 1-.539.54H9.995a.54.54 0 0 1-.54-.54zM18.91 16.026H25v5.153a.54.54 0 0 1-.539.54h-5.01a.54.54 0 0 1-.54-.54z"
    }))), mobile_marketer_logo_defs || (mobile_marketer_logo_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint0_linear_1_21",
        x1: -0.507,
        x2: 24.777,
        y1: 20.464,
        y2: 17.216,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        stopColor: "#FF158A"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 0.766,
        stopColor: "#FF158A",
        stopOpacity: 0.5
    })), /*#__PURE__*/ react.createElement("clipPath", {
        id: "clip0_1_21"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M0 0h25v25H0z"
    })))));
};
/* harmony default export */ var mobile_marketer_logo = (SvgMobileMarketerLogo);

;// CONCATENATED MODULE: ./static/svg/header/mobile_projects_logo.svg
var mobile_projects_logo_path, mobile_projects_logo_path2, mobile_projects_logo_path3, mobile_projects_logo_defs;
function mobile_projects_logo_extends() {
    mobile_projects_logo_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return mobile_projects_logo_extends.apply(this, arguments);
}

var SvgMobileProjectsLogo = function SvgMobileProjectsLogo(props) {
    return /*#__PURE__*/ react.createElement("svg", mobile_projects_logo_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 25,
        height: 25,
        fill: "none",
        viewBox: "0 0 25 25"
    }, props), /*#__PURE__*/ react.createElement("g", {
        clipPath: "url(#clip0_1_23)"
    }, mobile_projects_logo_path || (mobile_projects_logo_path = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint0_linear_1_23)",
        d: "M6.25 4.333c0-.583.308-1.12.807-1.412L11.693.218a1.6 1.6 0 0 1 1.614 0l4.636 2.703c.5.291.807.83.807 1.412v6.347l-6.25 3.643-6.25-3.643z"
    })), mobile_projects_logo_path2 || (mobile_projects_logo_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint1_linear_1_23)",
        d: "M6.25 10.68c-1.81 1.062-3.628 2.112-5.443 3.17-.5.291-.807.83-.807 1.412v5.405c0 .582.308 1.12.807 1.412l4.636 2.703c.5.29 1.115.29 1.614 0l5.443-3.17v-7.288z"
    })), mobile_projects_logo_path3 || (mobile_projects_logo_path3 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint2_linear_1_23)",
        d: "M24.193 13.85c.5.29.807.83.807 1.412v5.405c0 .582-.308 1.12-.807 1.412l-4.636 2.703c-.5.29-1.115.29-1.614 0l-5.443-3.17v-7.288l6.25-3.644c1.811 1.062 3.629 2.112 5.443 3.17"
    })), /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint3_linear_1_23)",
        d: "M6.25 11.15c0-.29.154-.56.404-.706l5.443-3.173a.8.8 0 0 1 .807 0l5.442 3.173c.25.146.404.415.404.706v6.347c0 .291-.154.56-.404.706l-5.442 3.173a.8.8 0 0 1-.807 0l-5.443-3.173a.82.82 0 0 1-.404-.706z",
        style: {
            mixBlendMode: "multiply"
        }
    })), mobile_projects_logo_defs || (mobile_projects_logo_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint0_linear_1_23",
        x1: 6.25,
        x2: 18.806,
        y1: 3.401,
        y2: 10.585,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        stopColor: "#FB9000"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#FFCB00"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint1_linear_1_23",
        x1: 12.5,
        x2: -0.056,
        y1: 14.318,
        y2: 21.502,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        stopColor: "#FB9000"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#FFCB00"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint2_linear_1_23",
        x1: 12.5,
        x2: 25.056,
        y1: 14.317,
        y2: 21.502,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        stopColor: "#FB9000"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#FFCB00"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint3_linear_1_23",
        x1: 12.5,
        x2: 12.5,
        y1: 7.162,
        y2: 21.485,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        stopColor: "#FDAB3D"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#FFCB00",
        stopOpacity: 0.51
    })), /*#__PURE__*/ react.createElement("clipPath", {
        id: "clip0_1_23"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M0 0h25v25H0z"
    })))));
};
/* harmony default export */ var mobile_projects_logo = (SvgMobileProjectsLogo);

;// CONCATENATED MODULE: ./static/svg/header/dev_logo_new.svg
var dev_logo_new_path, dev_logo_new_path2, dev_logo_new_path3, dev_logo_new_defs;
function dev_logo_new_extends() {
    dev_logo_new_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return dev_logo_new_extends.apply(this, arguments);
}

var SvgDevLogoNew = function SvgDevLogoNew(props) {
    return /*#__PURE__*/ react.createElement("svg", dev_logo_new_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 25,
        height: 18,
        fill: "none",
        viewBox: "0 0 25 18"
    }, props), dev_logo_new_path || (dev_logo_new_path = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint0_linear_2426_1287)",
        fillRule: "evenodd",
        d: "M9.415 2.535C9.415 1.135 10.55 0 11.95 0a8.54 8.54 0 0 1 8.54 8.54 8.54 8.54 0 0 1-8.54 8.542H2.535a2.535 2.535 0 0 1 0-5.07h9.415a3.47 3.47 0 0 0 3.47-3.471 3.47 3.47 0 0 0-3.47-3.47 2.535 2.535 0 0 1-2.535-2.536",
        clipRule: "evenodd"
    })), dev_logo_new_path2 || (dev_logo_new_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "#00CA72",
        fillRule: "evenodd",
        d: "M3.55 8.54A8.54 8.54 0 0 1 12.093 0a2.535 2.535 0 1 1 0 5.07 3.47 3.47 0 0 0-3.47 3.47 3.47 3.47 0 0 0 3.47 3.471h10.407v5.07H12.092a8.54 8.54 0 0 1-8.541-8.54",
        clipRule: "evenodd"
    })), dev_logo_new_path3 || (dev_logo_new_path3 = /*#__PURE__*/ react.createElement("path", {
        fill: "#00CA72",
        d: "M24.747 13.943a.86.86 0 0 1 0 1.219l-1.683 1.673c-.542.54-1.466.155-1.466-.61V12.88c0-.765.924-1.149 1.466-.61z"
    })), dev_logo_new_defs || (dev_logo_new_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint0_linear_2426_1287",
        x1: 15.536,
        x2: 14.014,
        y1: 5.721,
        y2: 12.798,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        stopColor: "#00CA72"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 0.906,
        stopColor: "#00CA72",
        stopOpacity: 0.6
    })))));
};
/* harmony default export */ var dev_logo_new = (SvgDevLogoNew);

;// CONCATENATED MODULE: ./static/svg/header/service_logo.svg
var service_logo_path, service_logo_path2, service_logo_defs;
function service_logo_extends() {
    service_logo_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return service_logo_extends.apply(this, arguments);
}

var SvgServiceLogo = function SvgServiceLogo(props) {
    return /*#__PURE__*/ react.createElement("svg", service_logo_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 23,
        height: 23,
        fill: "none",
        viewBox: "0 0 23 23"
    }, props), service_logo_path || (service_logo_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#FF4D77",
        fillRule: "evenodd",
        d: "M4.835 4.715C3.01 5.484 2.12 7.406 2.948 9.37c1.068 2.538 5.77 3.979 5.992 4.01.198.032.43-.083.43-.303s-.43-2.043-.43-2.172.072-.245.197-.297c.124-.051 5.577-2.363 7.385-3.123a3.523 3.523 0 0 0 1.887-4.654C17.63.983 15.573.178 13.755.943s-7.096 3.005-8.92 3.772",
        clipRule: "evenodd"
    })), service_logo_path2 || (service_logo_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint0_linear_162_137261)",
        fillRule: "evenodd",
        d: "M17.468 18.595c1.824-.769 2.713-2.691 1.887-4.654-1.07-2.538-5.771-3.97-5.992-4.002-.2-.03-.432.084-.432.304s.432 2.033.432 2.162c0 .13-.073.246-.197.298s-5.578 2.363-7.386 3.123a3.523 3.523 0 0 0-1.887 4.654c.778 1.848 2.836 2.652 4.654 1.887 1.82-.765 7.096-3.006 8.92-3.772",
        clipRule: "evenodd"
    })), service_logo_defs || (service_logo_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint0_linear_162_137261",
        x1: 14.58,
        x2: 14.211,
        y1: 23.441,
        y2: 10.321,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        stopColor: "#FF4D77"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 0.47,
        stopColor: "#FF4D77",
        stopOpacity: 0.85
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#FF4D77",
        stopOpacity: 0.4
    })))));
};
/* harmony default export */ var service_logo = (SvgServiceLogo);

;// CONCATENATED MODULE: ./static/svg/header/solutions/team.svg
var team_path, team_path2, team_path3, team_defs;
function team_extends() {
    team_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return team_extends.apply(this, arguments);
}

var SvgTeam = function SvgTeam(props) {
    return /*#__PURE__*/ react.createElement("svg", team_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 25,
        height: 22,
        fill: "none",
        viewBox: "0 0 25 22"
    }, props), team_path || (team_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#6C6CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.583,
        d: "M9.008 8.812c1.577 0 2.855-1.234 2.855-2.757 0-1.522-1.278-2.756-2.855-2.756S6.153 4.533 6.153 6.055c0 1.523 1.278 2.757 2.855 2.757"
    })), team_path2 || (team_path2 = /*#__PURE__*/ react.createElement("path", {
        stroke: "url(#paint0_linear_2492_172907)",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.583,
        d: "M14.718 18H3.298v-1.225c0-1.462.602-2.864 1.673-3.898a5.81 5.81 0 0 1 4.037-1.615c1.515 0 2.967.58 4.038 1.615a5.42 5.42 0 0 1 1.672 3.898z"
    })), team_path3 || (team_path3 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#6161FF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.583,
        d: "M14.082 3.299c.757 0 1.483.29 2.019.807a2.7 2.7 0 0 1 .836 1.95c0 .73-.301 1.431-.836 1.948a2.9 2.9 0 0 1-2.019.808M16.112 11.495a5.7 5.7 0 0 1 2.669 2.02 5.4 5.4 0 0 1 1.01 3.125V18H17.89"
    })), team_defs || (team_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint0_linear_2492_172907",
        x1: 5.107,
        x2: 8.823,
        y1: 12.395,
        y2: 18.121,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        stopColor: "#6C6CFF"
    })))));
};
/* harmony default export */ var team = (SvgTeam);

;// CONCATENATED MODULE: ./static/svg/header/solutions/company.svg
var company_path, company_path2, company_path3, company_path4;
function company_extends() {
    company_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return company_extends.apply(this, arguments);
}

var SvgCompany = function SvgCompany(props) {
    return /*#__PURE__*/ react.createElement("svg", company_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 25,
        height: 23,
        fill: "none",
        viewBox: "0 0 25 23"
    }, props), company_path || (company_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#6C6CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeMiterlimit: 10,
        strokeWidth: 1.583,
        d: "M18.943 19.082V6.415l-6.846-2.2L5.096 6.5l.13 12.582z"
    })), company_path2 || (company_path2 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#6C6CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeMiterlimit: 10,
        strokeWidth: 1.188,
        d: "M10.907 9.64h2.375"
    })), company_path3 || (company_path3 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#6C6CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.188,
        d: "M10.116 19.083V13.54h3.959v5.543"
    })), company_path4 || (company_path4 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#6C6CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeMiterlimit: 10,
        strokeWidth: 1.583,
        d: "M19.032 11.165h3.959v7.917h-3.959M5.158 11.165H1.199v7.917h3.959"
    })));
};
/* harmony default export */ var company = (SvgCompany);

;// CONCATENATED MODULE: ./static/svg/header/solutions/industry2.svg
var industry2_path, industry2_path2;
function industry2_extends() {
    industry2_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return industry2_extends.apply(this, arguments);
}

var SvgIndustry2 = function SvgIndustry2(props) {
    return /*#__PURE__*/ react.createElement("svg", industry2_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "none",
        viewBox: "0 0 22 22"
    }, props), industry2_path || (industry2_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#6161FF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.25,
        d: "M3.2 6.8h15.6S20 6.8 20 8v9.6s0 1.2-1.2 1.2H3.2S2 18.8 2 17.6V8s0-1.2 1.2-1.2M14.6 6.8a3.6 3.6 0 0 0-7.2 0M2 11.6h7.2M12.8 11.6H20"
    })), industry2_path2 || (industry2_path2 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#6161FF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.25,
        d: "M9.2 12.4a1.8 1.8 0 1 0 3.6 0v-.96a1.8 1.8 0 0 0-3.6 0z"
    })));
};
/* harmony default export */ var industry2 = (SvgIndustry2);

;// CONCATENATED MODULE: ./static/svg/header/platform/keyFeatures.svg
var keyFeatures_path, keyFeatures_path2, keyFeatures_path3;
function keyFeatures_extends() {
    keyFeatures_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return keyFeatures_extends.apply(this, arguments);
}

var SvgKeyFeatures = function SvgKeyFeatures(props) {
    return /*#__PURE__*/ react.createElement("svg", keyFeatures_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 25,
        height: 23,
        fill: "none",
        viewBox: "0 0 25 23"
    }, props), keyFeatures_path || (keyFeatures_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#6C6CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.3,
        d: "M17.818 4.016H7.182a1.56 1.56 0 0 0-1.241.672L3.28 8.369a1.534 1.534 0 0 0 .088 1.885l7.977 9.189a1.462 1.462 0 0 0 2.308 0l7.977-9.19a1.53 1.53 0 0 0 .087-1.884L19.06 4.688a1.56 1.56 0 0 0-1.241-.672"
    })), keyFeatures_path2 || (keyFeatures_path2 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#6C6CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.3,
        d: "M11.744 4 8.18 9.522l4.324 10.446"
    })), keyFeatures_path3 || (keyFeatures_path3 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#6C6CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.3,
        d: "m13.304 4 3.55 5.522L12.5 19.968M3.04 9.521h18.932"
    })));
};
/* harmony default export */ var keyFeatures = (SvgKeyFeatures);

;// CONCATENATED MODULE: ./static/svg/header/platform/integrations_1.svg
var integrations_1_path;
function integrations_1_extends() {
    integrations_1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return integrations_1_extends.apply(this, arguments);
}

var SvgIntegrations1 = function SvgIntegrations1(props) {
    return /*#__PURE__*/ react.createElement("svg", integrations_1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 25,
        height: 23,
        fill: "none",
        viewBox: "0 0 25 23"
    }, props), integrations_1_path || (integrations_1_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#6C6CFF",
        fillRule: "evenodd",
        d: "M8.427 2.249a.85.85 0 0 1 1.201 0l3.215 3.215.5-.5 1.2-1.2.01.008.876-.876a.85.85 0 0 1 1.2 1.2l-.876.877 3.708 3.708a3.396 3.396 0 0 1 0 4.803l-1.802 1.802 3.137 3.137a.85.85 0 1 1-1.2 1.2l-3.138-3.136-1.343 1.343a3.396 3.396 0 0 1-4.803 0l-3.708-3.708-.764.764a.85.85 0 1 1-1.2-1.201l.763-.764-.008-.009 1.07-1.07-3.216-3.216a.85.85 0 0 1 1.2-1.2l3.217 3.215 3.976-3.977L8.427 3.45a.85.85 0 0 1 0-1.2M7.805 12.92l3.708 3.708a1.7 1.7 0 0 0 2.402 0l4.345-4.346a1.7 1.7 0 0 0 0-2.401l-3.708-3.708z",
        clipRule: "evenodd"
    })));
};
/* harmony default export */ var integrations_1 = (SvgIntegrations1);

;// CONCATENATED MODULE: ./static/svg/header/platform/addOns_1.svg
var addOns_1_path;
function addOns_1_extends() {
    addOns_1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return addOns_1_extends.apply(this, arguments);
}

var SvgAddOns1 = function SvgAddOns1(props) {
    return /*#__PURE__*/ react.createElement("svg", addOns_1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 25,
        height: 23,
        fill: "none",
        viewBox: "0 0 25 23"
    }, props), addOns_1_path || (addOns_1_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#6C6CFF",
        fillRule: "evenodd",
        d: "M7.344 5.42a3.42 3.42 0 1 1 6.839.054h1.94a2.4 2.4 0 0 1 2.401 2.403v1.94h.056a3.42 3.42 0 1 1-.056 6.84v1.94A2.4 2.4 0 0 1 16.122 21H5.402A2.4 2.4 0 0 1 3 18.598v-2.903a.814.814 0 0 1 1.086-.768q.279.1.597.102a1.791 1.791 0 1 0-.597-3.481A.814.814 0 0 1 3 10.78V7.877a2.4 2.4 0 0 1 2.402-2.403h1.942zm3.42-1.791a1.79 1.79 0 0 0-1.69 2.388.814.814 0 0 1-.768 1.086H5.402a.774.774 0 0 0-.774.774v1.94h.055a3.42 3.42 0 1 1-.055 6.84v1.94c0 .428.347.774.774.774h10.72a.774.774 0 0 0 .774-.773v-2.904a.814.814 0 0 1 1.086-.767q.28.1.598.102a1.791 1.791 0 1 0-.598-3.481.814.814 0 0 1-1.086-.768V7.877a.774.774 0 0 0-.774-.774h-2.901a.814.814 0 0 1-.768-1.086q.1-.28.102-.597c0-.99-.802-1.791-1.791-1.791",
        clipRule: "evenodd"
    })));
};
/* harmony default export */ var addOns_1 = (SvgAddOns1);

;// CONCATENATED MODULE: ./static/svg/header/platform/github.svg
var github_g, _g2, github_defs;
function github_extends() {
    github_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return github_extends.apply(this, arguments);
}

var SvgGithub = function SvgGithub(props) {
    return /*#__PURE__*/ react.createElement("svg", github_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 39,
        height: 43,
        fill: "none",
        viewBox: "0 0 39 43"
    }, props), github_g || (github_g = /*#__PURE__*/ react.createElement("g", {
        filter: "url(#filter0_d_2306_173474)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#000",
        stroke: "#fff",
        strokeWidth: 1.346,
        d: "m21.035 3.05 12.161 7.038a2.81 2.81 0 0 1 1.4 2.433V26.6a2.81 2.81 0 0 1-1.4 2.433l-12.161 7.039a2.79 2.79 0 0 1-2.8 0L6.074 29.032a2.81 2.81 0 0 1-1.4-2.433V12.52a2.81 2.81 0 0 1 1.4-2.433l12.161-7.039a2.79 2.79 0 0 1 2.8 0Z"
    }))), _g2 || (_g2 = /*#__PURE__*/ react.createElement("g", {
        clipPath: "url(#clip0_2306_173474)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M19.88 9.932a9.67 9.67 0 0 0-6.306 2.334 9.82 9.82 0 0 0-3.3 5.9 9.87 9.87 0 0 0 1.281 6.65 9.74 9.74 0 0 0 5.251 4.224c.49.09.663-.217.663-.476v-1.667c-2.716.596-3.289-1.318-3.289-1.318a2.62 2.62 0 0 0-1.08-1.438c-.877-.602.072-.602.072-.602a2.04 2.04 0 0 1 1.486 1.011 2.1 2.1 0 0 0 1.246 1.002 2.06 2.06 0 0 0 1.583-.183c.037-.495.249-.96.596-1.312-2.16-.247-4.428-1.09-4.428-4.815a3.8 3.8 0 0 1 .997-2.63 3.6 3.6 0 0 1 .096-2.594s.817-.264 2.673 1.005a9.1 9.1 0 0 1 4.87 0c1.855-1.27 2.667-1.005 2.667-1.005.358.814.4 1.733.12 2.576a3.8 3.8 0 0 1 .996 2.63c0 3.767-2.274 4.592-4.44 4.815a2.32 2.32 0 0 1 .662 1.805v2.69c0 .32.174.566.669.47a9.74 9.74 0 0 0 5.177-4.24 9.87 9.87 0 0 0 1.249-6.607 9.82 9.82 0 0 0-3.267-5.864 9.67 9.67 0 0 0-6.244-2.361",
        clipRule: "evenodd"
    }))), github_defs || (github_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("clipPath", {
        id: "clip0_2306_173474"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M9.904 9.687h19.614V29.3H9.904z"
    })), /*#__PURE__*/ react.createElement("filter", {
        id: "filter0_d_2306_173474",
        width: 38.403,
        height: 42.252,
        x: 0.434,
        y: 0.217,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        "in": "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ react.createElement("feOffset", {
        dy: 1.783
    }), /*#__PURE__*/ react.createElement("feGaussianBlur", {
        stdDeviation: 1.783
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_2306_173474"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        "in": "SourceGraphic",
        in2: "effect1_dropShadow_2306_173474",
        result: "shape"
    })))));
};
/* harmony default export */ var github = (SvgGithub);

;// CONCATENATED MODULE: ./static/svg/header/platform/gitlab_1.svg
var gitlab_1_g, gitlab_1_g2, gitlab_1_defs;
function gitlab_1_extends() {
    gitlab_1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return gitlab_1_extends.apply(this, arguments);
}

var SvgGitlab1 = function SvgGitlab1(props) {
    return /*#__PURE__*/ react.createElement("svg", gitlab_1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 39,
        height: 43,
        fill: "none",
        viewBox: "0 0 39 43"
    }, props), gitlab_1_g || (gitlab_1_g = /*#__PURE__*/ react.createElement("g", {
        filter: "url(#filter0_d_2411_171105)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#6B4FBB",
        stroke: "#fff",
        strokeWidth: 1.34,
        d: "m21.036 3.046 12.161 7.04A2.81 2.81 0 0 1 34.6 12.52V26.6a2.81 2.81 0 0 1-1.403 2.436l-12.16 7.039a2.8 2.8 0 0 1-2.803 0l-12.162-7.04A2.81 2.81 0 0 1 4.67 26.6V12.52c0-1.005.535-1.934 1.402-2.436l12.162-7.039a2.8 2.8 0 0 1 2.802 0Z"
    }))), gitlab_1_g2 || (gitlab_1_g2 = /*#__PURE__*/ react.createElement("g", {
        fillRule: "evenodd",
        clipPath: "url(#clip0_2411_171105)",
        clipRule: "evenodd"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#E24329",
        d: "m19.5 28.25 3.498-10.769h-6.996z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#FC6D26",
        d: "m19.5 28.25-3.498-10.769h-4.904z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#FCA326",
        d: "m11.099 17.481-1.063 3.275a.72.72 0 0 0 .263.81L19.5 28.25z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#E24329",
        d: "M11.098 17.481h4.903L13.894 11a.362.362 0 0 0-.688 0z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#FC6D26",
        d: "m19.5 28.25 3.498-10.769h4.904z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#FCA326",
        d: "m27.902 17.481 1.062 3.272a.72.72 0 0 1-.263.81L19.5 28.25z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#E24329",
        d: "M27.902 17.481h-4.904l2.108-6.485a.362.362 0 0 1 .688 0z"
    }))), gitlab_1_defs || (gitlab_1_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("clipPath", {
        id: "clip0_2411_171105"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M10 10h19v19H10z"
    })), /*#__PURE__*/ react.createElement("filter", {
        id: "filter0_d_2411_171105",
        width: 38.37,
        height: 42.22,
        x: 0.45,
        y: 0.225,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        "in": "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ react.createElement("feOffset", {
        dy: 1.775
    }), /*#__PURE__*/ react.createElement("feGaussianBlur", {
        stdDeviation: 1.775
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_2411_171105"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        "in": "SourceGraphic",
        in2: "effect1_dropShadow_2411_171105",
        result: "shape"
    })))));
};
/* harmony default export */ var gitlab_1 = (SvgGitlab1);

;// CONCATENATED MODULE: ./static/svg/header/platform/googleads_1.svg
var googleads_1_g, googleads_1_path, googleads_1_path2, googleads_1_path3, googleads_1_path4, googleads_1_path5, googleads_1_defs;
function googleads_1_extends() {
    googleads_1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return googleads_1_extends.apply(this, arguments);
}

var SvgGoogleads1 = function SvgGoogleads1(props) {
    return /*#__PURE__*/ react.createElement("svg", googleads_1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 43,
        fill: "none",
        viewBox: "0 0 40 43"
    }, props), googleads_1_g || (googleads_1_g = /*#__PURE__*/ react.createElement("g", {
        filter: "url(#filter0_d_2243_200375)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#F5F6F8",
        stroke: "#fff",
        strokeWidth: 1.427,
        d: "m21.014 3.087 12.16 7.04a2.77 2.77 0 0 1 1.382 2.398v14.08a2.77 2.77 0 0 1-1.381 2.399l-12.161 7.04a2.75 2.75 0 0 1-2.759 0l-12.161-7.04a2.77 2.77 0 0 1-1.38-2.399v-14.08c0-.99.526-1.904 1.38-2.398l12.161-7.04a2.75 2.75 0 0 1 2.759 0Z"
    }))), googleads_1_path || (googleads_1_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#3C8BD9",
        d: "M17.105 13.726c.145-.38.344-.731.64-1.015a2.508 2.508 0 0 1 3.945.586c.604 1.1 1.244 2.175 1.866 3.262l3.118 5.425c.864 1.516-.073 3.431-1.788 3.69-1.052.158-2.036-.325-2.58-1.268l-2.743-4.76q-.028-.053-.066-.097c-.097-.078-.14-.193-.2-.296l-2.017-3.498a2.5 2.5 0 0 1-.332-1.328c.018-.242.048-.484.157-.701"
    })), googleads_1_path2 || (googleads_1_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "#FABC04",
        d: "M17.105 13.726a3.5 3.5 0 0 0-.115.664 2.6 2.6 0 0 0 .362 1.42l1.988 3.437c.06.103.108.206.169.302l-1.093 1.879-1.529 2.634c-.024 0-.03-.012-.036-.03-.006-.049.012-.09.024-.14.248-.905.042-1.709-.58-2.398a2.3 2.3 0 0 0-1.42-.73c-.725-.103-1.365.084-1.939.537-.102.079-.169.194-.29.254q-.035-.002-.042-.03l.864-1.505 3.594-6.228c.012-.024.03-.042.043-.066"
    })), googleads_1_path3 || (googleads_1_path3 = /*#__PURE__*/ react.createElement("path", {
        fill: "#34A852",
        d: "m12.628 21.542.345-.308c1.467-1.16 3.672-.32 3.993 1.517.078.44.036.863-.097 1.286a1 1 0 0 1-.024.103c-.054.097-.103.2-.163.296-.538.888-1.33 1.33-2.368 1.263-1.19-.085-2.127-.979-2.29-2.163a2.42 2.42 0 0 1 .332-1.607c.06-.109.133-.205.2-.314.03-.024.018-.073.072-.073"
    })), googleads_1_path4 || (googleads_1_path4 = /*#__PURE__*/ react.createElement("path", {
        fill: "#FABC04",
        d: "M12.628 21.543c-.024.024-.024.066-.066.072-.006-.042.018-.066.042-.096z"
    })), googleads_1_path5 || (googleads_1_path5 = /*#__PURE__*/ react.createElement("path", {
        fill: "#E1C025",
        d: "M16.845 24.14c-.024-.041 0-.072.024-.102l.024.024z"
    })), googleads_1_defs || (googleads_1_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("filter", {
        id: "filter0_d_2243_200375",
        width: 38.83,
        height: 42.685,
        x: 0.219,
        y: 0.113,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        "in": "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ react.createElement("feOffset", {
        dy: 1.89
    }), /*#__PURE__*/ react.createElement("feGaussianBlur", {
        stdDeviation: 1.89
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_2243_200375"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        "in": "SourceGraphic",
        in2: "effect1_dropShadow_2243_200375",
        result: "shape"
    })))));
};
/* harmony default export */ var googleads_1 = (SvgGoogleads1);

;// CONCATENATED MODULE: ./static/svg/header/platform/drive.svg
var drive_g, drive_g2, drive_defs;
function drive_extends() {
    drive_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return drive_extends.apply(this, arguments);
}

var SvgDrive = function SvgDrive(props) {
    return /*#__PURE__*/ react.createElement("svg", drive_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 43,
        fill: "none",
        viewBox: "0 0 40 43"
    }, props), drive_g || (drive_g = /*#__PURE__*/ react.createElement("g", {
        filter: "url(#filter0_d_2264_200045)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#F5F6F8",
        stroke: "#fff",
        strokeWidth: 1.427,
        d: "m21.014 3.087 12.16 7.04a2.77 2.77 0 0 1 1.382 2.398v14.08c0 .99-.527 1.904-1.381 2.399l-12.161 7.04a2.75 2.75 0 0 1-2.759 0l-12.161-7.04a2.77 2.77 0 0 1-1.38-2.399v-14.08c0-.99.526-1.904 1.38-2.398l12.161-7.04a2.75 2.75 0 0 1 2.759 0Z"
    }))), drive_g2 || (drive_g2 = /*#__PURE__*/ react.createElement("g", {
        clipPath: "url(#clip0_2264_200045)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#0066DA",
        d: "m13.21 24.252.705 1.219c.147.257.358.458.605.605l2.52-4.362H12c0 .284.073.568.22.825z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#00AC47",
        d: "m20 16.583-2.52-4.362a1.66 1.66 0 0 0-.605.604L12.22 20.89a1.66 1.66 0 0 0-.22.824h5.04z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#EA4335",
        d: "M25.48 26.076c.247-.147.458-.348.605-.605l.293-.504 1.402-2.428c.147-.257.22-.541.22-.825h-5.04l1.072 2.108z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#00832D",
        d: "m20 16.582 2.52-4.362a1.6 1.6 0 0 0-.825-.22h-3.39c-.293 0-.578.082-.825.22z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#2684FC",
        d: "M22.96 21.714h-5.92l-2.52 4.362c.247.146.532.22.825.22h9.31c.293 0 .578-.083.825-.22z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#FFBA00",
        d: "m25.453 16.858-2.328-4.033a1.66 1.66 0 0 0-.605-.604L20 16.583l2.96 5.131h5.03a1.66 1.66 0 0 0-.22-.824z"
    }))), drive_defs || (drive_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("clipPath", {
        id: "clip0_2264_200045"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M12 12h16v14.296H12z"
    })), /*#__PURE__*/ react.createElement("filter", {
        id: "filter0_d_2264_200045",
        width: 38.83,
        height: 42.685,
        x: 0.219,
        y: 0.113,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        "in": "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ react.createElement("feOffset", {
        dy: 1.89
    }), /*#__PURE__*/ react.createElement("feGaussianBlur", {
        stdDeviation: 1.89
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_2264_200045"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        "in": "SourceGraphic",
        in2: "effect1_dropShadow_2264_200045",
        result: "shape"
    })))));
};
/* harmony default export */ var drive = (SvgDrive);

;// CONCATENATED MODULE: ./static/svg/header/platform/hubspot.svg
var hubspot_g, hubspot_path, hubspot_defs;
function hubspot_extends() {
    hubspot_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return hubspot_extends.apply(this, arguments);
}

var SvgHubspot = function SvgHubspot(props) {
    return /*#__PURE__*/ react.createElement("svg", hubspot_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 39,
        height: 43,
        fill: "none",
        viewBox: "0 0 39 43"
    }, props), hubspot_g || (hubspot_g = /*#__PURE__*/ react.createElement("g", {
        filter: "url(#filter0_d_2411_171060)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#FF7A59",
        stroke: "#fff",
        strokeWidth: 1.345,
        d: "m21.035 3.046 12.161 7.039a2.81 2.81 0 0 1 1.401 2.433v14.078a2.81 2.81 0 0 1-1.4 2.434l-12.162 7.038a2.8 2.8 0 0 1-2.8 0L6.074 29.03a2.81 2.81 0 0 1-1.401-2.434V12.518c0-1.004.534-1.932 1.4-2.433l12.162-7.04a2.8 2.8 0 0 1 2.8 0Z"
    }))), hubspot_path || (hubspot_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M24.965 17.708v-2.01a1.55 1.55 0 0 0 .908-1.394v-.046a1.56 1.56 0 0 0-.466-1.096 1.57 1.57 0 0 0-1.108-.45h-.047a1.57 1.57 0 0 0-1.108.45c-.295.29-.463.683-.467 1.096v.046a1.54 1.54 0 0 0 .909 1.394v2.01a4.5 4.5 0 0 0-2.124.922l-5.622-4.298q.06-.213.063-.435c0-.468-.188-.918-.52-1.249a1.78 1.78 0 0 0-2.513 0c-.333.331-.52.78-.52 1.249a1.75 1.75 0 0 0 .89 1.51 1.78 1.78 0 0 0 1.761-.002l5.53 4.22a4.33 4.33 0 0 0 .069 4.956l-1.684 1.655a1.44 1.44 0 0 0-1.577.567 1.422 1.422 0 0 0 .764 2.17 1.44 1.44 0 0 0 1.589-.535 1.42 1.42 0 0 0 .267-.836 1.4 1.4 0 0 0-.068-.41l1.664-1.632a4.52 4.52 0 0 0 2.72.905c2.48 0 4.49-1.973 4.49-4.405 0-2.203-1.65-4.023-3.802-4.35zm-.69 6.61a2.3 2.3 0 0 1-1.256-.396 2.247 2.247 0 0 1-.313-3.473 2.28 2.28 0 0 1 2.473-.477 2.27 2.27 0 0 1 1.016.833c.248.37.38.807.38 1.252a2.26 2.26 0 0 1-.68 1.604 2.3 2.3 0 0 1-1.62.656"
    })), hubspot_defs || (hubspot_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("filter", {
        id: "filter0_d_2411_171060",
        width: 38.397,
        height: 42.247,
        x: 0.436,
        y: 0.215,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        "in": "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ react.createElement("feOffset", {
        dy: 1.782
    }), /*#__PURE__*/ react.createElement("feGaussianBlur", {
        stdDeviation: 1.782
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_2411_171060"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        "in": "SourceGraphic",
        in2: "effect1_dropShadow_2411_171060",
        result: "shape"
    })))));
};
/* harmony default export */ var hubspot = (SvgHubspot);

;// CONCATENATED MODULE: ./static/svg/header/platform/jira_1.svg
var jira_1_g, jira_1_g2, jira_1_defs;
function jira_1_extends() {
    jira_1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return jira_1_extends.apply(this, arguments);
}

var SvgJira1 = function SvgJira1(props) {
    return /*#__PURE__*/ react.createElement("svg", jira_1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 39,
        height: 43,
        fill: "none",
        viewBox: "0 0 39 43"
    }, props), jira_1_g || (jira_1_g = /*#__PURE__*/ react.createElement("g", {
        filter: "url(#filter0_d_2411_171128)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#0460E7",
        stroke: "#fff",
        strokeWidth: 1.303,
        d: "m21.045 3.03 12.162 7.04a2.83 2.83 0 0 1 1.411 2.451V26.6a2.83 2.83 0 0 1-1.411 2.452l-12.162 7.038a2.81 2.81 0 0 1-2.82 0L6.063 29.051a2.83 2.83 0 0 1-1.411-2.452V12.52c0-1.012.538-1.946 1.411-2.452l12.162-7.038a2.82 2.82 0 0 1 2.82 0Z"
    }))), jira_1_g2 || (jira_1_g2 = /*#__PURE__*/ react.createElement("g", {
        clipPath: "url(#clip0_2411_171128)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "url(#pattern0)",
        d: "M10.747 12.848h17.761V28.89H10.747z"
    }))), jira_1_defs || (jira_1_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("clipPath", {
        id: "clip0_2411_171128"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M10.747 10.474h18.99v18.99h-18.99z"
    })), /*#__PURE__*/ react.createElement("pattern", {
        id: "pattern0",
        width: 1,
        height: 1,
        patternContentUnits: "objectBoundingBox"
    }, /*#__PURE__*/ react.createElement("use", {
        xlinkHref: "#image0_2411_171128",
        transform: "scale(.00616 .00685)"
    })), /*#__PURE__*/ react.createElement("filter", {
        id: "filter0_d_2411_171128",
        width: 38.175,
        height: 42.025,
        x: 0.547,
        y: 0.274,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        "in": "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ react.createElement("feOffset", {
        dy: 1.726
    }), /*#__PURE__*/ react.createElement("feGaussianBlur", {
        stdDeviation: 1.726
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_2411_171128"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        "in": "SourceGraphic",
        in2: "effect1_dropShadow_2411_171128",
        result: "shape"
    })), /*#__PURE__*/ react.createElement("image", {
        xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAaoAAACSCAYAAAAU0Y6CAAAMSGlDQ1BJQ0MgUHJvZmlsZQAASImVVwdUU8kanltSSWiBCEgJvYlSpEsJoUUQkA42QhJIKDEmBBE7y6KCaxcRsKGrIoquBZC1Yi+LYu8PdVFZWRcLNlTepMC6et575/3nzJ0v//zz/SVz584AoFPLk0rzUF0A8iUFsviIEFZqWjqL9AhQARmgwA448PhyKTsuLhpAGez/KW9vAETZX3VRcn0//l9FTyCU8wFA4iDOFMj5+RDvBwAv5UtlBQAQfaDeenqBVIknQmwggwFCLFXibDUuVeJMNa5S2STGcyDeCQCZxuPJsgHQboF6ViE/G/Jo34LYVSIQSwDQIUMcyBfxBBBHQjwiP3+qEkM74JD5FU/2Pzgzhzh5vOwhrM5FJeRQsVyax5vxf5bjf0t+nmLQhx1sNJEsMl6ZM6zbrdypUUpMg7hHkhkTC7E+xO/FApU9xChVpIhMUtujpnw5B9YMMCF2FfBCoyA2hThckhcTrdFnZonDuRDDFYIWiQu4iZq5C4XysAQNZ61sanzsIM6ScdiauY08mcqv0v6kIjeJreG/JRJyB/nfFIsSU9QxY9RCcXIMxNoQM+W5CVFqG8ymWMSJGbSRKeKV8dtA7CeURISo+bHJWbLweI29LF8+mC+2UCTmxmhwdYEoMVLDs5PPU8VvBHGLUMJOGuQRylOjB3MRCEPD1Lljl4WSJE2+WKe0ICReM/eVNC9OY49ThXkRSr0VxKbywgTNXDywAC5INT8eIy2IS1THiWfm8MbGqePBi0A04IBQwAIK2DLBVJADxO09zT3wl3okHPCADGQDIXDRaAZnpKhGJPCZAIrBnxAJgXxoXohqVAgKof7zkFb9dAFZqtFC1Yxc8ATifBAF8uBvhWqWZMhbMvgdasTfeefDWPNgU459r2NDTbRGoxjkZekMWhLDiKHESGI40RE3wQNxfzwaPoNhc8d9cN/BaP+2JzwhdBAeEa4TOgm3p4hLZN/kwwLjQCf0EK7JOfPrnHE7yOqJh+ABkB9y40zcBLjgo6EnNh4EfXtCLUcTuTL7b7n/kcNXVdfYUVwpKGUYJZji8O1MbSdtzyEWZU2/rpA61syhunKGRr71z/mq0gLYR31riS3E9mFnsOPYOewQ1gxY2FGsBbuIHVbioVX0u2oVDXqLV8WTC3nE3/njaXwqKyl3bXDtdv2kHisQFin3R8CZKp0hE2eLClhsuPMLWVwJf+QIlrurG9y1ld8R9Tb1mqn6PiDM83/rSgoBCHAcGBg49Lcu2heA/XAfpXb/rXOAe5y2BQBnF/IVskK1Dlc+CPALpQPfKGNgDqyBA8zHHXgBfxAMwsBYEAsSQRqYDKssgutZBqaDWWA+KAMVYBlYDarBBrAZbAe7wF7QDA6B4+A0uAAug+vgLlw9XeA56AVvQT+CICSEjjAQY8QCsUWcEXfEBwlEwpBoJB5JQzKQbESCKJBZyA9IBbICqUY2IfXIL8hB5DhyDulAbiMPkW7kFfIRxVAaaoCaoXboKNQHZaNRaCI6Cc1Gp6HFaCm6BK1C69CdaBN6HL2AXkc70edoHwYwLYyJWWIumA/GwWKxdCwLk2FzsHKsEqvDGrFW+D9fxTqxHuwDTsQZOAt3gSs4Ek/C+fg0fA6+GK/Gt+NN+En8Kv4Q78W/EOgEU4IzwY/AJaQSsgnTCWWESsJWwgHCKfg2dRHeEolEJtGe6A3fxjRiDnEmcTFxHXE38Rixg/iY2EcikYxJzqQAUiyJRyoglZHWknaSjpKukLpI78laZAuyOzmcnE6WkEvIleQd5CPkK+Sn5H6KLsWW4keJpQgoMyhLKVsorZRLlC5KP1WPak8NoCZSc6jzqVXURuop6j3qay0tLSstX63xWmKteVpVWnu0zmo91PpA06c50Ti0iTQFbQltG+0Y7TbtNZ1Ot6MH09PpBfQl9Hr6CfoD+ntthvZIba62QHuudo12k/YV7Rc6FB1bHbbOZJ1inUqdfTqXdHp0Kbp2uhxdnu4c3Rrdg7o3dfv0GHpuerF6+XqL9XbondN7pk/St9MP0xfol+pv1j+h/5iBMawZHAaf8QNjC+MUo8uAaGBvwDXIMagw2GXQbtBrqG842jDZsMiwxvCwYScTY9oxucw85lLmXuYN5sdhZsPYw4TDFg1rHHZl2Duj4UbBRkKjcqPdRteNPhqzjMOMc42XGzcb3zfBTZxMxptMN1lvcsqkZ7jBcP/h/OHlw/cOv2OKmjqZxpvONN1setG0z8zcLMJMarbW7IRZjznTPNg8x3yV+RHzbguGRaCF2GKVxVGLP1iGLDYrj1XFOsnqtTS1jLRUWG6ybLfst7K3SrIqsdptdd+aau1jnWW9yrrNutfGwmaczSybBps7thRbH1uR7RrbM7bv7OztUuwW2DXbPbM3sufaF9s32N9zoDsEOUxzqHO45kh09HHMdVzneNkJdfJ0EjnVOF1yRp29nMXO65w7RhBG+I6QjKgbcdOF5sJ2KXRpcHk4kjkyemTJyOaRL0bZjEoftXzUmVFfXD1d81y3uN5103cb61bi1ur2yt3Jne9e437Ng+4R7jHXo8Xj5Wjn0cLR60ff8mR4jvNc4Nnm+dnL20vm1ejV7W3jneFd633Tx8Anzmexz1lfgm+I71zfQ74f/Lz8Cvz2+v3l7+Kf67/D/9kY+zHCMVvGPA6wCuAFbAroDGQFZgRuDOwMsgziBdUFPQq2DhYEbw1+ynZk57B3sl+EuIbIQg6EvOP4cWZzjoVioRGh5aHtYfphSWHVYQ/CrcKzwxvCeyM8I2ZGHIskREZFLo+8yTXj8rn13N6x3mNnjz0ZRYtKiKqOehTtFC2Lbh2Hjhs7buW4ezG2MZKY5lgQy41dGXs/zj5uWtyv44nj48bXjH8S7xY/K/5MAiNhSsKOhLeJIYlLE+8mOSQpktqSdZInJtcnv0sJTVmR0pk6KnV26oU0kzRxWks6KT05fWt634SwCasndE30nFg28cYk+0lFk85NNpmcN/nwFJ0pvCn7MggZKRk7Mj7xYnl1vL5MbmZtZi+fw1/Dfy4IFqwSdAsDhCuET7MCslZkPcsOyF6Z3S0KElWKesQccbX4ZU5kzoacd7mxudtyB/JS8nbnk/Mz8g9K9CW5kpNTzacWTe2QOkvLpJ3T/KatntYri5JtlSPySfKWAgN4YL+ocFD8qHhYGFhYU/h+evL0fUV6RZKiizOcZiya8bQ4vPjnmfhM/sy2WZaz5s96OJs9e9McZE7mnLa51nNL53bNi5i3fT51fu7830pcS1aUvPkh5YfWUrPSeaWPf4z4saFMu0xWdnOB/4INC/GF4oXtizwWrV30pVxQfr7CtaKy4tNi/uLzP7n9VPXTwJKsJe1LvZauX0ZcJll2Y3nQ8u0r9FYUr3i8ctzKplWsVeWr3qyesvpc5ejKDWuoaxRrOquiq1rW2qxdtvZTtaj6ek1Ize5a09pFte/WCdZdWR+8vnGD2YaKDR83ijfe2hSxqanOrq5yM3Fz4eYnW5K3nPnZ5+f6rSZbK7Z+3ibZ1rk9fvvJeu/6+h2mO5Y2oA2Khu6dE3de3hW6q6XRpXHTbubuij1gj2LPH79k/HJjb9Tetn0++xr32+6vPcA4UN6ENM1o6m0WNXe2pLV0HBx7sK3Vv/XAryN/3XbI8lDNYcPDS49Qj5QeGThafLTvmPRYz/Hs44/bprTdPZF64trJ8SfbT0WdOns6/PSJM+wzR88GnD10zu/cwfM+55sveF1ouuh58cBvnr8daPdqb7rkfanlsu/l1o4xHUeuBF05fjX06ulr3GsXrsdc77iRdOPWzYk3O28Jbj27nXf75Z3CO/13590j3Cu/r3u/8oHpg7p/Of5rd6dX5+GHoQ8vPkp4dPcx//Hz3+W/f+oqfUJ/UvnU4mn9M/dnh7rDuy//MeGPrufS5/09ZX/q/Vn7wuHF/r+C/7rYm9rb9VL2cuDV4tfGr7e9Gf2mrS+u78Hb/Lf978rfG7/f/sHnw5mPKR+f9k//RPpU9dnxc+uXqC/3BvIHBqQ8GU91FMBgQ7OyAHi1DQB6GgCMy/D8MEF9z1MJor6bqhD4T1h9F1SJFwCNsFMe1znHANgDmx1s9GAAlEf1xGCAengMNY3Iszzc1Vw0eOMhvB8YeG0GAKkVgM+ygYH+dQMDn7fAYG8DcGya+n6pFCK8G2xUcVxhzk4F38i/AWeVfpxslGIkAAAfpElEQVR4Ae1dvY4cSXJeng4yBAE7ECDjzple51zOQpYAAax15O7sE0zzCXbWlsHmE+zwCbb5BGo+wdY4cm/onnM9znnC9UJyJOiO+r5hxrA6mVWdVZn1O18AMVmZGREZ+VVVfpXVzeazLyS1CHz48KGs7XzaHQdMf/fs2bPt04ZBsxcCQmAIBJ4NMchcxwBRfZhr7gPlfY9xLkFYdwONp2GEgBB4ggiIqBpOuoiqAZxPXb/gsBBZfQJER0JACORF4Fd5wy0uGncMkmYEvkT3TbOJeoWAEBAC3REQUTVjt2/uVq9D4AV2nyuhIQSEgBDoAwERVTOq++Zu9VYQKCrHOhQCQkAIZENARNUMpb4k0IxPtXdVrehYCAgBIZALARFVM5IiqmZ81CsEhIAQ6B0BEVUDxPgmW4lufqtNIgSEgBAQAiMhIKI6DXx52kQWQmDeCODLMGfQNXQLLaEmBxywzvb1vGep7IXAQhHgzQmVnEZgs9BLYPHTwqndQElIMUK768WDoglOCgHtqE6fjh1M9PrvNE6ymBkCIBzuovg57Cso/z1cjNDuR/hxl3UW4yAbIZCKgIjqBIL4nOoAE5KVRAgsBgFHMiUm9LzjpF7Aj/4SIdA7AiKqOIg3cWayEgKzQWCDTLuSlE3yOQiPcSRCoFcERFQR8GJXtYfZbYSpTITA5BEAuayQ5PeZEn3l4mUKpzBC4HMEfv15k1pqEFij/Y81fWoWAo0IYDFfw4DaVe7wwHTd1dnzyxXHwl7i4MYqKoVAbgREVJGIcleFxeYNzHM9iUaOLLOFILDCPPi5zhSExJJTRFQ50VSszxDQq7/PIGls2KBX3wBshEidU0YAD1tnyO88c45TIeDM01K4qSAgompxJtw3AHM/jbbIQKZCIBmBi+QICiAEBkZARNUScJBVCRe+ApQIASHgEMBOrRAYQqAvBERUHZB1H2rrW4AdsJPLYhG4W+zMNLHRERBRdT8FfAX4vru7PIXAKAgc+hjVvRbvI7RiCoEvRFQdLwJ3YxZwF1l1xFBuwyOA67aPnc/98DPRiE8JARFVwtkWWSWAJ9cxEXiXefAyczyFEwJHCIiojuBoX6mQVe6bv30y8hACcQjs4syirXLHix5Yhk8DARFVhvNMsoJeItTrDOEUQgj0igCu1S0GyPW67j3iiah6PWMKLqLKeA3ght0g3NdQfW6VEVeF6gWBdaaoueJkSkdhloiAiCrzWQVZ8TfZLhCWu6tfModXOCGQBQFcoyUCvUwM9pLXe2IMuQuBkwiIqE5C1M0AN/AGniuoCAsgSKaHAK7RLbL6Dtr2geoePt84fxxKhEC/CIioesQXNzI/u9pgiBX0B+h7qEQITAYBXJ/8fGkF5QMVCahJ2M/r+AJ+ZZOh+oRATgT06+k50ayJRcJC1w0VPzWzQnnpVD/mCSAk4yLgrs8Nsti463OF4wJqUuJgD7u9NagUAkMiIKIaEm2M5W72B9Li0FgYLlCsoCwpxcPfbn9EfN1wk5dDwF2fe1RL16RCCIyOgIhq5FOAheEOKVB3qamA9D6kxpC/EBACQmBqCOgzqqmdEeUjBISAEBACRwiIqI7gUEUICAEhIASmhsCkXv3hzdUZALroABJfedlrLzu2kuHsOGRzqr+Ljx8zNgb96uR/8JrwP+s61S4EhIAQWCoCkyIqgEyS+rkj2H+Bn6//F2jzbU7Vh45RO30Q+X+j8z/cB961duoQAkJACCwJgakRVQq2f1Pj/Azt1BQZMgaJs07+Hh3/CsIqQVZ/qDNSuxAQAkJgSQhMjagOieDWkZWFHZJwbMxQeSqPJrJivIK7K5DVn0LB1SYEhIAQWBICkyIqLLx3WIBT8T1FVhb/FFmYXVOZK0ZojFNk9U9wElGFkFObEBACi0JgUkTlkOXvjn2ZiHIsWSUOc+SeSloh/yay+s3R6KoIASEgBBaKwBSJ6g5Yv8iAd1uyChFFhjQ6h2A+lFqywu7zt3r99xEk/RUCfSKAe+0M8fllLwpL1n3hz0xt/cYx6sh3hXGpBbSaO6pH6yt/f/TARsje6R1K/i8QrE9ClkxUBLgtWdlJyUFaRjQWs21ZJajqcds4shcCQQQqi1mw/1QjFrLylE2X/sS8+EPQXGiTBDlcIsAFtHBlzFueW9huoYML8j3DoAWUebM8h8bI84rR0QYBMe/RV0J3wHRXsWt9mHpOp0hUBOb71kjUO3QlK4uYSlqp/syDMUhWyR/gMZhECDgE1ihfJaDB67IPWSNo17xu4VtAW4sjpzUcv23tPJIDci4w9Bp6Bc0t5wjIuFcYhx/JkKw2HXdaa/h2PqdTJSrMKauQrHIRRkpiqTmIrFLQl68Q8BDAAsydyBp6DeXCPAtB3mskuoEOlTN3lEZafBi4zrFzRZwo+VWU1YBGmPwBw73rYUjOlYRFcqbyuIua/1gxSHYSISAEEhFwi/0dwvwIHWrBT8oaOfOfpjDnn0bM+QXG/j3y4H9bdJY0oUjnyRGVy3sXmX9bMyMrI6wuRFX1MbKystoXe9yF+ERWbc+87IWAQwCL6wpaojrmYt/qfJAQoFs4/Qx93sq5P+PvEXqPvIr+hvgY+akRFWftk5URRSyx+HZGUlb6/W3qFsPKJt8QWfEbPBIhIARqEHCLKnck3BXMQio5X00wYb4S/Bk5bvrMbZJE5V7/ve1x4lWyMjIgOZhaW9vS/GOIpi62+VpZZ8d2Xw5+g+pCQAh8RACL6RpH3JFwcZ2FVHI+n3jCr5Drtq8cJ0lUbrKbvibt4obIykghF+FYHIvbtjT/OtLyd1V8UpQIASHgIeAW/J+85klX3cI/p5yv+iIrLoCTFH4FEpPmruqqxwRjiZqE4JNC27SGiCGiantWZL94BLCOrDHJOS34X7gFv8+1r6/zfoXcv8D6TcyzyWSJys1wg/IS2udWPZasXErZvubeB/GVlqRKISAE8A8PP/7DXZHUsBcDyYq/0rHJNWzbRTrXuFFxuKuC4U2UcZoRcejyWo4+da/lYuLR1zTG3rc5IjuH130aFPIWAstAAIvlCjPZzmk2yHmDfOe4k/JhfoW5FH5j1/qkiYqTcqw8xLfZxiIrIx8jrDbEd0RU7iLYdb0Y5CcEFoYA74U+38ZkhQsL+xoBX2UNOm6wHeZ0liOFyROVm+QaJX/Co2/pQlYpRGO+fhlLViGi2vYNkuILgakjgAVygxyfTz1Pyw/5XuD4xuoLKfmQkGVOXBAnL9hV8f+pukaiQ7xrJlmRAEIk0AarUWI4rO6R6HmbZGUrBJaCANaKFebC9WJOskWyQ+3++IbqAC2hITlD4wV0BU1dR65wPraIkySzICrOEAvw1l2AQ2yNSTLc5VBGIZyPQx/9DeXBtpDcoPHHUIfahMATQGCDOaYu+reIsXeK4uiYdYot6B9rHf9iXdvA9XlH9xg3EtMWyv+6o0QZLciNc7yEFq7sgusGviW0s8yGqDhDgLxxZHXVecbxjiQBIyvzCpGF9cWWuWJwPMYKyRaNG2iXiwpuEiEwWwQukPmLltnzY4USumOJdWaPMlbo01l6fPjmnG6g25bzOZoLfA+MQa2Q1gb1NjuttucD4Y9lVkTF1AHcGoDx8Ip/epYQWdmQOQnHYrYtg0TFiwsY8SJ91Tag7IXAzBFo83B2i7lyId+OOOfcYxtB3TiSyTY1F4/5krSuUW6gsXgnkdVcvkwBPD4JAFuj9vpTS69HJAP/yw7VOsm+Wm97bP5WtvEPEpVDg0R1745VCAEh8AkB3hffYB0poNtPzcMeYbEvMGLSAu5lfIv6Bea0gXIn1JsgPteXFZRj9i6zJCqiwpOB4iWUTxB9yzMM0EQgJBnTJru6PiMpK+vs/PbaebsLlU89EiEgBD4h8Br3xgpafmoa7YiLfS55gzmRePe5Ap6Kg7EOHBN2r0/ZpvbPlqg4cYC0RXEBfQ/tW06RlZFICmExhvnHkBZzqhXgs0Pnu1oDdQiBp4MAH2i/wT2xmcKU3W7qeaZcXmJeoz2UOkxfZppLMMysiYozAkh7KMmKrN737iqWrNoSjpGcX54irUaiIj6QNbRvXDiORAhMFQFe/9xtlBNKcJMpl5eY1zZTrM5hXA69kdXsicqQBVAbHJOw3lpbT2UbsjLiOUU4ZtdUhmKcJCrgcgAORU9YKKwQmAMCl7gP7qaSKHZTXKdyfDbF133bqczL5fKmj3wWQ1QEB0Bxd7XG4VdQAtbXTqILWRkJhQjH+mJLi3GSqIABceFN+pLHEiHwxBB4jeu/nNicrzPkc4t55YiTIZVPIVxOt59a8hwtiqgMEoBFwrqGnqGNC/Q768tYkiRiiaXOjoTDPivr7Orao6cDLLYwFllFIybDBSDwHtf9ZoLzuEzMiQ/g68QYfbozt6ybBC6Qixa3QG85SfcBZoHDC+gKmvphJsmKGLJMkb90dG41LrEABhzqp47jyU0IzAmBye04cP+RpGL/7VEd1je4l/d1nWO3MzfM8wZ5vMqVy+KJqgoUACxRpx4JQD1Dw8VRY1yFPj9CueOhkDhakceD1/GfNjFajyWyOgZbtcUicOvu96lN8DIxoXvMa5MYYwj3GwxyDU0l5YdcnxRR1Z0dnPgD+sq6/rp2tzuxbiMrq7chHPPxy1MxWhMVB8B8ubPa43AHzXIhIY5ECEwJge2Ukqnkclk57nK46eI0tA/X1Jy7qkV+RjX0SamMF/osiQ8DpqH+mDbzZ1m1rwzd7hAXUgmPFfQWKhECS0OAD2GTEizcBRJKeTD8hQ+Zk5pUczI36M7yWZWIqhnoLr1VIvGP6wjHt2uqV2N02lHZpPjUAy1QfwnNckFZbJVCYEQE3vHaHnH8uqGLuo7I9m2k3STM3DnI8sDwa7D8GrOinhJ+Cv9Xp/zwn8dss2Prq5bWF7Jjn8VssrN4ZmP1ahmKVe23Y4vh54NUgvJfaP0DAP9TsLe+kUQTIySaFLJJ8X3MD/Pjq0BeUNfQV48dOhAC80SgnGjaRWJe20T/Mdy5rlylDsyn8xX0RWQgW+C54JuSBOy4Wobap9wWguA3aPwdFvE9yhIL+v+GjGraYsmqxj2qOQtRcST39LPBXG9QJWFRU15TwF0iBEZB4G6UUU8PGrvOhiLd4x6d6rxC+T60IWf+d/S1/bEdfPV3iDWGHRdG+nARNmXdb2PfmG3+2H7d8qu2I+VaWaGnqO2t7zCMYsrqK70Ye9pkIyqbAgkLuoGeoe0l9J31qRQCc0AA1245tTyxWBeJOe0S/cd0T15DuDi2ZWku7qkSS7Ehu1BbbD6nfLkjrJMVLrbf4Sb4Q51BTTsJpYuQhLITUZtEMNct7KlfuButwOGF03OUEiEwNQSm+lnrKhGoMtF/THdyzLcpCZCoukgTWYXIINQWGjfWLrdvNV4jWcGwLVExdleysrzqSGswInNPqaUlZGXlSXFvbSqFwIgItH3wHipVPuClSJniPLIvc3+VksOvuQBhsekSw8iqk3OXASN9YvMJ2VlbHVn9NjKHkJm9qksll6p/9Tg0Zu9tjsB6H0cDCIGZI5BCVPwpqMOM55/88GA7qnuAcN4BCCOrNq5GBqd8QnahtlNxrL+tb4is/taCdSyreKWSDP1TY3SchtyEgBBoicCqpX3VfF+tzO2YJNtxM/Q4VSMqMt75Y2u7g+riGyKDUFtohFi73L6heGxjPvyWYm6p4pUaW0SViqD8hcAwCJwnDJO8I0kYO5frLQK96BrMiKpEgJQPu3IuvrFzCRFbqC0UL2QXaqPvEGSl3VHoLKlNCCwAAewmzhKnsU/0n727EdUOM/kxcTYxZFVHBv7QIbtQm+9XV0/xZcwhyMpyb0Na2lEZaiqFwHQRuEhMbZ/oPwX3Q0oSD0SFd4h7sP57BHqeEgy+PlnFEkSsXZv0UmKGfIckK5vnKdISURlSKoXAchFIWuQnAssd8uj81s52VJzLFpq6q2Icn6zYlltCRBJqC40bsgu1hXx9sspxAcXiFSItEVXoLKlNCEwLgbOUdLCR4CL/pKUPoiKgocU3lgxCdqG20U8cL6DUb7O4SYTwappfiLSa7NUnBITAeAhcjDf0MkZ+JCr3FcK3mNZVpqnFLr59kFBKzJBvqM1gusfBuVUSyli8qkNoR1VFQ8dCQAgsEoFHonKz26C8yjjTNotvExlUUwrZhdqqPnYcsgu1mX1MyW35eYxhhE0bvBhORBUBqkyEgBCYNwJHCyO/VIHpvMk8JY5B5S8zmPr1uvaQL21D/m3afFu/3jQGhj+S3O+PQ7kYPn4pojo6FaoIASGwRAS4KPqyQUPuH3YMLfwcO7Qop7b5/n7dFnu/nfWYNpgdSXlUy1NhHtztUi3fUCmiyoO3oggBITBhBPxXfw//LxG+ILBGzv+eOW8utHUS+/otZBdqC40TaxfyrW3DLpS/lUhi/7LWqFsHScgw47FIqRuO8hICQmDmCPDJ/TPB4rtD47vPOtIbuPD6uxbbKfjtrPttdf5t7Hxbv25j+O2sU0NCvPoQIyvDyHZZttMSefWBumIKASEwKQTqFl4muYbe8yCz1BGBtduibKVPGE12vq1fr4tJu5BtqC0ER19ExbF8srI5kKxEVKGzoTYhIAQWhcBnr/5sdu7r6peol9Dcr7W42JrEvpIL2YXaLG61jLWr+kQfcweK138k9fNop3aGRla+l4jKR0R1ITA9BO6ml9K8MuKOoVawABNgklUfYjsDlv7OhXW/LWTXts2P6dctnt/OurXVYXFT15Gp3ciKOZqKqDKBqzBCoEcEDimx8RC8SvFfgi8X30YBWZUweNlo1L3TFtwmgqjamF2ozYjE+vx6XTvtQrZ1bXWz3aIj97cl/bF8svL7VRcCQmB5CKwWMKUiZQ5cjE8KyGoLo++gfSzERiBW+gTBekwb/bvahXzr2jDM5wKM+NS0+bwne0uVrLSjyg6vAgqB7Agk7aiyZzPDgFzYowQL8Q6GBXQMsqojDZ+Ymux8W79uvn4769U2VMMCjG7Q8z7cm7XVyEpElRVWBRMC+RHAunCXGLVI9J+C+1lKElyAo8UBvoLDbbRTvGGVDIw0WFbVtzE7v511v81s/XgxdlXfUzO6PmWQqZ8kJaLKBKbCCIEJI5C0yE9kXs9T8uAi3UpAVgdoAacfoDl3V1x0fdJgPaatSiQ+EVXrOeyQUr0AmxK9b+ot1CMEhMATRCDl4f5iznjl+DJIa6IywLAg3+CYAL61tgxliKyMXEKEFUtCsb4hO7/t5DSBzTWMhngFeDIXGQgBITAJBA4JWbxI8J2CK3kiSbgIdxYsyHvoGgG+guYirDqyMsKqkhPz94kk1BbrG7Lz2zBklBSwyrnjjBpURotFYL/YmT2Nid2lTBO7kuTFPmX8RN8i0f9hkU+Nwd8HrBLWawS8TwxqZOWTkE8arA/ZxnyiBJjwCaqAiqyiEJPRCQT2J/rVPW0EkogKUyumPb3G7JJzj154G9NwnY6wNihXaPoaStK6hXYRkpWREPM0UrK2at3aQnahtq6+9IsW4MCLs4CKrKJRW6whrwPJ00XgSRKV+3wq6YsUvGRqf0Ip9Xpyi/TjyXFb1zPELVrG5s8fUf/qyn9B+c9QCtu7Sopv9JjEAXMv4FBCc/8UFUJKZoIAr/0U2ac4y3dcBLAO7LEO8IG16xpQjDuDzqNfdvasOPZGVJUxHg4dcfG4fGjo+Acn+9/gSrIaWjoTmyOrCyS8gyY/XQw9cY2XBYHU877PkoWCjIlAicG/7ZjAl1j7LrGWcA2Zk1znSJavxeYm9kqw+vqO86DGtFVteBzra7ad8OITFRwL6Fuo5AkhwAUmw3QPGWIoxLgIlInDrxP9B3XHdV9gwPMcg3KRnpsYsbAMkc6pNvM/ZWfE5Nt1xgtkxX+DtkaA76D63KozkrNzLFIzxnVzlxpD/qMjUCZm8C0W/1VijCHdN7kG46I9N6nuqNqQlW/r1+uIiXZV22S8sOjsEGQFfZMcTAHmgEDqjur9HCapHJsRcA8b981WJ3uvT1pMwMDtpl7kSoUL8NykSlRGLlUiqWuzdpamPgmZjR/P2llmEVy03F3xovsK+jZLUAWZHAK4YddIKvX1x93kJqaEuiJQdnV0fuuZ7Kq2ifM8cp8jUXECPllViYTHpk2EYzbm69v6dbM7AjC1ArLK/W/QUlOSf14ENhnCiagygDiRELvEPPitwU1ijF7dQaTML/Xh7CjHuRIVJ9GGrHzSYd1vMyI6RWBHAOaqOMLK9W/QcqWlOAkI4IbljjnHDVsmpCHXCSGA+5xElfr59BWurWJC03pMxeX16rEh08FgX0/PlK8fhmQVItsPvuGc6riY+QRNfRCc/AscrKAsKSunB1Yk00PAnbNNhsx+cddDhlAKMREEtsjj+8RcdrjGVrg2JrMGuGt+lzivoPvciYqTChFVcLINjbHEFmvXMFT7rgpx9XIRtM9IHk0I4IY9Qz/PFV/TpIrOeSqC0/O/QUqpRMVrq8S1VkyBrBxJlcgpxzWPMMeSY5E/jjhOjfOgVl/b2as8v73JtupfZzfODDXqLBBwN+wdkj3PlLCIKhOQUwkDYtkjl9sM+TxHDJLeqNI3SXFyXIyXIkYsLKuEY4SVq20peD2JeeAm2kD5TamzvieMMa4xRgnNRVJ87Sei6vvEjRN/k2nYK1x3/Jm23q/vUL4Yd432EtrLTgpxH2RJRMUJGUlZWSWnuja/3a8b0Vn7R+T0dy4IFEj0J+ifcVPxvX72r/e6mHuM8SM05w27RTzJAhHAA0iJaeXYVREd7qxIVhesDCEY6wzKhyjeWzmv+WD6S/iMyp8YCcXkgx1UylBbpfvxMNbu0UEHk0fgW2RI/QI32T2Ku4ry37WVqJ8UtyBwUSigl9C+btQbxJYsF4ENpvZzpumdI87vcW2+RnmDa/mQKe5RGMQ/Q8O1076u+6MxWVkiUXFeVbJiXSIEfAR4Y1MfiIuduAlZUEhiex54skKdPkPIWyw2+yEG0hjjIMAHI1xz3FW9yJjBK8S6Rlw+5GxzXUOIt0K8NZQk1YWg3sLvCtpJlkpUBCOGrD5EohZrFxlOZhNH4Bz5UceUzZiDa+zBEFhjpD9mHo1E8ooKgnmHsqSCtO5QRgt8CxhTL6HPoV2Fu7wkmSNRlZgxT0KM+GT1IcYJNrF2keFkJgRaIfA215Nwq1FlPDgCPM8gBC7ksWta2xz5xoBqbwy4gztA60irQN8ZNIWY4P4o9zi6gV4/tnQ4mCNRtZ2mT1Zt/WUvBIZEgL9akHRTD5msxkpHAGS1AVldIlIucmhK6oXrfCCvJsNMfWvM74D5JYWb3SKOSZcdZsx5+t8ADLVVbfxv+1lfh+HlIgSiEXi4saOtZbgUBEhUqT+tNDUs3nRcrz+bx+yIys3g/WczOd3gE5MRkRGQ1U/ZnR5JFkKgGwK8sXfdXOU1ZwRw3vfIfz3nOXi5v8ecsr0ZmCtRlR4osdVTJGSkRTvf1uqxY8lOCLRBIOuN3WZg2U4DAfeQ8nIa2SRlwc+liqQInjMX3zlKmZA052ykUyUmO66WIbuEoeUqBIII8A1BEexR45NCAGS1xYR/mPGk+fryEvM45JzDXL9MUSaCQDIKSdonfqGIahMCzQg8kFTuG7t5SPVOGQFcCzf48gEX+p+mnGcgN5JUgfzvAn1JTdwxzE7cTf0uMXGSlb9jsja/vVpPHFbuQuARgbc44o2d9enzMboOZosAroktkp/Ta0A+cK36ICmexFkSFROHbB/+pv0xYmLpa5WczG7OeKUhJe/cCPyAm1rf8MuN6oLiObL6GlPiTmXK0vsD12wXXpzEHc4cP7RLlSoJnSIr9kuEQAoCt3D+CtfvTUoQ+T4NBHCd8DXaCpr6BqkPwEig3yHH3h+4ZktUDvVNJvSNoIgH1eos/XqmIRVmIASm8lqNBPUNbuoCuh9o7hpmAQjgeuEPJl9iKt9Bczyc50DlLYKskNcuR7BTMWZNVABpiwnmOnFN5FQlsFOYqn9CCLgb/Guk9Ab6foTUeEN/gzxIUOUI42vIhSCA62cHXWE6L6G51j2EaiW8nr9CHmvoYA+Bc/3WXxXZDSq5vh1DsqqKvgVYRWOmx7ih7pD6NdPHt6nOUBROL1BSv4TmEi4gJXTHcsibGeNJngACuKa2mOYW1/IaJfUFtE/hNb2lYuw9ysHl2eAj9jAgTliJsDlP1l8Qr6p/tTpO1D/iWLIgBBx5kbBWTjk71s940CAH9N1BrbwTMTWgpa5eEMD1u0LgS2jhNMeD1y1ilVDu4niNjypLIaoVUCSYOU6QnZAqUfH4gaxw0v7BDFQKASEgBKaGAIjrAjlRVxXFYa3s0WPKh63RicnPdBFExUnh5KxR5HoF+BASfx53Ujh+ICucxJxkyHEkQkAICAEh0IDArL9MUZ0XCGSL+ttqW+IxSZz4+F+ySAwrdyEgBISAEGiDwGJ2VDZp7KxKHOf8vOoD4j3urECIf2djqRQCQkAICIH+EVjMjqoC1SWOc34N2d9ZVYbSoRAQAkJACPSNwOKICjueA0AroH2Q1eLw6vsCU3whIASEQCoCi1x4K2T1LhWgij93Vv6/s6p061AICAEhIASEQAcE8JnVBppNOqQgFyEgBISAEBACzQiApQroPgdbNY+kXiEgBISAEBACHREASZ1B+R+SJUnH4eUmBISAEBACQiAOAbDUBbTsylZxo8hKCAgBISAEhEAiAo6wtm0JK3FYuQsBISAEhIAQaIcAiIqvBNfQXQxptYsuayEgBISAEEhFYHG/TJECCEkL/hfQwpUrlM+hj4KvvguzRzR0IASEgBDoH4H/ByB8TRXCvla5AAAAAElFTkSuQmCC",
        id: "image0_2411_171128",
        width: 426,
        height: 146
    }))));
};
/* harmony default export */ var jira_1 = (SvgJira1);

;// CONCATENATED MODULE: ./static/svg/header/platform/mailchimp.svg
var mailchimp_g, mailchimp_path, mailchimp_path2, mailchimp_defs;
function mailchimp_extends() {
    mailchimp_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return mailchimp_extends.apply(this, arguments);
}

var SvgMailchimp = function SvgMailchimp(props) {
    return /*#__PURE__*/ react.createElement("svg", mailchimp_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 39,
        height: 43,
        fill: "none",
        viewBox: "0 0 39 43"
    }, props), mailchimp_g || (mailchimp_g = /*#__PURE__*/ react.createElement("g", {
        filter: "url(#filter0_d_2411_171071)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#FFE102",
        stroke: "#fff",
        strokeWidth: 1.345,
        d: "m21.035 3.046 12.161 7.039a2.81 2.81 0 0 1 1.401 2.433v14.078a2.81 2.81 0 0 1-1.4 2.434l-12.162 7.038a2.8 2.8 0 0 1-2.8 0L6.074 29.03a2.81 2.81 0 0 1-1.401-2.434V12.518c0-1.004.534-1.932 1.4-2.433l12.162-7.04a2.8 2.8 0 0 1 2.8 0Z"
    }))), mailchimp_path || (mailchimp_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#1A1919",
        fillRule: "evenodd",
        d: "M23.877 18.935q.196-.025.368 0c.066-.152.078-.414.018-.699-.088-.423-.208-.68-.455-.64s-.257.347-.168.77c.05.239.138.442.237.569M21.753 19.27c.177.078.286.129.328.084.028-.028.02-.082-.023-.15a1.04 1.04 0 0 0-.457-.37 1.25 1.25 0 0 0-1.214.147c-.118.086-.23.207-.215.28.006.023.023.04.065.047.098.01.439-.162.832-.186.277-.017.507.07.684.148M21.397 19.473c-.23.036-.358.112-.44.183-.07.06-.112.128-.112.175 0 .023.01.036.018.042q.015.015.038.015c.052 0 .168-.047.168-.047.321-.115.533-.1.742-.077.116.013.171.02.196-.02.008-.01.017-.036-.006-.073-.054-.088-.287-.236-.604-.198M23.16 20.218c.156.077.328.047.384-.067s-.025-.269-.182-.346c-.156-.077-.328-.047-.385.067-.056.115.026.27.182.346M24.165 19.34c-.127-.003-.232.137-.235.31-.003.175.098.318.225.32s.232-.137.235-.311c.003-.175-.098-.318-.225-.32M15.625 22.483c-.032-.04-.084-.027-.134-.016a.5.5 0 0 1-.118.017.26.26 0 0 1-.218-.11c-.058-.089-.054-.222.01-.373l.03-.068c.101-.23.272-.612.08-.977a.87.87 0 0 0-.662-.482.85.85 0 0 0-.73.263c-.28.31-.324.733-.27.882.02.055.051.07.074.073.048.006.118-.028.163-.148l.012-.038c.02-.064.057-.18.117-.275a.51.51 0 0 1 .708-.147c.197.128.273.37.189.6-.043.12-.114.347-.098.534.031.38.264.532.473.548.204.007.346-.107.382-.19.022-.05.004-.08-.008-.093",
        clipRule: "evenodd"
    })), mailchimp_path2 || (mailchimp_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "#1A1919",
        fillRule: "evenodd",
        d: "M17.56 15.525c.664-.767 1.482-1.434 2.214-1.809.025-.013.052.015.038.04-.058.105-.17.33-.205.501-.006.027.023.047.046.032.455-.31 1.248-.644 1.943-.686.03-.002.044.036.02.054a1.7 1.7 0 0 0-.306.307.03.03 0 0 0 .024.047c.488.004 1.176.175 1.624.426.03.017.009.076-.025.068-.678-.155-1.79-.273-2.943.008-1.03.251-1.816.64-2.39 1.056-.029.021-.063-.017-.04-.044m6.045 7.757a.05.05 0 0 0 .031-.053.05.05 0 0 0-.055-.045s-1.417.21-2.755-.28c.146-.474.533-.303 1.12-.256a8.2 8.2 0 0 0 2.702-.292c.606-.174 1.402-.517 2.02-1.005.21.458.283.963.283.963s.162-.03.296.054c.128.078.221.241.157.663-.13.788-.464 1.428-1.027 2.016-.343.369-.759.69-1.235.922a5 5 0 0 1-.806.34c-2.122.694-4.294-.068-4.994-1.704a2.6 2.6 0 0 1-.14-.387c-.299-1.078-.046-2.371.746-3.186.05-.052.099-.113.099-.19 0-.064-.04-.132-.076-.18-.277-.402-1.237-1.086-1.044-2.411.138-.952.97-1.623 1.747-1.583l.196.011c.337.02.63.063.907.075.463.02.88-.047 1.374-.459.166-.138.3-.259.526-.297.023-.004.082-.025.2-.02.121.007.236.04.339.109.395.263.451.9.472 1.367.012.266.044.91.055 1.096.025.423.136.482.361.556.127.042.244.073.417.121.524.148.834.297 1.03.488.117.12.171.247.188.369.062.45-.35 1.007-1.44 1.513-1.19.552-2.635.692-3.633.581l-.35-.04c-.799-.107-1.254.925-.775 1.632.309.456 1.15.753 1.992.753 1.93 0 3.413-.824 3.965-1.536a1 1 0 0 0 .044-.063c.027-.04.005-.064-.029-.04-.45.308-2.453 1.533-4.595 1.164 0 0-.26-.042-.498-.135-.189-.073-.584-.255-.632-.66 1.729.534 2.817.029 2.817.029m-9.494-4.108a2.3 2.3 0 0 0-1.455.928c-.194-.162-.554-.474-.618-.596-.517-.982.564-2.892 1.32-3.97 1.868-2.666 4.793-4.683 6.147-4.317.22.062.95.908.95.908s-1.354.75-2.61 1.797c-1.69 1.303-2.968 3.196-3.734 5.25m1.01 4.507q-.136.022-.277.02c-.905-.025-1.882-.84-1.979-1.805-.107-1.068.438-1.889 1.404-2.084.115-.023.255-.037.405-.029.541.03 1.339.445 1.52 1.624.162 1.044-.094 2.107-1.073 2.274m12.253-1.89c-.008-.028-.058-.212-.127-.434a4 4 0 0 0-.142-.38c.279-.416.284-.788.247-1a1.26 1.26 0 0 0-.368-.714c-.22-.23-.669-.466-1.3-.643l-.33-.092c-.002-.014-.017-.78-.032-1.11-.01-.237-.03-.609-.146-.974-.137-.496-.377-.929-.675-1.206.824-.854 1.338-1.795 1.337-2.603-.002-1.552-1.909-2.022-4.259-1.049l-.498.211-.913-.895c-2.68-2.336-11.055 6.974-8.377 9.235l.585.496a2.9 2.9 0 0 0-.163 1.329c.063.622.384 1.218.904 1.68.494.437 1.143.714 1.774.713 1.042 2.402 3.423 3.875 6.215 3.958 2.995.09 5.509-1.316 6.562-3.84.069-.178.361-.976.361-1.68 0-.709-.4-1.002-.655-1.002",
        clipRule: "evenodd"
    })), mailchimp_defs || (mailchimp_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("filter", {
        id: "filter0_d_2411_171071",
        width: 38.397,
        height: 42.247,
        x: 0.437,
        y: 0.215,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        "in": "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ react.createElement("feOffset", {
        dy: 1.782
    }), /*#__PURE__*/ react.createElement("feGaussianBlur", {
        stdDeviation: 1.782
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_2411_171071"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        "in": "SourceGraphic",
        in2: "effect1_dropShadow_2411_171071",
        result: "shape"
    })))));
};
/* harmony default export */ var mailchimp = (SvgMailchimp);

;// CONCATENATED MODULE: ./static/svg/header/platform/mt_1.svg
var mt_1_g, mt_1_path, mt_1_path2, mt_1_path3, mt_1_path4, mt_1_path5, mt_1_path6, mt_1_path7, mt_1_path8, mt_1_defs;
function mt_1_extends() {
    mt_1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return mt_1_extends.apply(this, arguments);
}

var SvgMt1 = function SvgMt1(props) {
    return /*#__PURE__*/ react.createElement("svg", mt_1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 43,
        fill: "none",
        viewBox: "0 0 40 43"
    }, props), mt_1_g || (mt_1_g = /*#__PURE__*/ react.createElement("g", {
        filter: "url(#filter0_d_2306_173568)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        stroke: "#fff",
        strokeWidth: 1.427,
        d: "m21.014 3.087 12.16 7.04a2.77 2.77 0 0 1 1.382 2.398v14.08a2.77 2.77 0 0 1-1.381 2.399l-12.161 7.04a2.75 2.75 0 0 1-2.759 0l-12.161-7.04a2.77 2.77 0 0 1-1.38-2.399v-14.08c0-.99.526-1.904 1.38-2.398l12.161-7.04a2.75 2.75 0 0 1 2.759 0Z"
    }))), mt_1_path || (mt_1_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#5059C9",
        d: "M23.008 23.243v-4.468q0-.168.12-.286a.4.4 0 0 1 .292-.118h4.62a.79.79 0 0 1 .727.476.8.8 0 0 1 .06.296v4.1a2.8 2.8 0 0 1-.489 1.578 2.85 2.85 0 0 1-.8.783 2.9 2.9 0 0 1-1.61.479h-.021a2.95 2.95 0 0 1-2.05-.832 2.85 2.85 0 0 1-.793-1.454 2.8 2.8 0 0 1-.056-.554M27.8 15.52a1.8 1.8 0 0 1-.317 1.025 1.85 1.85 0 0 1-.845.679 1.9 1.9 0 0 1-1.088.105 1.9 1.9 0 0 1-1.198-.784 1.84 1.84 0 0 1-.317-1.025 1.8 1.8 0 0 1 .317-1.025 1.85 1.85 0 0 1 .845-.679 1.9 1.9 0 0 1 1.088-.105 1.9 1.9 0 0 1 1.198.784 1.83 1.83 0 0 1 .317 1.025M25.75 26.294l-.027-.001z"
    })), mt_1_path2 || (mt_1_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "#7B83EB",
        d: "M22.665 14.683a2.62 2.62 0 0 1-.461 1.49 2.7 2.7 0 0 1-.756.74 2.8 2.8 0 0 1-.987.4 2.8 2.8 0 0 1-2.056-.4 2.7 2.7 0 0 1-1.008-1.204 2.63 2.63 0 0 1 .253-2.517 2.7 2.7 0 0 1 .755-.74 2.8 2.8 0 0 1 .987-.4 2.8 2.8 0 0 1 2.056.4 2.7 2.7 0 0 1 1.009 1.204 2.6 2.6 0 0 1 .208 1.026M24.263 18.371h-7.987a.8.8 0 0 0-.736.477.8.8 0 0 0-.062.297v4.643a4.6 4.6 0 0 0 .38 1.78 4.65 4.65 0 0 0 1.042 1.506 4.8 4.8 0 0 0 1.548 1.004 4.9 4.9 0 0 0 1.822.353 4.9 4.9 0 0 0 2.646-.78 4.8 4.8 0 0 0 1.32-1.28 4.7 4.7 0 0 0 .725-1.675q.096-.45.101-.908v-4.643a.76.76 0 0 0-.236-.549.8.8 0 0 0-.563-.225"
    })), mt_1_path3 || (mt_1_path3 = /*#__PURE__*/ react.createElement("path", {
        fill: "#000",
        fillOpacity: 0.2,
        d: "M19.928 18.371v6.931a.6.6 0 0 1-.014.134.76.76 0 0 1-.27.465.8.8 0 0 1-.514.183h-3.023a4 4 0 0 1-.18-.336 4.472 4.472 0 0 1-.448-1.962v-4.64a.76.76 0 0 1 .233-.55.8.8 0 0 1 .563-.225zM19.927 16.47v.896a2.778 2.778 0 0 1-1.67-.557 2.7 2.7 0 0 1-.87-1.12h1.742a.8.8 0 0 1 .738.482q.06.144.06.3"
    })), mt_1_path4 || (mt_1_path4 = /*#__PURE__*/ react.createElement("path", {
        fill: "#000",
        fillOpacity: 0.098,
        d: "M20.27 18.371v6.26q-.002.222-.09.426-.087.205-.247.361-.16.157-.369.242a1.2 1.2 0 0 1-.434.088h-3.204a4.472 4.472 0 0 1-.448-1.962v-4.64a.76.76 0 0 1 .234-.55.8.8 0 0 1 .563-.225zM20.269 16.47v.875a2.782 2.782 0 0 1-2.012-.537 2.7 2.7 0 0 1-.983-1.454h1.855a1.15 1.15 0 0 1 1.052.69q.087.204.088.426"
    })), mt_1_path5 || (mt_1_path5 = /*#__PURE__*/ react.createElement("path", {
        fill: "#000",
        fillOpacity: 0.2,
        d: "M19.928 18.371v6.26a.76.76 0 0 1-.234.553.8.8 0 0 1-.564.229h-3.351a4.5 4.5 0 0 1-.301-1.626v-4.641a.76.76 0 0 1 .234-.55.8.8 0 0 1 .563-.225zM19.927 16.47v.896a2.778 2.778 0 0 1-1.67-.557 2.7 2.7 0 0 1-.87-1.12h1.742a.8.8 0 0 1 .738.482q.06.144.06.3"
    })), mt_1_path6 || (mt_1_path6 = /*#__PURE__*/ react.createElement("path", {
        fill: "#000",
        fillOpacity: 0.098,
        d: "M19.585 16.47v.876a2.8 2.8 0 0 1-1.328-.537 2.7 2.7 0 0 1-.87-1.12h1.4a.8.8 0 0 1 .738.482q.06.144.06.3M16.275 18.371h3.31v6.26a.76.76 0 0 1-.233.553.8.8 0 0 1-.564.229h-3.01a4.5 4.5 0 0 1-.3-1.626v-4.641a.76.76 0 0 1 .234-.55.8.8 0 0 1 .563-.225"
    })), mt_1_path7 || (mt_1_path7 = /*#__PURE__*/ react.createElement("path", {
        fill: "#4B53BC",
        d: "M10.799 15.69h7.987a.8.8 0 0 1 .738.482q.06.144.06.3v7.824a.76.76 0 0 1-.234.553.8.8 0 0 1-.564.229h-7.987a.81.81 0 0 1-.738-.483.8.8 0 0 1-.061-.3v-7.823a.76.76 0 0 1 .234-.554.8.8 0 0 1 .565-.229"
    })), mt_1_path8 || (mt_1_path8 = /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M16.849 18.549h-1.563v4.368h-.995v-4.368h-1.556V17.7h4.114z"
    })), mt_1_defs || (mt_1_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("filter", {
        id: "filter0_d_2306_173568",
        width: 38.83,
        height: 42.685,
        x: 0.219,
        y: 0.113,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        "in": "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ react.createElement("feOffset", {
        dy: 1.89
    }), /*#__PURE__*/ react.createElement("feGaussianBlur", {
        stdDeviation: 1.89
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_2306_173568"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        "in": "SourceGraphic",
        in2: "effect1_dropShadow_2306_173568",
        result: "shape"
    })))));
};
/* harmony default export */ var mt_1 = (SvgMt1);

;// CONCATENATED MODULE: ./static/svg/header/platform/outlook.svg
var outlook_g, outlook_path, outlook_g2, outlook_path2, outlook_defs;
function outlook_extends() {
    outlook_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return outlook_extends.apply(this, arguments);
}

var SvgOutlook = function SvgOutlook(props) {
    return /*#__PURE__*/ react.createElement("svg", outlook_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 43,
        fill: "none",
        viewBox: "0 0 40 43"
    }, props), outlook_g || (outlook_g = /*#__PURE__*/ react.createElement("g", {
        filter: "url(#filter0_d_2306_173508)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#276BA6",
        stroke: "#fff",
        strokeWidth: 1.427,
        d: "m21.014 3.087 12.16 7.04a2.77 2.77 0 0 1 1.382 2.398v14.08a2.77 2.77 0 0 1-1.381 2.399l-12.161 7.04a2.75 2.75 0 0 1-2.759 0l-12.161-7.04a2.77 2.77 0 0 1-1.38-2.399v-14.08c0-.99.526-1.904 1.38-2.398l12.161-7.04a2.75 2.75 0 0 1 2.759 0Z"
    }))), /*#__PURE__*/ react.createElement("mask", {
        id: "mask0_2306_173508",
        width: 16,
        height: 16,
        x: 12,
        y: 12,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "alpha"
        }
    }, outlook_path || (outlook_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M12 12h15.537v15.84H12z",
        clipRule: "evenodd"
    }))), outlook_g2 || (outlook_g2 = /*#__PURE__*/ react.createElement("g", {
        fill: "#fff",
        fillRule: "evenodd",
        clipRule: "evenodd",
        mask: "url(#mask0_2306_173508)"
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M12 26.026V13.6l9.119-1.6v15.843zm3.669-6.117c0 .944.456 1.709 1.02 1.709.563 0 1.02-.765 1.02-1.71 0-.943-.457-1.708-1.02-1.708-.564 0-1.02.765-1.02 1.709m-1.077.004c0-1.593.95-2.884 2.122-2.884s2.12 1.291 2.12 2.884-.949 2.884-2.12 2.884-2.121-1.291-2.121-2.884M21.686 19.544v4.167h5.156s.755-.106.692-1.113l.004-5.445-3.777 2.6s-1.07.877-2.075-.21"
    }))), outlook_path2 || (outlook_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M21.76 15.032h5.185s.61-.044.61.659l-4.687 3.305-1.108-.747z",
        clipRule: "evenodd"
    })), outlook_defs || (outlook_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("filter", {
        id: "filter0_d_2306_173508",
        width: 38.83,
        height: 42.685,
        x: 0.219,
        y: 0.113,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        "in": "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ react.createElement("feOffset", {
        dy: 1.89
    }), /*#__PURE__*/ react.createElement("feGaussianBlur", {
        stdDeviation: 1.89
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_2306_173508"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        "in": "SourceGraphic",
        in2: "effect1_dropShadow_2306_173508",
        result: "shape"
    })))));
};
/* harmony default export */ var outlook = (SvgOutlook);

;// CONCATENATED MODULE: ./static/svg/header/platform/pagerduty_1.svg
var pagerduty_1_g, pagerduty_1_defs;
function pagerduty_1_extends() {
    pagerduty_1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return pagerduty_1_extends.apply(this, arguments);
}

var SvgPagerduty1 = function SvgPagerduty1(props) {
    return /*#__PURE__*/ react.createElement("svg", pagerduty_1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 39,
        height: 43,
        fill: "none",
        viewBox: "0 0 39 43"
    }, props), pagerduty_1_g || (pagerduty_1_g = /*#__PURE__*/ react.createElement("g", {
        filter: "url(#filter0_d_2411_171116)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#06AC38",
        stroke: "#fff",
        strokeWidth: 1.346,
        d: "m21.035 3.05 12.161 7.038a2.81 2.81 0 0 1 1.4 2.433V26.6a2.81 2.81 0 0 1-1.4 2.433l-12.161 7.039a2.79 2.79 0 0 1-2.8 0L6.074 29.032a2.81 2.81 0 0 1-1.4-2.433V12.52a2.81 2.81 0 0 1 1.4-2.433l12.161-7.039a2.79 2.79 0 0 1 2.8 0Z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M18.448 22.01h-1.843v3.224h1.843zM23.056 14.066c-.916-.498-1.558-.579-3.062-.579h-3.39v7.14h3.377c1.337 0 2.34-.08 3.222-.673.963-.639 1.464-1.709 1.464-2.947 0-1.333-.615-2.403-1.61-2.941m-2.68 5.067h-2.053v-4.118L20.262 15c1.765-.013 2.647.606 2.647 2.026 0 1.528-1.096 2.106-2.534 2.106"
    }))), pagerduty_1_defs || (pagerduty_1_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("filter", {
        id: "filter0_d_2411_171116",
        width: 38.403,
        height: 42.252,
        x: 0.434,
        y: 0.217,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        "in": "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ react.createElement("feOffset", {
        dy: 1.783
    }), /*#__PURE__*/ react.createElement("feGaussianBlur", {
        stdDeviation: 1.783
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_2411_171116"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        "in": "SourceGraphic",
        in2: "effect1_dropShadow_2411_171116",
        result: "shape"
    })))));
};
/* harmony default export */ var pagerduty_1 = (SvgPagerduty1);

;// CONCATENATED MODULE: ./static/svg/header/platform/slack_1.svg
var slack_1_g, slack_1_defs;
function slack_1_extends() {
    slack_1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return slack_1_extends.apply(this, arguments);
}

var SvgSlack1 = function SvgSlack1(props) {
    return /*#__PURE__*/ react.createElement("svg", slack_1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 39,
        height: 43,
        fill: "none",
        viewBox: "0 0 39 43"
    }, props), slack_1_g || (slack_1_g = /*#__PURE__*/ react.createElement("g", {
        filter: "url(#filter0_d_2315_173531)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#4A154B",
        stroke: "#fff",
        strokeWidth: 1.369,
        d: "M21.029 3.061 33.19 10.1a2.8 2.8 0 0 1 1.395 2.423v14.078a2.8 2.8 0 0 1-1.395 2.423l-12.161 7.04c-.863.498-1.925.498-2.788 0L6.08 29.023a2.8 2.8 0 0 1-1.396-2.423V12.523A2.8 2.8 0 0 1 6.08 10.1L18.24 3.06c.863-.5 1.925-.5 2.788 0Z"
    }), /*#__PURE__*/ react.createElement("g", {
        fillRule: "evenodd",
        clipPath: "url(#clip0_2315_173531)",
        clipRule: "evenodd"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#E01E5A",
        d: "M15.312 21.283a1.89 1.89 0 0 1-1.892 1.887 1.89 1.89 0 0 1-1.892-1.888 1.89 1.89 0 0 1 1.892-1.888h1.892zM15.806 21.283a1.89 1.89 0 0 1 1.892-1.889 1.89 1.89 0 0 1 1.892 1.889v4.72a1.89 1.89 0 0 1-1.892 1.888 1.89 1.89 0 0 1-1.892-1.888z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#36C5F0",
        d: "M17.698 14.716a1.89 1.89 0 0 1-1.892-1.888 1.89 1.89 0 0 1 1.892-1.888 1.89 1.89 0 0 1 1.892 1.888v1.888zM17.698 15.212A1.89 1.89 0 0 1 19.59 17.1a1.89 1.89 0 0 1-1.892 1.888h-4.73a1.89 1.89 0 0 1-1.892-1.888 1.89 1.89 0 0 1 1.892-1.888z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#2EB67D",
        d: "M24.348 17.1a1.89 1.89 0 0 1 1.892-1.888 1.89 1.89 0 0 1 1.892 1.888 1.89 1.89 0 0 1-1.892 1.888h-1.892zM23.854 17.1a1.89 1.89 0 0 1-1.892 1.889A1.89 1.89 0 0 1 20.07 17.1v-4.72a1.89 1.89 0 0 1 1.892-1.889 1.89 1.89 0 0 1 1.892 1.888z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#ECB22E",
        d: "M21.962 23.667a1.89 1.89 0 0 1 1.892 1.888 1.89 1.89 0 0 1-1.892 1.888 1.89 1.89 0 0 1-1.892-1.888v-1.888zM21.962 23.17a1.89 1.89 0 0 1-1.892-1.888 1.89 1.89 0 0 1 1.892-1.888h4.73a1.89 1.89 0 0 1 1.892 1.889 1.89 1.89 0 0 1-1.892 1.887z"
    })))), slack_1_defs || (slack_1_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("clipPath", {
        id: "clip0_2315_173531"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M10.615 10.032h18.43v18.426h-18.43z"
    })), /*#__PURE__*/ react.createElement("filter", {
        id: "filter0_d_2315_173531",
        width: 38.524,
        height: 42.376,
        x: 0.373,
        y: 0.187,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        "in": "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ react.createElement("feOffset", {
        dy: 1.813
    }), /*#__PURE__*/ react.createElement("feGaussianBlur", {
        stdDeviation: 1.813
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_2315_173531"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        "in": "SourceGraphic",
        in2: "effect1_dropShadow_2315_173531",
        result: "shape"
    })))));
};
/* harmony default export */ var slack_1 = (SvgSlack1);

;// CONCATENATED MODULE: ./static/svg/header/platform/surveymonkey.svg
var surveymonkey_g, surveymonkey_g2, surveymonkey_defs;
function surveymonkey_extends() {
    surveymonkey_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return surveymonkey_extends.apply(this, arguments);
}

var SvgSurveymonkey = function SvgSurveymonkey(props) {
    return /*#__PURE__*/ react.createElement("svg", surveymonkey_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 43,
        fill: "none",
        viewBox: "0 0 40 43"
    }, props), surveymonkey_g || (surveymonkey_g = /*#__PURE__*/ react.createElement("g", {
        filter: "url(#filter0_d_2315_173498)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#00BF6F",
        stroke: "#fff",
        strokeWidth: 1.415,
        d: "m21.017 3.076 12.162 7.039a2.78 2.78 0 0 1 1.383 2.403v14.078c0 .992-.528 1.908-1.383 2.404l-12.162 7.038a2.76 2.76 0 0 1-2.765 0L6.091 29a2.78 2.78 0 0 1-1.384-2.404V12.518c0-.992.528-1.908 1.384-2.403l12.161-7.04a2.76 2.76 0 0 1 2.765 0Z"
    }))), surveymonkey_g2 || (surveymonkey_g2 = /*#__PURE__*/ react.createElement("g", {
        clipPath: "url(#clip0_2315_173498)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M27.152 19.914q-.288 0-.568.071a7.4 7.4 0 0 0-2.105-3.589 7.3 7.3 0 0 0-4.062-1.924c.021-.698.054-1.507 1.072-2.232l-.158-.41s-1.982.622-2.21 2.338c-.099-.467-1.024-1.051-1.481-1.161l-.228.371a1.6 1.6 0 0 1 .744 1.15 7.3 7.3 0 0 0-3.693 1.869 7.4 7.4 0 0 0-2.106 3.59 2.35 2.35 0 0 0-2.096.49c-.287.242-.513.55-.66.897a2.42 2.42 0 0 0 .143 2.169c.19.325.455.6.77.801a2.36 2.36 0 0 0 2.143.205c.203.512.461.999.772 1.452l1.97-1.343-.016-.023c-.521-.677-.842-1.674-.894-2.666-.058-1.094.205-2.181.897-2.82 1.42-1.227 2.978-.67 3.945.508h.262c.973-1.175 2.526-1.735 3.946-.509.692.638.957 1.727.897 2.821-.054.992-.373 1.989-.893 2.666l-.018.023L25.497 26c.31-.453.569-.94.771-1.452a2.35 2.35 0 0 0 2.011-.134c.305-.17.57-.406.774-.69a2.41 2.41 0 0 0 .381-2 2.4 2.4 0 0 0-.464-.932 2.38 2.38 0 0 0-1.818-.88m-15.404 3.108a.7.7 0 0 1-.496-.208.71.71 0 0 1 0-1.001.7.7 0 0 1 .889-.085q.008.56.074 1.117a.7.7 0 0 1-.467.177m15.452 0a.7.7 0 0 1-.474-.182q.066-.556.074-1.116a.694.694 0 0 1 .995.22c.065.11.1.238.099.366a.71.71 0 0 1-.201.501.7.7 0 0 1-.494.21"
    }))), surveymonkey_defs || (surveymonkey_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("clipPath", {
        id: "clip0_2315_173498"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M9.153 10.026h20.612v20.612H9.153z"
    })), /*#__PURE__*/ react.createElement("filter", {
        id: "filter0_d_2315_173498",
        width: 38.765,
        height: 42.615,
        x: 0.252,
        y: 0.123,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        "in": "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ react.createElement("feOffset", {
        dy: 1.874
    }), /*#__PURE__*/ react.createElement("feGaussianBlur", {
        stdDeviation: 1.874
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_2315_173498"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        "in": "SourceGraphic",
        in2: "effect1_dropShadow_2315_173498",
        result: "shape"
    })))));
};
/* harmony default export */ var surveymonkey = (SvgSurveymonkey);

;// CONCATENATED MODULE: ./static/svg/header/platform/twilio_1.svg
var twilio_1_g, twilio_1_path, twilio_1_path2, twilio_1_defs;
function twilio_1_extends() {
    twilio_1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return twilio_1_extends.apply(this, arguments);
}

var SvgTwilio1 = function SvgTwilio1(props) {
    return /*#__PURE__*/ react.createElement("svg", twilio_1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 43,
        fill: "none",
        viewBox: "0 0 40 43"
    }, props), twilio_1_g || (twilio_1_g = /*#__PURE__*/ react.createElement("g", {
        filter: "url(#filter0_d_2253_200036)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#FF043D",
        stroke: "#fff",
        strokeWidth: 1.427,
        d: "m21.014 3.087 12.16 7.04a2.77 2.77 0 0 1 1.382 2.398v14.08a2.77 2.77 0 0 1-1.381 2.399l-12.161 7.04a2.75 2.75 0 0 1-2.759 0l-12.161-7.04a2.77 2.77 0 0 1-1.38-2.399v-14.08c0-.99.526-1.904 1.38-2.398l12.161-7.04a2.75 2.75 0 0 1 2.759 0Z"
    }))), twilio_1_path || (twilio_1_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M20 25.155a5.155 5.155 0 1 1 0-10.31 5.155 5.155 0 0 1 0 10.31M20 13a7 7 0 1 0 0 14 7 7 0 0 0 0-14"
    })), twilio_1_path2 || (twilio_1_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M20.288 18.257a1.456 1.456 0 1 1 2.91 0 1.456 1.456 0 0 1-2.91 0m0 3.487a1.456 1.456 0 1 1 2.91 0 1.456 1.456 0 0 1-2.91 0m-3.487 0a1.456 1.456 0 1 1 2.911 0 1.456 1.456 0 0 1-2.91 0m0-3.487a1.456 1.456 0 1 1 2.911 0 1.456 1.456 0 0 1-2.91 0"
    })), twilio_1_defs || (twilio_1_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("filter", {
        id: "filter0_d_2253_200036",
        width: 38.83,
        height: 42.685,
        x: 0.219,
        y: 0.113,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        "in": "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ react.createElement("feOffset", {
        dy: 1.89
    }), /*#__PURE__*/ react.createElement("feGaussianBlur", {
        stdDeviation: 1.89
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_2253_200036"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        "in": "SourceGraphic",
        in2: "effect1_dropShadow_2253_200036",
        result: "shape"
    })))));
};
/* harmony default export */ var twilio_1 = (SvgTwilio1);

;// CONCATENATED MODULE: ./static/svg/header/platform/zendesk.svg
var zendesk_g, zendesk_path, zendesk_defs;
function zendesk_extends() {
    zendesk_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return zendesk_extends.apply(this, arguments);
}

var SvgZendesk = function SvgZendesk(props) {
    return /*#__PURE__*/ react.createElement("svg", zendesk_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 43,
        fill: "none",
        viewBox: "0 0 40 43"
    }, props), zendesk_g || (zendesk_g = /*#__PURE__*/ react.createElement("g", {
        filter: "url(#filter0_d_2301_173445)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#02363D",
        stroke: "#fff",
        strokeWidth: 1.438,
        d: "m21.012 3.089 12.16 7.039a2.77 2.77 0 0 1 1.379 2.393V26.6c0 .988-.526 1.9-1.378 2.393l-12.161 7.039a2.75 2.75 0 0 1-2.754 0l-12.16-7.039A2.77 2.77 0 0 1 4.718 26.6V12.52c0-.988.526-1.9 1.378-2.393l12.161-7.039a2.75 2.75 0 0 1 2.754 0Z"
    }))), zendesk_path || (zendesk_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M19.099 16.646v9.22h-7.637zM19.099 13.337a3.818 3.818 0 0 1-7.637 0zM20.357 25.866a3.818 3.818 0 0 1 7.637 0zM20.357 22.557v-9.22h7.638z"
    })), zendesk_defs || (zendesk_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("filter", {
        id: "filter0_d_2301_173445",
        width: 38.891,
        height: 42.741,
        x: 0.19,
        y: 0.095,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        "in": "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ react.createElement("feOffset", {
        dy: 1.905
    }), /*#__PURE__*/ react.createElement("feGaussianBlur", {
        stdDeviation: 1.905
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_2301_173445"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        "in": "SourceGraphic",
        in2: "effect1_dropShadow_2301_173445",
        result: "shape"
    })))));
};
/* harmony default export */ var zendesk = (SvgZendesk);

;// CONCATENATED MODULE: ./static/svg/header/platform/zoom_1.svg
var zoom_1_g, zoom_1_path, zoom_1_defs;
function zoom_1_extends() {
    zoom_1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return zoom_1_extends.apply(this, arguments);
}

var SvgZoom1 = function SvgZoom1(props) {
    return /*#__PURE__*/ react.createElement("svg", zoom_1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 43,
        fill: "none",
        viewBox: "0 0 40 43"
    }, props), zoom_1_g || (zoom_1_g = /*#__PURE__*/ react.createElement("g", {
        filter: "url(#filter0_d_2264_200020)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#0073EA",
        stroke: "#fff",
        strokeWidth: 1.427,
        d: "m21.014 3.087 12.16 7.04a2.77 2.77 0 0 1 1.382 2.398v14.08a2.77 2.77 0 0 1-1.381 2.399l-12.161 7.04a2.75 2.75 0 0 1-2.759 0l-12.161-7.04a2.77 2.77 0 0 1-1.38-2.399v-14.08c0-.99.526-1.904 1.38-2.398l12.161-7.04a2.75 2.75 0 0 1 2.759 0Z"
    }))), zoom_1_path || (zoom_1_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M26.592 18.644c.08.138.107.295.115.472l.012.236v1.65l.011.236c.024.386.308.67.697.695l.235.012v-2.593l.011-.236c.01-.175.036-.335.117-.474a.943.943 0 0 1 1.632.003c.08.138.105.298.115.471l.011.236v1.65l.012.236a.72.72 0 0 0 .696.695l.235.012v-2.829a1.886 1.886 0 0 0-3.3-1.247 1.884 1.884 0 0 0-2.47-.315c-.184-.205-.595-.324-.831-.324v4.715l.236-.012c.394-.026.68-.303.695-.695l.012-.236v-1.65l.012-.236c.01-.178.035-.334.115-.473a.945.945 0 0 1 1.632 0m-16.14 3.29.236.01h3.536l-.012-.234c-.032-.388-.306-.671-.695-.696l-.236-.012h-2.122l2.829-2.83-.012-.234a.713.713 0 0 0-.695-.697l-.236-.01-3.536-.001.012.236c.03.384.309.673.695.695l.236.012h2.121l-2.828 2.83.011.235a.72.72 0 0 0 .696.695m12.512-4.014a2.358 2.358 0 1 1-3.334 3.334 2.358 2.358 0 0 1 3.334-3.334m-.667.668a1.416 1.416 0 1 1-2.003 2 1.416 1.416 0 0 1 2.003-2m-5.95-1.358a2.357 2.357 0 1 1-1.669 4.024 2.358 2.358 0 0 1 1.666-4.024zm1 1.357a1.415 1.415 0 1 1-2.003 2 1.415 1.415 0 0 1 2.002-2",
        clipRule: "evenodd"
    })), zoom_1_defs || (zoom_1_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("filter", {
        id: "filter0_d_2264_200020",
        width: 38.83,
        height: 42.685,
        x: 0.219,
        y: 0.113,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        "in": "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ react.createElement("feOffset", {
        dy: 1.89
    }), /*#__PURE__*/ react.createElement("feGaussianBlur", {
        stdDeviation: 1.89
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_2264_200020"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        "in": "SourceGraphic",
        in2: "effect1_dropShadow_2264_200020",
        result: "shape"
    })))));
};
/* harmony default export */ var zoom_1 = (SvgZoom1);

;// CONCATENATED MODULE: ./static/svg/header/platform/gmail.svg
var gmail_g, gmail_g2, gmail_defs;
function gmail_extends() {
    gmail_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return gmail_extends.apply(this, arguments);
}

var SvgGmail = function SvgGmail(props) {
    return /*#__PURE__*/ react.createElement("svg", gmail_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 43,
        fill: "none",
        viewBox: "0 0 40 43"
    }, props), gmail_g || (gmail_g = /*#__PURE__*/ react.createElement("g", {
        filter: "url(#filter0_d_2306_173600)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        stroke: "#fff",
        strokeWidth: 1.427,
        d: "m21.014 3.084 12.161 7.04a2.77 2.77 0 0 1 1.38 2.399v14.079c0 .99-.526 1.904-1.38 2.399l-12.16 7.04a2.75 2.75 0 0 1-2.76 0L6.095 29a2.77 2.77 0 0 1-1.381-2.399v-14.08c0-.99.526-1.904 1.38-2.398l12.161-7.04a2.75 2.75 0 0 1 2.76 0Z"
    }))), gmail_g2 || (gmail_g2 = /*#__PURE__*/ react.createElement("g", {
        clipPath: "url(#clip0_2306_173600)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#4285F4",
        d: "M12.136 25.962h2.652v-6.44L11 16.683v8.144c0 .629.51 1.136 1.136 1.136"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#34A853",
        d: "M23.879 25.961h2.651c.629 0 1.137-.51 1.137-1.136V16.68l-3.788 2.84"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#FBBC04",
        d: "M23.879 14.138v4.924l3.788-2.841v-1.515c0-1.405-1.605-2.207-2.728-1.364"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#EA4335",
        d: "M14.788 19.061v-4.924l4.546 3.409 4.545-3.41v4.925l-4.546 3.41"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#C5221F",
        d: "M11 14.707v1.515l3.788 2.84V14.14l-1.06-.796C12.601 12.5 11 13.302 11 14.707"
    }))), gmail_defs || (gmail_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("clipPath", {
        id: "clip0_2306_173600"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M11 13h16.667v12.5H11z"
    })), /*#__PURE__*/ react.createElement("filter", {
        id: "filter0_d_2306_173600",
        width: 38.83,
        height: 42.685,
        x: 0.22,
        y: 0.11,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        "in": "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ react.createElement("feOffset", {
        dy: 1.89
    }), /*#__PURE__*/ react.createElement("feGaussianBlur", {
        stdDeviation: 1.89
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_2306_173600"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        "in": "SourceGraphic",
        in2: "effect1_dropShadow_2306_173600",
        result: "shape"
    })))));
};
/* harmony default export */ var gmail = (SvgGmail);

// EXTERNAL MODULE: ./constants/work-managment-logos.js
var work_managment_logos = __webpack_require__(74329);
;// CONCATENATED MODULE: ./static/svg/header/platform/miro.svg
var miro_rect, miro_g, miro_defs;
function miro_extends() {
    miro_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return miro_extends.apply(this, arguments);
}

var SvgMiro = function SvgMiro(props) {
    return /*#__PURE__*/ react.createElement("svg", miro_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 40,
        fill: "none",
        viewBox: "0 0 40 40"
    }, props), miro_rect || (miro_rect = /*#__PURE__*/ react.createElement("rect", {
        width: 40,
        height: 40,
        fill: "#fff",
        rx: 4
    })), miro_g || (miro_g = /*#__PURE__*/ react.createElement("g", {
        clipPath: "url(#clip0_2274_200071)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#FFD02F",
        d: "M3 4h33v33H3z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#050038",
        d: "M25.487 7.4h-3.523l3.127 4.847L18.48 7.4h-3.523l3.127 6.352L11.473 7.4H7.95l3.076 8.2-3.076 16h3.523l6.611-17.156L14.957 31.6h3.523l6.611-18.66-3.127 18.66h3.523l6.663-20.497z"
    }))), miro_defs || (miro_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("clipPath", {
        id: "clip0_2274_200071"
    }, /*#__PURE__*/ react.createElement("rect", {
        width: 33,
        height: 33,
        x: 3,
        y: 3,
        fill: "#fff",
        rx: 4
    })))));
};
/* harmony default export */ var miro = (SvgMiro);

;// CONCATENATED MODULE: ./static/svg/header/platform/Tracket_1.svg
var Tracket_1_rect, Tracket_1_path;
function Tracket_1_extends() {
    Tracket_1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return Tracket_1_extends.apply(this, arguments);
}

var SvgTracket1 = function SvgTracket1(props) {
    return /*#__PURE__*/ react.createElement("svg", Tracket_1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 40,
        fill: "none",
        viewBox: "0 0 40 40"
    }, props), Tracket_1_rect || (Tracket_1_rect = /*#__PURE__*/ react.createElement("rect", {
        width: 40,
        height: 40,
        fill: "#fff",
        rx: 4
    })), Tracket_1_path || (Tracket_1_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#5A32FA",
        d: "m18.985 27.28-2.073 3.561a10 10 0 0 1-3.276-3.306l3.542-2.027a5.9 5.9 0 0 0 1.807 1.773M21.83 28.166v4.128c-1.657-.05-3.152-.464-4.53-1.226l2.075-3.564a5.9 5.9 0 0 0 2.455.662M30.523 17.354l-3.506 2.005a5.9 5.9 0 0 0-1.813-1.86l2.054-3.516a9.9 9.9 0 0 1 3.265 3.371M26.805 31.06a9.75 9.75 0 0 1-4.525 1.231v-4.125a5.9 5.9 0 0 0 2.453-.662zM30.46 27.527a9.95 9.95 0 0 1-3.267 3.306l-2.069-3.552a5.9 5.9 0 0 0 1.805-1.774zM31.88 22.684a9.9 9.9 0 0 1-1.197 4.452l-3.522-2.016a5.8 5.8 0 0 0 .692-2.436zM31.884 22.237H27.86a5.8 5.8 0 0 0-.624-2.48l3.507-2a9.9 9.9 0 0 1 1.14 4.48M21.152 12.53v1.799c0 1.18-.96 2.14-2.141 2.14h-2.773v5.064c0 .274.018 1.032.018 1.032.023.431.07.789.148 1.125.118.505.3.986.545 1.433l-3.537 2.023a9.8 9.8 0 0 1-1.198-4.593V16.47h-1.88A1.334 1.334 0 0 1 9 15.136V12.53h3.213v-2.228L16.238 8v4.53z"
    })));
};
/* harmony default export */ var Tracket_1 = (SvgTracket1);

// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
// EXTERNAL MODULE: ./utils/general.js
var general = __webpack_require__(56093);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./client/services/cluster-config-service/cluster-config-service.js
var cluster_config_service = __webpack_require__(79092);
// EXTERNAL MODULE: ./utils/url.js
var url = __webpack_require__(8339);
// EXTERNAL MODULE: ./segments/desktop/core-components/square-tags/square-tags.js + 4 modules
var square_tags = __webpack_require__(76416);
// EXTERNAL MODULE: ./constants/clusters.js
var clusters = __webpack_require__(16961);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button-consts.js
var button_consts = __webpack_require__(75650);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./client/services/hubspot-service/hubspot-constants.js
var hubspot_constants = __webpack_require__(22638);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-service.js
// Header menus data =================================================================
















// import BoardsColoredIcon from "static/svg/header/boards_colored.svg";









// import EnterpriseAgilityColoredIcon from "static/svg/header/enterprise_agility_colored.svg";


















// platform icons






























var PRODUCTS_MENU_ID = "products";
var USE_CASES_MENU_ID = "use-cases";
var FEATURES_MENU_ID = "features";
var RESOURCES_MENU_ID = "resources";
// structured header
var SOLUTIONS_MENU_ID = "solutions";
var TEAMS_MENU_ID = "teams";
var PLATFORM_MENU_ID = "platform";
var CUSTOMERS_MENU_ID = "customers";
var DESKTOP_HEADER_BASE_CLASS_NAME = "base-header-desktop-component";
var PRODUCTS_PRODUCTS_SECTION_ID = "products";
var PRODUCTS_MORE_SECTION_ID = "more";
var BY_TEAM_SECTION_ID = "by-team";
var BY_BUSINESS_SIZE_SECTION_ID = "by-business-size";
var BY_INDUSTRY_SECTION_ID = "by-industry";
var KEY_FEATURES_SECTION_ID = "key-features";
var INTEGRATIONS_SECTION_ID = "integrations";
var ADD_ONS_SECTION_ID = "add-ons";
var RESOURCES_LEARN_SECTION_ID = "learn";
var RESOURCES_CONNECT_SECTION_ID = "connect";
var RESOURCES_EXPLORE_SECTION_ID = "explore";
var RESOURCES_BUILD_SECTION_ID = "build";
var TOP_STORIES_SECTION_ID = "top-stories";
var GET_INVOLVED_SECTION_ID = "get-involved";
var LEADING_COMPANIES_SECTION_ID = "leading-companies";
var WORK_MANAGEMENT_SECTION_ID = "work-management";
var CRM_SECTION_ID = "crm";
var DEV_SECTION_ID = "dev";
var SERVICE_SECTION_ID = "service";
var ICON_TYPES = {
    fill: "fill",
    outline: "outline"
};
var MENU_SECTION_CLASSNAMES = {
    products: "products",
    mondayProducts: "mondayProducts",
    moreProducts: "moreProducts",
    useCases: "use-cases",
    features: "features",
    resources: "resources",
    integrations: "integrations",
    addOns: "addOns"
};
var MENU_SECTION_ITEM_TYPE = {
    base: "base",
    product: "product",
    secondaryProduct: "secondary-product",
    useCase: "use-case",
    useCaseByWorkflow: "use-case-by-workflow",
    feature: "feature",
    resource: "resource",
    story: "story",
    byTeam: "by-team",
    byIndustry: "by-industry",
    innerMenuBottomItem: "inner-menu-bottom-item",
    integration: "integration",
    addOn: "addOn"
};
var mobileProductsSectionMenuItems = [
    {
        id: PRODUCTS_PRODUCTS_SECTION_ID,
        title: "header.products.section.withWm.text.title",
        subtitle: "header.products.section.withWm.text.subtitle",
        mobileTitle: "header.products.section.products.mobileTitle",
        classname: MENU_SECTION_CLASSNAMES.mondayProducts,
        maxNumberOfItemsInColumn: 3,
        noSeparator: true,
        menuSectionItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.product,
                mobileIcon: wm_logo,
                icon: monday_work_management_square,
                iconStrokeColor: colors/* default.gainsboro */.Z.gainsboro,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.mondayWorkManagement.title",
                subtitle: "header.tabs.products.mondayWorkManagement.subtitle1",
                url: links/* WORK_MANAGEMENT_MINI_SITE_LINK */.ler,
                hoverBackgroundColor: (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], 0.16)
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.product,
                mobileIcon: mobile_crm_logo,
                icon: monday_crm_square/* default */.Z,
                iconStrokeColor: colors/* default.gainsboro */.Z.gainsboro,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.mondaySalesCRM.title",
                subtitle: "header.tabs.products.mondaySalesCRM.subtitle",
                url: links/* CRM_MINI_SITE_LINK */.mgz,
                hoverBackgroundColor: (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.CRM_GREEN_COLOR_NAME], 0.16),
                tags: {
                    title: "header.tabs.products.tags.title",
                    color: "#025050",
                    backgroundColor: (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.CRM_GREEN_COLOR_NAME], 0.16),
                    list: [
                        "header.tabs.products.mondaySalesCRM.tags.contactManagement",
                        "header.tabs.products.mondaySalesCRM.tags.salesPipeline",
                        "header.tabs.products.mondaySalesCRM.tags.leadManagement"
                    ]
                }
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.product,
                mobileIcon: dev_logo_new,
                icon: monday_dev_square/* default */.Z,
                iconStrokeColor: colors/* default.gainsboro */.Z.gainsboro,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.mondayDev.title",
                subtitle: "header.tabs.products.mondayDev.subtitle1",
                url: links/* SOFTWARE_MINI_SITE_LINK */.DDD,
                hoverBackgroundColor: (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.DEV_GREEN_COLOR_NAME], 0.16)
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.product,
                mobileIcon: service_logo,
                iconStrokeColor: colors/* default.gainsboro */.Z.gainsboro,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.mondayService.title",
                subtitle: "header.tabs.products.mondayService.subtitle",
                url: links/* SERVICE_MINI_SITE_LINK */.Kon,
                hoverBackgroundColor: (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.BRAND_SERVICE_PRIMARY_COLOR_NAME], 0.16),
                hasBetaTag: true
            }
        ]
    },
    {
        id: PRODUCTS_MORE_SECTION_ID,
        classname: MENU_SECTION_CLASSNAMES.moreProducts,
        title: "header.products.section.more",
        titleLine: true,
        menuSectionItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.secondaryProduct,
                icon: workforms_colored,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.more.workForms.title",
                url: links/* WORKFORMS_HOMEPAGE_LINK */.o2N,
                openInNewTab: true
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.secondaryProduct,
                icon: workcanvas_colored,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.more.workCanvas.title",
                url: links/* CANVAS_HOMEPAGE_LINK */.gOl,
                openInNewTab: true
            }
        ]
    }
];
var TAG_TYPES = {
    DEFAULT: "default",
    BULLET: "bullet"
};
var productsSectionMenuItems = [
    {
        id: PRODUCTS_PRODUCTS_SECTION_ID,
        title: "header.products.section.withWm.text.title",
        mobileTitle: "header.products.section.products.mobileTitle",
        classname: MENU_SECTION_CLASSNAMES.mondayProducts,
        maxNumberOfItemsInColumn: 3,
        noSeparator: true,
        menuSectionItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.product,
                mobileIcon: mobile_crm_logo,
                icon: monday_work_management_square,
                iconStrokeColor: colors/* default.gainsboro */.Z.gainsboro,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.mondayWorkManagement.title",
                subtitle: "header.tabs.products.mondayWorkManagement.subtitle1",
                url: links/* WORK_MANAGEMENT_MINI_SITE_LINK */.ler,
                hoverBackgroundColor: (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], 0.16),
                tags: {
                    title: "header.tabs.products.tags.title",
                    color: colors/* default */.Z[color_consts.DARK_WORK_OS_IRIS_COLOR_NAME],
                    backgroundColor: (0,general/* hexToRgba */.a7)("#babafd", 0.2),
                    list: [
                        "header.tabs.products.mondayWorkManagement.tags.projectAndTaskManagement",
                        "header.tabs.products.mondayWorkManagement.tags.operations",
                        "header.tabs.products.mondayWorkManagement.tags.buildYourOwn"
                    ]
                }
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.product,
                mobileIcon: mobile_crm_logo,
                icon: monday_crm_square/* default */.Z,
                iconStrokeColor: colors/* default.gainsboro */.Z.gainsboro,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.mondaySalesCRM.title",
                subtitle: "header.tabs.products.mondaySalesCRM.subtitle",
                url: links/* CRM_MINI_SITE_LINK */.mgz,
                hoverBackgroundColor: (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.CRM_GREEN_COLOR_NAME], 0.16),
                tags: {
                    title: "header.tabs.products.tags.title",
                    color: "#025050",
                    backgroundColor: (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.CRM_GREEN_COLOR_NAME], 0.16),
                    list: [
                        "header.tabs.products.mondaySalesCRM.tags.contactManagement",
                        "header.tabs.products.mondaySalesCRM.tags.salesPipeline",
                        "header.tabs.products.mondaySalesCRM.tags.leadManagement"
                    ]
                }
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.product,
                mobileIcon: dev_logo_new,
                icon: monday_dev_square/* default */.Z,
                iconStrokeColor: colors/* default.gainsboro */.Z.gainsboro,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.mondayDev.title",
                subtitle: "header.tabs.products.mondayDev.subtitle1",
                url: links/* SOFTWARE_MINI_SITE_LINK */.DDD,
                hoverBackgroundColor: (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.DEV_GREEN_COLOR_NAME], 0.16),
                tags: {
                    title: "header.tabs.products.tags.title",
                    color: "#015727",
                    backgroundColor: (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.DEV_GREEN_COLOR_NAME], 0.08),
                    list: [
                        "header.tabs.products.mondayDev.tags.roadmapPlanning",
                        "header.tabs.products.mondayDev.tags.bugTracking",
                        "header.tabs.products.mondayDev.tags.scrumAndKanban"
                    ]
                }
            }
        ]
    },
    {
        id: PRODUCTS_PRODUCTS_SECTION_ID,
        mobileTitle: "header.products.section.products.mobileTitle",
        classname: MENU_SECTION_CLASSNAMES.mondayProducts,
        maxNumberOfItemsInColumn: 3,
        menuSectionItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.product,
                mobileIcon: mobile_marketer_logo,
                icon: monday_marketer_square/* default */.Z,
                iconStrokeColor: colors/* default.gainsboro */.Z.gainsboro,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.mondayMarketer.title",
                subtitle: "header.tabs.products.mondayMarketer.subtitle",
                url: links/* MARKETING_MANAGEMENT_MINI_SITE_LINK */.Txj,
                hoverBackgroundColor: (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.MARKETING_RED_COLOR_NAME], 0.16),
                tags: {
                    title: "header.tabs.products.tags.title",
                    color: "#9A0550",
                    backgroundColor: (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.MARKETING_RED_COLOR_NAME], 0.08),
                    list: [
                        "header.tabs.products.mondayMarketer.tags.contentCalendar",
                        "header.tabs.products.mondayMarketer.tags.marketingStrategy",
                        "header.tabs.products.mondayMarketer.tags.creativeRequests"
                    ]
                }
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.product,
                mobileIcon: mobile_projects_logo,
                icon: monday_projects_square/* default */.Z,
                iconStrokeColor: colors/* default.gainsboro */.Z.gainsboro,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.mondayProjects.title",
                subtitle: "header.tabs.products.mondayProjects.subtitle",
                url: links/* PROJECT_MANAGEMENT_MINI_SITE_LINK */.JgV,
                hoverBackgroundColor: (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.PROJECTS_ORANGE_COLOR_NAME], 0.16),
                tags: {
                    title: "header.tabs.products.tags.title",
                    color: "#BC5004",
                    backgroundColor: (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.PROJECTS_ORANGE_COLOR_NAME], 0.08),
                    list: [
                        "header.tabs.products.mondayProjects.tags.advancedProjects",
                        "header.tabs.products.mondayProjects.tags.portfolioManagement",
                        "header.tabs.products.mondayProjects.tags.criticalPath"
                    ]
                }
            }
        ]
    },
    {
        id: PRODUCTS_MORE_SECTION_ID,
        classname: MENU_SECTION_CLASSNAMES.moreProducts,
        title: "header.products.section.more",
        titleLine: true,
        menuSectionItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.secondaryProduct,
                icon: workforms_colored,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.more.workForms.title",
                url: links/* WORKFORMS_HOMEPAGE_LINK */.o2N,
                openInNewTab: true
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.secondaryProduct,
                icon: workcanvas_colored,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.more.workCanvas.title",
                url: links/* CANVAS_HOMEPAGE_LINK */.gOl,
                openInNewTab: true
            }
        ]
    }
];
var useCasesSectionMenuItems = [
    {
        id: BY_TEAM_SECTION_ID,
        title: "header.useCases.section.byTeam",
        titleLine: true,
        classname: MENU_SECTION_CLASSNAMES.useCases,
        maxNumberOfItemsInColumn: 4,
        menuSectionItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.useCase,
                icon: marketing_colored,
                iconColor: color_consts.MARKETING_RED_COLOR_NAME,
                title: "header.tabs.workflows.byTeam.marketing",
                url: links/* WORK_MANAGEMENT_FOR_MARKETING_MINI_SITE_LINK */.qAD,
                outline: true
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.useCaseByWorkflow,
                icon: project_management_colored_2,
                title: "header.tabs.workflows.byWorkflow.projectManagement.title",
                description: "header.tabs.workflows.byWorkflow.projectManagement.description",
                url: links/* WORK_MANAGEMENT_FOR_PMO_MINI_SITE_LINK */.Y42
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.useCase,
                icon: sales_colored_1,
                iconColor: color_consts.CRM_GREEN_COLOR_NAME,
                title: "header.tabs.workflows.byTeam.sales",
                url: links/* CRM_MINI_SITE_LINK */.mgz,
                outline: true
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.useCase,
                icon: dev_colored,
                iconColor: color_consts.DEV_GREEN_COLOR_NAME,
                title: "header.tabs.teams.byTeam.productDevelopers",
                url: links/* SOFTWARE_MINI_SITE_LINK */.DDD,
                outline: true
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.useCase,
                icon: operations_colored,
                title: "header.tabs.workflows.byTeam.operations",
                url: links/* OPERATIONS_CLUSTER_LINK */.R9t,
                outline: true
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.useCase,
                icon: it_colored_1,
                title: "header.tabs.workflows.byTeam.it",
                url: links/* SERVICE_MINI_SITE_LINK */.Kon,
                outline: true
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.useCase,
                icon: hr_colored_1,
                title: "header.tabs.workflows.byTeam.hr",
                url: links/* HR_USE_CASES_LINK */.n$n,
                outline: true
            }
        ]
    },
    {
        id: BY_BUSINESS_SIZE_SECTION_ID,
        title: "header.useCases.section.byBusinessSize",
        titleLine: true,
        classname: MENU_SECTION_CLASSNAMES.useCases,
        maxNumberOfItemsInColumn: 4,
        menuSectionItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.useCase,
                icon: enterprise_colored_1,
                title: "header.tabs.workflows.byBusinessSize.enterprise",
                url: links/* ENTERPRISE_PAGE_LINK */.RVF
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.useCase,
                icon: small_business_colored_1,
                title: "header.tabs.workflows.byBusinessSize.smallBusiness",
                url: links/* SMB_PAGE_LINK */.qDl
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.useCase,
                icon: nonprofit_colored,
                title: "header.tabs.workflows.byBusinessSize.nonprofit",
                url: links/* NGO_PAGE_LINK */.htU
            }
        ]
    },
    {
        id: BY_INDUSTRY_SECTION_ID,
        title: "header.tabs.solutions.byTeam.industries.title",
        titleLine: true,
        classname: MENU_SECTION_CLASSNAMES.useCases,
        maxNumberOfItemsInColumn: 4,
        menuSectionItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.byIndustry,
                icon: retail_colored,
                hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                title: "header.tabs.solutions.byTeam.industries.retail.title",
                url: links/* RETAIL_PAGE_LINK */.fjW
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.byIndustry,
                icon: media_colored,
                hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                title: "header.tabs.solutions.byTeam.industries.media.title",
                url: links/* MEDIA_PAGE_LINK */.Dx_
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.byIndustry,
                icon: construction_colored,
                hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                title: "header.tabs.solutions.byTeam.industries.construction.title",
                url: links/* CONSTRUCTION_MINI_SITE_LINK */.ikI
            }
        ]
    }
];
var featuresSectionMenuItems = [
    {
        id: KEY_FEATURES_SECTION_ID,
        maxNumberOfItemsInColumn: 2,
        menuSectionItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.feature,
                icon: dashboards_colored,
                title: "header.tabs.features.keyFeatures.dashboards.title",
                description: "header.tabs.features.keyFeatures.dashboards.description",
                outline: true,
                url: links/* DASHBOARDS_PAGE_LINK */.yCu
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.feature,
                icon: integrations_colored,
                title: "header.tabs.features.keyFeatures.integrations.title",
                description: "header.tabs.features.keyFeatures.integrations.description",
                outline: true,
                url: links/* INTEGRATIONS_PAGE_LINK */.oUX
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.feature,
                icon: automations_colored,
                title: "header.tabs.features.keyFeatures.automations.title",
                description: "header.tabs.features.keyFeatures.automations.description",
                outline: true,
                url: links/* AUTOMATIONS_PAGE_LINK */.cPO
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.feature,
                icon: ai_icon,
                title: "header.tabs.features.keyFeatures.ai.title",
                description: "header.tabs.features.keyFeatures.ai.description",
                outline: true,
                url: links/* AI_PAGE_LINK */.lro
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.feature,
                icon: kanban_colored,
                title: "header.tabs.features.keyFeatures.kanban.title",
                description: "header.tabs.features.keyFeatures.kanban.description",
                outline: true,
                url: links/* KANBAN_PAGE_LINK */.ivN
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.feature,
                icon: docs_colored,
                title: "header.tabs.features.keyFeatures.docs.title",
                description: "header.tabs.features.keyFeatures.docs.description",
                outline: true,
                url: links/* WORKDOCS_PAGE_LINK */.RdE
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.feature,
                icon: gantt_colored,
                title: "header.tabs.features.keyFeatures.gantt.title",
                description: "header.tabs.features.keyFeatures.gantt.description",
                outline: true,
                url: links/* GANTT_PAGE_LINK */.TA3
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.feature,
                icon: forms_icon_new,
                title: "header.tabs.features.keyFeatures.forms.title",
                description: "header.tabs.features.keyFeatures.forms.description",
                outline: true,
                url: links/* FORMS_PAGE_LINK */.ua2
            }
        ]
    }
];
var resourcesSectionMenuItems = [
    {
        id: RESOURCES_LEARN_SECTION_ID,
        classname: MENU_SECTION_CLASSNAMES.resources,
        title: "header.tabs.resources.section.learn",
        titleLine: true,
        noSeparator: true,
        maxNumberOfItemsInColumn: 5,
        menuSectionItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.resource,
                title: "header.tabs.resources.learn.knowledgeBase.title",
                description: "header.tabs.resources.learn.knowledgeBase.description",
                url: links/* HELP_CENTER_LINK */.j3e
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.resource,
                title: "header.tabs.resources.learn.whatsNew.title",
                description: "header.tabs.resources.learn.whatsNew.description",
                url: links/* WHATS_NEW_PAGE_LINK */.Lmq
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.resource,
                title: "header.tabs.resources.learn.aboutUs.title",
                description: "header.tabs.resources.learn.aboutUs.description",
                url: links/* ABOUT_US_PAGE_LINK */.iAZ
            },
            // {
            //   itemType: MENU_SECTION_ITEM_TYPE.resource,
            //   title: "header.tabs.resources.learn.resourcesHub.title",
            //   description: "header.tabs.resources.learn.resourcesHub.description",
            // },
            {
                itemType: MENU_SECTION_ITEM_TYPE.resource,
                title: "header.tabs.resources.learn.blog.title",
                description: "header.tabs.resources.learn.blog.description",
                url: links/* BLOG_PAGE_LINK */.xR0
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.resource,
                title: "header.tabs.resources.connect.BuilderCertificationsText.title",
                description: "header.tabs.resources.connect.BuilderCertificationsText.description",
                url: links/* BUILDERS_CERTIFICATIONS_PAGE_LINK */.QHq
            }
        ]
    },
    {
        id: RESOURCES_CONNECT_SECTION_ID,
        title: "header.tabs.resources.section.connect",
        titleLine: true,
        noSeparator: true,
        maxNumberOfItemsInColumn: 5,
        menuSectionItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.resource,
                title: "header.tabs.resources.connect.support.title",
                description: "header.tabs.resources.connect.support.description",
                url: links/* SUPPORT_PAGE_LINK */.jX6
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.resource,
                title: "header.tabs.resources.connect.partners.title",
                description: "header.tabs.resources.connect.partners.description1",
                url: links/* PARTNERS_PAGE_LINK */.MW2
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.resource,
                title: "header.tabs.resources.connect.globalEvents.title",
                description: "header.tabs.resources.connect.globalEvents.description",
                url: links/* GLOBAL_EVENTS_PAGE_LINK */.O5z
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.resource,
                hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                title: "header.tabs.resources.connect.community.title",
                description: "header.tabs.resources.connect.community.description",
                url: links/* COMMUNITY_LINK */.gcb
            }
        ]
    },
    {
        id: RESOURCES_EXPLORE_SECTION_ID,
        title: "header.tabs.resources.section.build",
        titleLine: true,
        noSeparator: true,
        maxNumberOfItemsInColumn: 5,
        menuSectionItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.resource,
                title: "header.tabs.resources.explore.appsDeveloper.title",
                description: "header.tabs.resources.explore.appsDeveloper.description",
                url: links/* APPS_DEVELOPER_LINK */.FE7
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.resource,
                title: "header.tabs.resources.explore.templateCenter.title",
                description: "header.tabs.resources.explore.templateCenter.description1",
                url: links/* TEMPLATE_CENTER_PAGE_LINK */.EDy
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.resource,
                title: "header.tabs.resources.explore.spaces.title",
                description: "header.tabs.resources.explore.spaces.description",
                url: links/* MONDAY_SPACES_PAGE_LINK */.UN3
            }
        ]
    },
    {
        id: TOP_STORIES_SECTION_ID,
        title: "header.tabs.resources.section.customersStories",
        titleLine: true,
        noSeparator: true,
        maxNumberOfItemsInColumn: 2,
        backgroundColor: color_consts.BACKGROUND_GRAY_COLOR_NAME,
        hideOnMobile: true,
        menuSectionItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.story,
                hoverBackgroundColor: colors/* default */.Z[color_consts.WHITE_COLOR_NAME],
                imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/header/Header_asset.png",
                description: "header.tabs.resources.topStories.whyCustomersUse",
                url: links/* MONDAY_STORIES_PAGE */.Ce8,
                button: true
            }
        ]
    }
];
var solutionsMenu = {
    innerMenu: {
        items: [
            {
                id: "By product",
                title: "header.tabs.solutions.byProduct.title.byMonday",
                subItems: [
                    {
                        id: "Work management",
                        title: "header.tabs.solutions.byProduct.workManagement",
                        subtitle: "Run all aspects of work",
                        icon: wm_logo,
                        content: {
                            menuSections: [
                                {
                                    id: WORK_MANAGEMENT_SECTION_ID,
                                    title: "header.tabs.products.mondayWorkManagement.subtitle1",
                                    titleUrl: links/* WORK_MANAGEMENT_MINI_SITE_LINK */.ler,
                                    titleImage: work_managment_logos/* default.WM_BIGGER_DESKTOP_LOGO */.Z.WM_BIGGER_DESKTOP_LOGO,
                                    titleCTA: {
                                        title: "signup.learnMore",
                                        buttonType: button_consts/* REGULAR_BUTTON_TYPE */.ys,
                                        eventInfo: "learnMore",
                                        color: color_consts.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR_NAME,
                                        outline: true,
                                        buttonSize: sizes.SM,
                                        url: links/* WORK_MANAGEMENT_MINI_SITE_LINK */.ler
                                    },
                                    maxNumberOfItemsInColumn: 3,
                                    seeMoreItem: {
                                        title: "header.seeAllUseCases",
                                        eventInfo: "seeAll",
                                        url: links/* WORK_MANAGEMENT_MINI_SITE_LINK */.ler
                                    },
                                    menuSectionItems: [
                                        {
                                            title: "header.tabs.solutions.byProduct.workManagement.projectManagement.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.workManagement.projectManagement.description",
                                            url: (0,url.addParamToURL)(links/* WORK_MANAGEMENT_MINI_SITE_LINK */.ler, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.PROJECT_MANAGEMENT_USE_CASE)
                                        },
                                        {
                                            title: "header.tabs.solutions.byProduct.workManagement.taskManagement.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.workManagement.taskManagement.description",
                                            url: (0,url.addParamToURL)(links/* WORK_MANAGEMENT_MINI_SITE_LINK */.ler, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.TASK_MANAGEMENT)
                                        },
                                        {
                                            title: "header.tabs.solutions.byProduct.workManagement.resourceManagement.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.workManagement.resourceManagement.description",
                                            url: (0,url.addParamToURL)(links/* WORK_MANAGEMENT_MINI_SITE_LINK */.ler, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.RESOURCE_MANAGEMENT)
                                        },
                                        {
                                            title: "header.tabs.solutions.byProduct.workManagement.portfolioManagement.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.workManagement.portfolioManagement.description",
                                            url: (0,url.addParamToURL)(links/* WORK_MANAGEMENT_MINI_SITE_LINK */.ler, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.PORTFOLIO_MANAGEMENT)
                                        },
                                        {
                                            title: "header.tabs.solutions.byProduct.workManagement.businessOperations.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.workManagement.businessOperations.description",
                                            url: (0,url.addParamToURL)(links/* WORK_MANAGEMENT_MINI_SITE_LINK */.ler, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.BUSINESS_OPERATIONS)
                                        },
                                        {
                                            title: "header.tabs.solutions.byProduct.workManagement.goalsAndStrategy.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.workManagement.goalsAndStrategy.description",
                                            url: (0,url.addParamToURL)(links/* WORK_MANAGEMENT_MINI_SITE_LINK */.ler, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.STRATEGIC_PLANNING)
                                        }
                                    ]
                                },
                                {
                                    id: TOP_STORIES_SECTION_ID,
                                    title: "header.tabs.solutions.byProduct.workManagement.rightSection.title",
                                    maxNumberOfItemsInColumn: 1,
                                    backgroundColor: color_consts.WHITE_COLOR_NAME,
                                    menuSectionItems: [
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.story,
                                            backgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                                            imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/header/Wm_image.png",
                                            description: "header.tabs.solutions.byProduct.workManagement.rightSection.card.description",
                                            url: links/* TEMPLATE_CENTER_PAGE_LINK */.EDy,
                                            buttonText: "header.tabs.solutions.byProduct.workManagement.rightSection.card.buttonText.startWithAtemplate",
                                            button: true
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        id: "CRM",
                        title: "header.tabs.solutions.byProduct.crm",
                        subtitle: "Streamline sales processes",
                        icon: mobile_crm_logo,
                        content: {
                            menuSections: [
                                {
                                    id: CRM_SECTION_ID,
                                    title: "header.tabs.products.mondaySalesCRM.subtitle",
                                    titleUrl: links/* CRM_MINI_SITE_LINK */.mgz,
                                    titleImage: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/Yotam_Ron/logo-crm-only.png",
                                    titleCTA: {
                                        title: "signup.learnMore",
                                        outline: true,
                                        eventInfo: "learnMore",
                                        color: color_consts.CRM_DARK_TINT_01_COLOR_NAME,
                                        buttonType: button_consts/* REGULAR_BUTTON_TYPE */.ys,
                                        buttonSize: sizes.SM,
                                        url: links/* CRM_MINI_SITE_LINK */.mgz
                                    },
                                    maxNumberOfItemsInColumn: 3,
                                    seeMoreItem: {
                                        eventInfo: "seeAll",
                                        title: "header.seeAllUseCases",
                                        url: links/* CRM_MINI_SITE_LINK */.mgz
                                    },
                                    menuSectionItems: [
                                        {
                                            title: "header.tabs.solutions.byProduct.salesCRM.salesPipeline.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.salesCRM.salesPipeline.description",
                                            url: (0,url.addParamToURL)(links/* CRM_MINI_SITE_LINK */.mgz, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.SALES_PIPELINE)
                                        },
                                        {
                                            title: "header.tabs.solutions.byProduct.salesCRM.contactManagement.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.salesCRM.contactManagement.description",
                                            url: (0,url.addParamToURL)(links/* CRM_MINI_SITE_LINK */.mgz, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.CONTACT_MANAGEMENT)
                                        },
                                        {
                                            title: "header.tabs.solutions.byProduct.salesCRM.customerProjects.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.salesCRM.customerProjects.description",
                                            url: (0,url.addParamToURL)(links/* CRM_MINI_SITE_LINK */.mgz, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.CUSTOMER_PROJECTS)
                                        },
                                        {
                                            title: "header.tabs.solutions.byProduct.salesCRM.leadCapturing.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.salesCRM.leadCapturing.description",
                                            url: (0,url.addParamToURL)(links/* CRM_MINI_SITE_LINK */.mgz, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.LEADS_CAPTURING)
                                        },
                                        {
                                            title: "header.tabs.solutions.byProduct.salesCRM.leadManagement.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.salesCRM.leadManagement.description",
                                            url: (0,url.addParamToURL)(links/* CRM_MINI_SITE_LINK */.mgz, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.LEAD_MANAGEMENT)
                                        },
                                        {
                                            title: "header.tabs.solutions.byProduct.salesCRM.customerOnboarding.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.salesCRM.customerOnboarding.description",
                                            url: (0,url.addParamToURL)(links/* CRM_MINI_SITE_LINK */.mgz, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.CUSTOMER_ONBOARDING)
                                        }
                                    ]
                                },
                                {
                                    id: TOP_STORIES_SECTION_ID,
                                    title: "header.tabs.solutions.byProduct.crm.rightSection.title",
                                    maxNumberOfItemsInColumn: 1,
                                    backgroundColor: color_consts.WHITE_COLOR_NAME,
                                    menuSectionItems: [
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.story,
                                            backgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                                            imageSrc: "https://dapulse-res.cloudinary.com/image/upload/v1669619701/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/header/crm_image.png",
                                            description: "header.tabs.solutions.byProduct.crm.rightSection.card.description",
                                            url: links/* CRM_MINI_SITE_LINK */.mgz,
                                            buttonText: "header.tabs.solutions.byProduct.crm.rightSection.card.buttonText",
                                            button: true
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        id: "Dev",
                        title: "header.tabs.solutions.byProduct.dev",
                        subtitle: "Manage product lifecycles",
                        icon: dev_logo_new,
                        content: {
                            menuSections: [
                                {
                                    id: DEV_SECTION_ID,
                                    title: "header.tabs.products.mondayDev.subtitle1",
                                    titleUrl: links/* SOFTWARE_MINI_SITE_LINK */.DDD,
                                    titleImage: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/Dev_new_logo_July23/bigger-desktop_close_monday_dev_logo1.png",
                                    titleCTA: {
                                        title: "signup.learnMore",
                                        buttonType: button_consts/* REGULAR_BUTTON_TYPE */.ys,
                                        buttonSize: sizes.SM,
                                        outline: true,
                                        eventInfo: "learnMore",
                                        color: color_consts.BRAND_GREEN_DARK_TINT_01_COLOR_NAME,
                                        url: links/* SOFTWARE_MINI_SITE_LINK */.DDD
                                    },
                                    maxNumberOfItemsInColumn: 3,
                                    seeMoreItem: {
                                        eventInfo: "seeAll",
                                        title: "header.seeAllUseCases",
                                        url: links/* SOFTWARE_MINI_SITE_LINK */.DDD
                                    },
                                    menuSectionItems: [
                                        {
                                            title: "header.tabs.solutions.byProduct.dev.sprintManagement.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.dev.sprintManagement.description",
                                            url: (0,url.addParamToURL)(links/* SOFTWARE_MINI_SITE_LINK */.DDD, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.SPRINT_MANAGEMENT)
                                        },
                                        {
                                            title: "header.tabs.solutions.byProduct.dev.bugTracking.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.dev.bugTracking.description",
                                            url: (0,url.addParamToURL)(links/* SOFTWARE_MINI_SITE_LINK */.DDD, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.BUGS_TRACKING)
                                        },
                                        {
                                            title: "header.tabs.solutions.byProduct.dev.releasePlan.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.dev.releasePlan.description",
                                            url: (0,url.addParamToURL)(links/* SOFTWARE_MINI_SITE_LINK */.DDD, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.RELEASE_PLAN)
                                        },
                                        {
                                            title: "header.tabs.solutions.byProduct.dev.roadmapPlanning.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.dev.roadmapPlanning.description",
                                            url: (0,url.addParamToURL)(links/* SOFTWARE_MINI_SITE_LINK */.DDD, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.ROADMAP_PLANNING)
                                        },
                                        {
                                            title: "header.tabs.solutions.byProduct.dev.featureRequests.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.dev.featureRequests.description",
                                            url: (0,url.addParamToURL)(links/* SOFTWARE_MINI_SITE_LINK */.DDD, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.FEATURE_REQUESTS)
                                        },
                                        {
                                            title: "header.tabs.solutions.byProduct.dev.agileProjects.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.dev.agileProjects.description",
                                            url: (0,url.addParamToURL)(links/* SOFTWARE_MINI_SITE_LINK */.DDD, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.AGILE_PROJECTS)
                                        }
                                    ]
                                },
                                {
                                    id: TOP_STORIES_SECTION_ID,
                                    title: "header.tabs.solutions.byProduct.dev.rightSection.title",
                                    maxNumberOfItemsInColumn: 1,
                                    backgroundColor: color_consts.WHITE_COLOR_NAME,
                                    menuSectionItems: [
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.story,
                                            backgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                                            imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/header/dev_image.png",
                                            description: "header.tabs.solutions.byProduct.dev.rightSection.card.description",
                                            url: links/* SOFTWARE_MINI_SITE_LINK */.DDD,
                                            buttonText: "header.tabs.solutions.byProduct.dev.rightSection.card.buttonText",
                                            button: true
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        id: "Service",
                        title: "header.tabs.solutions.byProduct.service",
                        icon: service_logo,
                        hasBetaTag: true,
                        content: {
                            menuSections: [
                                {
                                    id: SERVICE_SECTION_ID,
                                    title: "header.tabs.products.mondayService.subtitle",
                                    titleUrl: links/* SERVICE_MINI_SITE_LINK */.Kon,
                                    titleImage: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/Yotam_Ron/service/Service-logo-h-26-header-V2.png",
                                    titleCTA: {
                                        title: "signup.learnMore",
                                        buttonType: button_consts/* REGULAR_BUTTON_TYPE */.ys,
                                        buttonSize: sizes.SM,
                                        outline: true,
                                        eventInfo: "learnMore",
                                        color: color_consts.BRAND_BLACK_TEXT_COLOR,
                                        url: links/* SERVICE_MINI_SITE_LINK */.Kon
                                    },
                                    maxNumberOfItemsInColumn: 3,
                                    seeMoreItem: {
                                        eventInfo: "seeAll",
                                        title: "header.seeAllUseCases",
                                        url: links/* SERVICE_MINI_SITE_LINK */.Kon
                                    },
                                    menuSectionItems: [
                                        {
                                            title: "header.tabs.solutions.byProduct.service.ticketManagement.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.service.ticketManagement.description",
                                            url: (0,url.addParamToURL)(links/* SERVICE_MINI_SITE_LINK */.Kon, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.TICKET_MANAGEMENT)
                                        },
                                        {
                                            title: "header.tabs.solutions.byProduct.service.employeeLifecycle.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.service.employeeLifecycle.description",
                                            url: (0,url.addParamToURL)(links/* SERVICE_MINI_SITE_LINK */.Kon, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.EMPLOYEE_LIFECYCLE)
                                        },
                                        {
                                            title: "header.tabs.solutions.byProduct.service.inventoryAndOrders.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.service.inventoryAndOrders.description",
                                            url: (0,url.addParamToURL)(links/* SERVICE_MINI_SITE_LINK */.Kon, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.INVENTORY_AND_ORDERS)
                                        },
                                        {
                                            title: "header.tabs.solutions.byProduct.service.customerPortal.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.service.customerPortal.description",
                                            url: (0,url.addParamToURL)(links/* SERVICE_MINI_SITE_LINK */.Kon, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.CUSTOMER_PORTAL)
                                        },
                                        {
                                            title: "header.tabs.solutions.byProduct.service.assetManagement.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.service.assetManagement.description",
                                            url: (0,url.addParamToURL)(links/* SERVICE_MINI_SITE_LINK */.Kon, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.ASSET_MANAGEMENT)
                                        },
                                        {
                                            title: "header.tabs.solutions.byProduct.service.serviceCatalog.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.service.serviceCatalog.description",
                                            url: (0,url.addParamToURL)(links/* SERVICE_MINI_SITE_LINK */.Kon, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.SERVICE_CATALOG)
                                        }
                                    ]
                                },
                                {
                                    id: TOP_STORIES_SECTION_ID,
                                    title: "header.tabs.solutions.byProduct.service.rightSection.title",
                                    maxNumberOfItemsInColumn: 1,
                                    backgroundColor: color_consts.WHITE_COLOR_NAME,
                                    menuSectionItems: [
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.story,
                                            backgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                                            imageSrc: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/Yotam_Ron/service/service-tn-v1.png",
                                            description: "header.tabs.solutions.byProduct.service.rightSection.card.description",
                                            url: links/* SERVICE_MINI_SITE_LINK */.Kon,
                                            buttonText: "header.tabs.solutions.byProduct.service.rightSection.card.buttonText",
                                            button: true
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                ]
            }
        ]
    },
    bottomPanel: {
        bottomItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.secondaryProduct,
                icon: workforms_colored,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.more.workForms.title",
                hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                url: links/* WORKFORMS_HOMEPAGE_LINK */.o2N,
                openInNewTab: true
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.secondaryProduct,
                icon: workcanvas_colored,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.more.workCanvas.title",
                hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                url: links/* CANVAS_HOMEPAGE_LINK */.gOl,
                openInNewTab: true
            }
        ]
    }
};
var teamsMenu = {
    innerMenu: {
        items: [
            {
                id: "By team",
                title: "header.tabs.solutions.byTeam.title",
                subItems: [
                    {
                        id: "Team type",
                        title: "header.tabs.solutions.byTeam.teamType",
                        icon: team,
                        content: {
                            menuSections: [
                                {
                                    id: BY_TEAM_SECTION_ID,
                                    title: "header.tabs.solutions.byTeam.teamType.title",
                                    maxNumberOfItemsInColumn: 4,
                                    withTitleUnderline: true,
                                    menuSectionItems: [
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.byTeam,
                                            icon: marketing_colored,
                                            iconColor: color_consts.MARKETING_RED_COLOR_NAME,
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            title: "header.tabs.workflows.byTeam.marketing",
                                            description: "header.tabs.solutions.byTeam.marketing.description",
                                            url: links/* WORK_MANAGEMENT_FOR_MARKETING_MINI_SITE_LINK */.qAD
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.byTeam,
                                            icon: dev_colored,
                                            iconColor: color_consts.DEV_GREEN_COLOR_NAME,
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            title: "header.tabs.solutions.byTeam.developers.title",
                                            description: "header.tabs.solutions.byTeam.developers.description",
                                            url: links/* SOFTWARE_MINI_SITE_LINK */.DDD
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.byTeam,
                                            icon: operations_colored,
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            title: "header.tabs.workflows.byTeam.operations",
                                            description: "header.tabs.solutions.byTeam.operations.description",
                                            url: links/* OPERATIONS_CLUSTER_LINK */.R9t
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.byTeam,
                                            icon: hr_colored_1,
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            title: "header.tabs.workflows.byTeam.hr",
                                            description: "header.tabs.solutions.byTeam.hr.description",
                                            url: links/* HR_USE_CASES_LINK */.n$n
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.byTeam,
                                            icon: sales_colored_1,
                                            iconColor: color_consts.CRM_GREEN_COLOR_NAME,
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            title: "header.tabs.workflows.byTeam.sales",
                                            description: "header.tabs.solutions.byTeam.sales.description",
                                            url: links/* CRM_MINI_SITE_LINK */.mgz
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.byTeam,
                                            icon: pmo_colored,
                                            iconColor: color_consts.PROJECTS_ORANGE_COLOR_NAME,
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byTeam.pmo.description",
                                            title: "header.tabs.workflows.byTeam.pmo",
                                            url: links/* WORK_MANAGEMENT_FOR_PMO_MINI_SITE_LINK */.Y42
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.byTeam,
                                            icon: it_colored_1,
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            title: "header.tabs.workflows.byTeam.it",
                                            description: "header.tabs.solutions.byTeam.it.description",
                                            url: links/* SERVICE_MINI_SITE_LINK */.Kon
                                        }
                                    ]
                                },
                                {
                                    id: TOP_STORIES_SECTION_ID,
                                    title: "header.tabs.resources.section.featuredStory",
                                    maxNumberOfItemsInColumn: 2,
                                    backgroundColor: color_consts.WHITE_COLOR_NAME,
                                    menuSectionItems: [
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.story,
                                            backgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                                            imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/header/blog.png",
                                            description: "header.tabs.solutions.byTeam.teamType.rightSection.card.description",
                                            url: links/* WORKLOAD_BLOG_PAGE_LINK */.Pqs,
                                            openInNewTab: true,
                                            buttonText: "header.tabs.solutions.byTeam.teamType.rightSection.card.buttonText",
                                            button: true
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        id: "Company size",
                        title: "header.tabs.solutions.byTeam.companySize",
                        icon: company,
                        content: {
                            menuSections: [
                                {
                                    id: BY_BUSINESS_SIZE_SECTION_ID,
                                    title: "header.tabs.solutions.byTeam.companySize.title",
                                    withTitleUnderline: true,
                                    classname: MENU_SECTION_CLASSNAMES.useCases,
                                    maxNumberOfItemsInColumn: 2,
                                    menuSectionItems: [
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.byTeam,
                                            icon: enterprise_colored_1,
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            title: "header.tabs.workflows.byBusinessSize.enterprise",
                                            description: "header.tabs.solutions.byTeam.companySize.enterprise.description",
                                            url: links/* ENTERPRISE_PAGE_LINK */.RVF
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.byTeam,
                                            icon: small_business_colored_1,
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            title: "header.tabs.solutions.byTeam.companySize.SMB.title",
                                            description: "header.tabs.solutions.byTeam.companySize.SMB.description",
                                            url: links/* SMB_PAGE_LINK */.qDl
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.byTeam,
                                            icon: nonprofit_colored,
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            title: "header.tabs.workflows.byBusinessSize.nonprofit",
                                            description: "header.tabs.solutions.byTeam.companySize.nonProfit.description",
                                            url: links/* NGO_PAGE_LINK */.htU
                                        }
                                    ]
                                },
                                {
                                    title: "header.tabs.solutions.byTeam.rightSection.title",
                                    maxNumberOfItemsInColumn: 1,
                                    backgroundColor: color_consts.WHITE_COLOR_NAME,
                                    menuSectionItems: [
                                        {
                                            id: TOP_STORIES_SECTION_ID,
                                            itemType: MENU_SECTION_ITEM_TYPE.story,
                                            backgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                                            imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/header/agile_enterprise.png",
                                            description: "header.tabs.solutions.byTeam.rightSection.card.description",
                                            url: links/* ENTERPRISE_AGILE_PAGE_LINK */.FdN,
                                            buttonText: "header.tabs.customers.section.rightSection.card.buttonText",
                                            button: true
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        id: "Industries",
                        title: "header.tabs.solutions.byTeam.industries",
                        icon: industry2,
                        content: {
                            menuSections: [
                                {
                                    id: BY_INDUSTRY_SECTION_ID,
                                    title: "header.tabs.solutions.byTeam.industries.title",
                                    withTitleUnderline: true,
                                    classname: MENU_SECTION_CLASSNAMES.useCases,
                                    maxNumberOfItemsInColumn: 2,
                                    menuSectionItems: [
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.byIndustry,
                                            icon: retail_colored,
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            title: "header.tabs.solutions.byTeam.industries.retail.title",
                                            description: "header.tabs.solutions.byTeam.industries.retail.description",
                                            url: links/* RETAIL_PAGE_LINK */.fjW
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.byIndustry,
                                            icon: construction_colored,
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            title: "header.tabs.solutions.byTeam.industries.construction.title",
                                            description: "header.tabs.solutions.byTeam.industries.construction.description",
                                            url: links/* CONSTRUCTION_MINI_SITE_LINK */.ikI
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.byIndustry,
                                            icon: media_colored,
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            title: "header.tabs.solutions.byTeam.industries.media.title",
                                            description: "header.tabs.solutions.byTeam.industries.media.description",
                                            url: links/* MEDIA_PAGE_LINK */.Dx_
                                        }
                                    ]
                                },
                                {
                                    title: "header.tabs.solutions.byTeam.industries.rightSection.title",
                                    maxNumberOfItemsInColumn: 1,
                                    backgroundColor: color_consts.WHITE_COLOR_NAME,
                                    menuSectionItems: [
                                        {
                                            id: TOP_STORIES_SECTION_ID,
                                            itemType: MENU_SECTION_ITEM_TYPE.story,
                                            backgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                                            imageSrc: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/Yotam_Ron/200324-retail/retail-header-tn-v2.png",
                                            description: "header.tabs.solutions.byTeam.industries.rightSection.description",
                                            url: (0,url.addParamToURL)(links/* CONTACT_SALES_PAGE_LINK */.yMV, hubspot_constants/* URL_PARAM_FROM */.sy, "industries"),
                                            buttonText: "header.tabs.solutions.byTeam.industries.rightSection.buttonText",
                                            button: true
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                ]
            }
        ]
    },
    bottomPanel: {
        bottomItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.secondaryProduct,
                icon: workforms_colored,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.more.workForms.title",
                hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                url: links/* WORKFORMS_HOMEPAGE_LINK */.o2N,
                openInNewTab: true
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.secondaryProduct,
                icon: workcanvas_colored,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.more.workCanvas.title",
                hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                url: links/* CANVAS_HOMEPAGE_LINK */.gOl,
                openInNewTab: true
            }
        ]
    }
};
var platformMenu = {
    innerMenu: {
        items: [
            {
                id: "The platform",
                title: "header.tabs.platform.thePlatform",
                subItems: [
                    {
                        id: "Key features",
                        title: "header.tabs.platform.keyFeatures.title",
                        icon: keyFeatures,
                        content: {
                            menuSections: [
                                {
                                    id: KEY_FEATURES_SECTION_ID,
                                    title: "header.tabs.platform.keyFeatures.create.title",
                                    withTitleUnderline: true,
                                    classname: MENU_SECTION_CLASSNAMES.features,
                                    maxNumberOfItemsInColumn: 4,
                                    menuSectionItems: [
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.feature,
                                            icon: dashboards_colored,
                                            title: "header.tabs.features.keyFeatures.dashboards.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.features.keyFeatures.dashboards.description",
                                            url: links/* DASHBOARDS_PAGE_LINK */.yCu
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.feature,
                                            icon: integrations_colored,
                                            title: "header.tabs.features.keyFeatures.integrations.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.features.keyFeatures.integrations.description",
                                            url: links/* INTEGRATIONS_PAGE_LINK */.oUX
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.feature,
                                            icon: automations_colored,
                                            title: "header.tabs.features.keyFeatures.automations.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.features.keyFeatures.automations.description",
                                            url: links/* AUTOMATIONS_PAGE_LINK */.cPO
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.feature,
                                            icon: ai_icon,
                                            title: "header.tabs.features.keyFeatures.ai.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.features.keyFeatures.ai.description",
                                            url: links/* AI_PAGE_LINK */.lro
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.feature,
                                            icon: kanban_colored,
                                            title: "header.tabs.features.keyFeatures.kanban.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.features.keyFeatures.kanban.description",
                                            url: links/* KANBAN_PAGE_LINK */.ivN
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.feature,
                                            icon: docs_colored,
                                            title: "header.tabs.features.keyFeatures.docs.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.features.keyFeatures.docs.description",
                                            url: links/* WORKDOCS_PAGE_LINK */.RdE
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.feature,
                                            icon: gantt_colored,
                                            title: "header.tabs.features.keyFeatures.gantt.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.features.keyFeatures.gantt.description",
                                            url: links/* GANTT_PAGE_LINK */.TA3
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.feature,
                                            icon: forms_icon_new,
                                            title: "header.tabs.features.keyFeatures.forms.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.features.keyFeatures.forms.description",
                                            url: links/* FORMS_PAGE_LINK */.ua2
                                        }
                                    ]
                                },
                                {
                                    id: TOP_STORIES_SECTION_ID,
                                    title: "header.tabs.platform.keyFeatures.rightSection.title",
                                    maxNumberOfItemsInColumn: 1,
                                    backgroundColor: color_consts.WHITE_COLOR_NAME,
                                    menuSectionItems: [
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.story,
                                            backgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                                            imageSrc: "https://dapulse-res.cloudinary.com/image/upload/v1669716137/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/header/byateam_image.png",
                                            url: links/* COMPARE_LINK */.zB0,
                                            description: "header.tabs.platform.keyFeatures.rightSection.card.description",
                                            button: true,
                                            buttonText: "header.tabs.customers.section.rightSection.card.buttonText"
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        id: "Integrations",
                        title: "Integrations",
                        icon: integrations_1,
                        content: {
                            title: "header.tabs.platform.integrations.connect.title",
                            menuSections: [
                                {
                                    id: INTEGRATIONS_SECTION_ID,
                                    classname: MENU_SECTION_CLASSNAMES.integrations,
                                    title: "header.tabs.platform.integrations.connect.forDevelopment.title",
                                    maxNumberOfItemsInColumn: 4,
                                    noSeparator: true,
                                    seeMoreItem: {
                                        title: "header.tabs.platform.integrations.connect.buttonText",
                                        url: links/* INTEGRATIONS_APPS_LINK */.Ccw
                                    },
                                    menuSectionItems: [
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.integration,
                                            icon: github,
                                            iconType: ICON_TYPES.fill,
                                            title: "header.tabs.platform.integrations.connect.forDevelopment.gitHub",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* APPS_GITHUB_LINK */.BK3
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.integration,
                                            icon: jira_1,
                                            iconType: ICON_TYPES.fill,
                                            title: "header.tabs.platform.integrations.connect.forDevelopment.jiraCloud",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* APPS_JIRA_CLOUD_LINK */.LJp
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.integration,
                                            icon: pagerduty_1,
                                            iconType: ICON_TYPES.fill,
                                            title: "header.tabs.platform.integrations.connect.forDevelopment.pagerDuty",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* APPS_PAGER_DUTY_LINK */.qM
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.integration,
                                            icon: gitlab_1,
                                            iconType: ICON_TYPES.fill,
                                            title: "header.tabs.platform.integrations.connect.forDevelopment.gitLab",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* APPS_GITLAB_LINK */.LcP
                                        }
                                    ]
                                },
                                {
                                    id: INTEGRATIONS_SECTION_ID,
                                    classname: MENU_SECTION_CLASSNAMES.integrations,
                                    title: "header.tabs.platform.integrations.connect.forMarketing.title",
                                    noSeparator: true,
                                    maxNumberOfItemsInColumn: 4,
                                    menuSectionItems: [
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.integration,
                                            icon: mailchimp,
                                            iconType: ICON_TYPES.fill,
                                            title: "header.tabs.platform.integrations.connect.forMarketing.mailchimp",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* APPS_MAILCHIMP_LINK */.rG7
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.integration,
                                            icon: hubspot,
                                            iconType: ICON_TYPES.fill,
                                            title: "header.tabs.platform.integrations.connect.forMarketing.hubSpot",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* APPS_HUBSPOT_LINK */.g0b
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.integration,
                                            icon: surveymonkey,
                                            iconType: ICON_TYPES.fill,
                                            title: "header.tabs.platform.integrations.connect.forMarketing.surveyMonkey",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* APPS_SURVEY_MONKEY_LINK */.yZo
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.integration,
                                            icon: googleads_1,
                                            iconType: ICON_TYPES.fill,
                                            title: "header.tabs.platform.integrations.connect.forMarketing.googleAds",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* APPS_ADS_LINK */.C83
                                        }
                                    ]
                                },
                                {
                                    id: INTEGRATIONS_SECTION_ID,
                                    classname: MENU_SECTION_CLASSNAMES.integrations,
                                    title: "header.tabs.platform.integrations.connect.forCollaboration.title",
                                    noSeparator: true,
                                    maxNumberOfItemsInColumn: 4,
                                    menuSectionItems: [
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.integration,
                                            icon: zoom_1,
                                            iconType: ICON_TYPES.fill,
                                            title: "header.tabs.platform.integrations.connect.forCollaboration.zoom",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* APPS_ZOOM_LINK */.sxP
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.integration,
                                            icon: drive,
                                            iconType: ICON_TYPES.fill,
                                            title: "header.tabs.platform.integrations.connect.forCollaboration.googleDrive",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* APPS_DRIVE_LINK */.vcQ
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.integration,
                                            icon: mt_1,
                                            iconType: ICON_TYPES.fill,
                                            title: "header.tabs.platform.integrations.connect.forCollaboration.microsoftTeams",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* APPS_TEAMS_LINK */.pTo
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.integration,
                                            icon: slack_1,
                                            iconType: ICON_TYPES.fill,
                                            title: "header.tabs.platform.integrations.connect.forCollaboration.slack",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* APPS_SLACK_LINK */.fiz
                                        }
                                    ]
                                },
                                {
                                    id: INTEGRATIONS_SECTION_ID,
                                    classname: MENU_SECTION_CLASSNAMES.integrations,
                                    title: "header.tabs.platform.integrations.connect.forCommunication.title",
                                    noSeparator: true,
                                    maxNumberOfItemsInColumn: 4,
                                    menuSectionItems: [
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.integration,
                                            title: "header.tabs.platform.integrations.connect.forCommunication.outlook",
                                            icon: outlook,
                                            iconType: ICON_TYPES.fill,
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* APPS_OUTLOOK_LINK */.Hqq
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.integration,
                                            icon: gmail,
                                            iconType: ICON_TYPES.fill,
                                            title: "header.tabs.platform.integrations.connect.forCommunication.gmail",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* APPS_GMAIL_LINK */.RtI
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.integration,
                                            icon: zendesk,
                                            iconType: ICON_TYPES.fill,
                                            title: "header.tabs.platform.integrations.connect.forCommunication.zendesk",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* APPS_ZENDESK_LINK */.qQP
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.integration,
                                            icon: twilio_1,
                                            iconType: ICON_TYPES.fill,
                                            title: "header.tabs.platform.integrations.connect.forCommunication.twilio",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* APPS_TWILIO_LINK */.z6N
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        id: "Add-ons",
                        title: "Add-ons",
                        icon: addOns_1,
                        content: {
                            title: "header.tabs.platform.addOns.extend.title",
                            menuSections: [
                                {
                                    id: ADD_ONS_SECTION_ID,
                                    classname: MENU_SECTION_CLASSNAMES.addOns,
                                    title: "header.tabs.platform.addOns.extend.popular.title",
                                    maxNumberOfItemsInColumn: 4,
                                    noSeparator: true,
                                    seeMoreItem: {
                                        title: "header.tabs.platform.addOns.extend.buttonText",
                                        url: links/* APPS_MARKETPLACE_LINK */.IHo
                                    },
                                    menuSectionItems: [
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.addOn,
                                            icon: miro,
                                            iconType: ICON_TYPES.fill,
                                            iconStrokeColor: colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_LIGHTER_TINT_01],
                                            title: "header.tabs.platform.addOns.extend.popular.miro",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* MIRO_APP_PAGE_LINK */.goo
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.addOn,
                                            imageSrc: "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/remote_mondaycom_static/svg/header/platform/DocuGen.svg",
                                            title: "header.tabs.platform.addOns.extend.popular.docuGen",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* DOCU_GEN_APP_PAGE_LINK */.nIm
                                        }
                                    ]
                                },
                                {
                                    id: ADD_ONS_SECTION_ID,
                                    classname: MENU_SECTION_CLASSNAMES.addOns,
                                    title: "header.tabs.platform.addOns.extend.forMarketing.title",
                                    noSeparator: true,
                                    maxNumberOfItemsInColumn: 4,
                                    menuSectionItems: [
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.addOn,
                                            imageSrc: "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/remote_mondaycom_static/svg/header/platform/Easyform.svg",
                                            title: "header.tabs.platform.addOns.extend.forMarketing.easyform",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* EASYFORM_APP_PAGE_LINK */.L3E
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.addOn,
                                            imageSrc: "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/remote_mondaycom_static/svg/header/platform/Figma.svg",
                                            title: "header.tabs.platform.addOns.extend.forMarketing.figma",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* FIGMA_APP_PAGE_LINK */.wxc
                                        }
                                    ]
                                },
                                {
                                    id: ADD_ONS_SECTION_ID,
                                    classname: MENU_SECTION_CLASSNAMES.addOns,
                                    title: "header.tabs.platform.addOns.extend.forTeamManagement.title",
                                    noSeparator: true,
                                    maxNumberOfItemsInColumn: 4,
                                    menuSectionItems: [
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.addOn,
                                            icon: Tracket_1,
                                            iconType: ICON_TYPES.fill,
                                            iconStrokeColor: colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_LIGHTER_TINT_01],
                                            title: "header.tabs.platform.addOns.extend.forTeamManagement.tracket",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* TRACKET_APP_PAGE_LINK */.epH
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.addOn,
                                            imageSrc: "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/remote_mondaycom_static/svg/header/platform/Team_View.svg",
                                            title: "header.tabs.platform.addOns.extend.forTeamManagement.teamView",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* TEAM_VIEW_APP_PAGE_LINK */.Oek
                                        }
                                    ]
                                },
                                {
                                    id: ADD_ONS_SECTION_ID,
                                    classname: MENU_SECTION_CLASSNAMES.addOns,
                                    title: "header.tabs.platform.addOns.extend.forProductivity.title",
                                    noSeparator: true,
                                    maxNumberOfItemsInColumn: 4,
                                    menuSectionItems: [
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.addOn,
                                            title: "header.tabs.platform.addOns.extend.forProductivity.1View",
                                            imageSrc: "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/remote_mondaycom_static/svg/header/platform/1View.svg",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* ONE_VIEW_APP_PAGE_LINK */.U6d
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.integration,
                                            imageSrc: "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/remote_mondaycom_static/svg/header/platform/Approvals.svg",
                                            title: "header.tabs.platform.addOns.extend.forProductivity.approvals",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* APPROVALS_APP_PAGE_LINK */.Wkm
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                ]
            }
        ],
        bottomItem: {
            itemType: MENU_SECTION_ITEM_TYPE.innerMenuBottomItem,
            title: "header.tabs.platform.whyWorkOS.title",
            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
            description: "header.tabs.platform.whyWorkOS.description",
            url: links/* WHY_WORK_OS_LINK */.kpx,
            openInNewTab: true
        }
    }
};
var customersMenu = {
    content: {
        menuSections: [
            {
                id: LEADING_COMPANIES_SECTION_ID,
                title: "header.tabs.customers.section.leadingCompanies",
                noSeparator: true,
                withTitleUnderline: true,
                maxNumberOfItemsInColumn: 2,
                seeMoreItem: {
                    title: "header.tabs.customers.section.leadingCompanies.buttonText",
                    url: links/* CUSTOMERS_PAGE_LINK */.iN6
                },
                menuSectionItems: [
                    {
                        title: "header.tabs.customers.section.leadingCompanies.zippo.title",
                        hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                        description: "header.tabs.customers.section.leadingCompanies.zippo.description",
                        url: links/* ZIPPO_CUSTOMER_PAGE_LINK */.$UX
                    },
                    {
                        title: "header.tabs.customers.section.leadingCompanies.nissan.title",
                        hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                        description: "header.tabs.customers.section.leadingCompanies.nissan.description",
                        url: links/* NISSAN_CUSTOMER_PAGE_LINK */.$0S
                    },
                    {
                        title: "header.tabs.customers.section.leadingCompanies.softwareAG.title",
                        hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                        description: "header.tabs.customers.section.leadingCompanies.softwareAG.description",
                        url: links/* SOFTWARE_AG_CUSTOMER_PAGE_LINK */.q4d
                    },
                    {
                        title: "header.tabs.customers.section.leadingCompanies.farfetch.title",
                        hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                        description: "header.tabs.customers.section.leadingCompanies.farfetch.description",
                        url: links/* FARFETCH_CUSTOMER_PAGE_LINK */.ZsN
                    }
                ]
            },
            {
                id: GET_INVOLVED_SECTION_ID,
                title: "header.tabs.customers.section.getInvolved",
                withTitleUnderline: true,
                maxNumberOfItemsInColumn: 2,
                menuSectionItems: [
                    {
                        title: "header.tabs.customers.section.getInvolved.community.title",
                        hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                        description: "header.tabs.customers.section.getInvolved.community.description",
                        url: links/* COMMUNITY_LINK */.gcb,
                        openInNewTab: true
                    },
                    {
                        title: "header.tabs.customers.section.getInvolved.reviews.title",
                        hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                        description: "header.tabs.customers.section.getInvolved.reviews.description",
                        url: links/* G2_WRITE_A_REVIEW_PAGE_LINK */.jHu,
                        openInNewTab: true
                    }
                ]
            },
            {
                id: TOP_STORIES_SECTION_ID,
                title: "header.tabs.customers.section.rightSection.title",
                maxNumberOfItemsInColumn: 1,
                backgroundColor: color_consts.BACKGROUND_GRAY_COLOR_NAME,
                menuSectionItems: [
                    {
                        itemType: MENU_SECTION_ITEM_TYPE.story,
                        backgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                        hoverBackgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/header/efficiency_image.png",
                        description: "header.tabs.customers.section.rightSection.card.description",
                        url: links/* EFFICIENCY_IMPACT_PAGE_LINK */.Lip,
                        openInNewTab: true,
                        button: true,
                        buttonText: "header.tabs.customers.section.rightSection.card.buttonText"
                    }
                ]
            }
        ]
    },
    bottomPanel: {
        isSocialProofDisplayed: true
    }
};
var resourcesMenu = {
    content: {
        menuSections: [
            {
                id: RESOURCES_LEARN_SECTION_ID,
                title: "header.tabs.resources.section.learn",
                noSeparator: true,
                withTitleUnderline: true,
                maxNumberOfItemsInColumn: 5,
                menuSectionItems: [
                    {
                        itemType: MENU_SECTION_ITEM_TYPE.resource,
                        hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                        title: "header.tabs.resources.learn.knowledgeBase.title",
                        description: "header.tabs.resources.learn.knowledgeBase.description",
                        url: links/* HELP_CENTER_LINK */.j3e
                    },
                    {
                        itemType: MENU_SECTION_ITEM_TYPE.resource,
                        title: "header.tabs.resources.learn.whatsNew.newTitle",
                        description: "header.tabs.resources.learn.whatsNew.description",
                        isPopular: true,
                        badgeText: "header.menuItem.new",
                        badgeColorName: color_consts.WORK_OS_IRIS_COLOR_NAME,
                        badgeTextColorName: color_consts.WHITE_COLOR_NAME,
                        badgeStrokeColorName: "transparent",
                        url: links/* WHATS_NEW_PAGE_LINK */.Lmq
                    },
                    {
                        itemType: MENU_SECTION_ITEM_TYPE.resource,
                        hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                        title: "header.tabs.resources.learn.aboutUs.title",
                        description: "header.tabs.resources.learn.aboutUs.description",
                        url: links/* ABOUT_US_PAGE_LINK */.iAZ
                    },
                    {
                        itemType: MENU_SECTION_ITEM_TYPE.resource,
                        hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                        title: "header.tabs.resources.learn.blog.title",
                        description: "header.tabs.resources.learn.blog.description",
                        url: "header.blog"
                    },
                    {
                        itemType: MENU_SECTION_ITEM_TYPE.resource,
                        title: "header.tabs.resources.connect.BuilderCertificationsText.title",
                        description: "header.tabs.resources.connect.BuilderCertificationsText.description",
                        url: links/* BUILDERS_CERTIFICATIONS_PAGE_LINK */.QHq
                    }
                ]
            },
            {
                id: RESOURCES_CONNECT_SECTION_ID,
                title: "header.tabs.resources.section.connect",
                noSeparator: true,
                withTitleUnderline: true,
                maxNumberOfItemsInColumn: 4,
                menuSectionItems: [
                    {
                        itemType: MENU_SECTION_ITEM_TYPE.resource,
                        hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                        title: "header.tabs.resources.connect.support.title",
                        description: "header.tabs.resources.connect.support.description",
                        url: links/* SUPPORT_PAGE_LINK */.jX6
                    },
                    {
                        itemType: MENU_SECTION_ITEM_TYPE.resource,
                        hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                        title: "header.tabs.resources.connect.partners.title",
                        description: "header.tabs.resources.connect.partners.description1",
                        url: links/* PARTNERS_PAGE_LINK */.MW2
                    },
                    {
                        itemType: MENU_SECTION_ITEM_TYPE.resource,
                        hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                        title: "header.tabs.resources.connect.globalEvents.title",
                        description: "header.tabs.resources.connect.globalEvents.description",
                        url: links/* GLOBAL_EVENTS_PAGE_LINK */.O5z
                    },
                    {
                        itemType: MENU_SECTION_ITEM_TYPE.resource,
                        hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                        title: "header.tabs.resources.connect.community.title",
                        description: "header.tabs.resources.connect.community.description",
                        url: links/* COMMUNITY_LINK */.gcb
                    }
                ]
            },
            {
                id: RESOURCES_BUILD_SECTION_ID,
                title: "header.tabs.resources.section.build",
                withTitleUnderline: true,
                maxNumberOfItemsInColumn: 3,
                menuSectionItems: [
                    {
                        itemType: MENU_SECTION_ITEM_TYPE.resource,
                        hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                        title: "header.tabs.resources.explore.appsDeveloper.title",
                        description: "header.tabs.resources.explore.appsDeveloper.description",
                        url: links/* APPS_DEVELOPER_LINK */.FE7
                    },
                    {
                        itemType: MENU_SECTION_ITEM_TYPE.resource,
                        hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                        title: "header.tabs.resources.explore.templateCenter.title",
                        description: "header.tabs.resources.explore.templateCenter.description1",
                        url: links/* TEMPLATE_CENTER_PAGE_LINK */.EDy
                    },
                    {
                        itemType: MENU_SECTION_ITEM_TYPE.resource,
                        hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                        title: "header.tabs.resources.explore.spaces.title",
                        description: "header.tabs.resources.explore.spaces.description",
                        url: links/* MONDAY_SPACES_PAGE_LINK */.UN3
                    }
                ]
            },
            {
                id: TOP_STORIES_SECTION_ID,
                title: "header.tabs.resources.section.successStories",
                maxNumberOfItemsInColumn: 2,
                backgroundColor: color_consts.WHITE_COLOR_NAME,
                menuSectionItems: [
                    {
                        itemType: MENU_SECTION_ITEM_TYPE.story,
                        backgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                        hoverBackgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/header/Customer%20tab/nissan.png",
                        description: "header.tabs.resources.topStories.howCustomersEmpowers",
                        imageFloatingCaption: "header.tabs.resources.topStories.savedPerMonth",
                        url: links/* MONDAY_STORIES_PAGE */.Ce8,
                        button: true,
                        buttonText: "header.menuItem.button.exploreAllCustomerStories"
                    },
                    {
                        itemType: MENU_SECTION_ITEM_TYPE.story,
                        backgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                        hoverBackgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/header/Customer%20tab/efficency.png",
                        description: "header.tabs.resources.topStories.discoverEfficiency",
                        url: links/* EFFICIENCY_IMPACT_PAGE_LINK */.Lip,
                        button: true,
                        buttonText: "header.menuItem.button.exploreAllUseCases"
                    }
                ]
            }
        ]
    }
};
var _obj;
/** * Structured Header sections definitions - End ** */ var StructuredHeaderMenuComponentMapping = (_obj = {}, (0,_define_property/* default */.Z)(_obj, SOLUTIONS_MENU_ID, "StructuredHeaderMenuComponent"), (0,_define_property/* default */.Z)(_obj, TEAMS_MENU_ID, "StructuredHeaderMenuComponent"), (0,_define_property/* default */.Z)(_obj, PLATFORM_MENU_ID, "StructuredHeaderMenuComponent"), (0,_define_property/* default */.Z)(_obj, CUSTOMERS_MENU_ID, "StructuredHeaderMenuComponent"), (0,_define_property/* default */.Z)(_obj, RESOURCES_MENU_ID, "StructuredHeaderMenuComponent"), _obj);
var _obj1;
var SectionsHeadersMenuItemsMapping = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, PRODUCTS_MENU_ID, productsSectionMenuItems), (0,_define_property/* default */.Z)(_obj1, USE_CASES_MENU_ID, useCasesSectionMenuItems), (0,_define_property/* default */.Z)(_obj1, FEATURES_MENU_ID, featuresSectionMenuItems), (0,_define_property/* default */.Z)(_obj1, RESOURCES_MENU_ID, resourcesSectionMenuItems), _obj1);
var _obj2;
var StructuredHeaderMenuMapping = (_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, SOLUTIONS_MENU_ID, solutionsMenu), (0,_define_property/* default */.Z)(_obj2, TEAMS_MENU_ID, teamsMenu), (0,_define_property/* default */.Z)(_obj2, PLATFORM_MENU_ID, platformMenu), (0,_define_property/* default */.Z)(_obj2, CUSTOMERS_MENU_ID, customersMenu), (0,_define_property/* default */.Z)(_obj2, RESOURCES_MENU_ID, resourcesMenu), _obj2);
// ===========================================================================================
// Header service functions
var isDesktopMinisiteSecondaryMenuActive = function() {
    var headerElement = document.querySelector(".".concat(DESKTOP_HEADER_BASE_CLASS_NAME));
    if (!headerElement) return false;
    return headerElement.classList.contains("scroll-started") && !headerElement.classList.contains("scrolled-threshold");
};
var shouldRenderSecondaryMenu = function(isClusterMiniSitePage, pageClusterConfig, useProductMiniSiteConfig) {
    return isClusterMiniSitePage && (0,cluster_config_service/* isMiniSiteConfigValid */.cJ)(pageClusterConfig, {
        useProductMiniSiteConfig: useProductMiniSiteConfig
    });
};


/***/ }),

/***/ 72428:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    BASIC_HEADER_HEIGHT: 72,
    SECONDARY_HEADER_HEIGHT: 56,
    HEADER_CONTENT_HORIZONTAL_PADDING: 32,
    MOBILE_MINI_SITE_BASIC_HEADER_HEIGHT: 52,
    MOBILE_MINI_SITE_SECONDARY_HEADER_HEIGHT: 44,
    SIGNUP_POPUP_SCREEN_RIGHT_MARGIN: 16,
    SIGNUP_POPUP_SCREEN_WIDTH: 346,
    SIGNUP_POPUP_SCREEN_HEIGHT: 404,
    PRODUCTS_SWITCHER_SCREEN_WIDTH: 300,
    PRODUCTS_SWITCHER_NEW_USERS_SCREEN_HEIGHT: 375,
    PRODUCTS_SWITCHER_EXISTING_USERS_SCREEN_HEIGHT: 270,
    PRODUCTS_SWITCHER_SCREEN_RIGHT_MARGIN: 32
});


/***/ }),

/***/ 6941:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
var CONTACT_SALES_REGIONS = (__webpack_require__(31766).CONTACT_SALES_REGIONS);
// DEFAULT
var DEFAULT_NO_SDR_TYPE = "DEFAULT_NO_SDR";
// TEST
var TEST_REGION_TYPE = "TEST_SALES_ONLY";
// *****************************
var overrideTypeformContactSalesWithVariantDataIfNeeded = function(param) {
    var contactSalesData = param.contactSalesData, getNewVariantForTest = param.getNewVariantForTest;
    if (!getNewVariantForTest) return contactSalesData;
    var newProps = {};
    if (contactSalesData.variantFormId) {
        newProps.formId = contactSalesData.variantFormId;
    }
    if (contactSalesData.variantPrefetchImages) {
        newProps.prefetchImages = contactSalesData.prefetchImages;
    }
    return _object_spread({}, contactSalesData, newProps);
};
var getTypeformContactSalesData = function(param) {
    var country = param.country, isTest = param.isTest, _getNewVariantForTest = param.getNewVariantForTest, getNewVariantForTest = _getNewVariantForTest === void 0 ? false : _getNewVariantForTest;
    // this function can not return null - must return a regionType from CONTACT_SALES_REGIONS
    if (isTest) {
        return CONTACT_SALES_REGIONS[TEST_REGION_TYPE];
    }
    var regions = Object.keys(CONTACT_SALES_REGIONS);
    var regionType = regions.find(function(region) {
        var _CONTACT_SALES_REGIONS_region;
        return (_CONTACT_SALES_REGIONS_region = CONTACT_SALES_REGIONS[region]) === null || _CONTACT_SALES_REGIONS_region === void 0 ? void 0 : _CONTACT_SALES_REGIONS_region.countries.includes(country);
    }) || DEFAULT_NO_SDR_TYPE;
    return overrideTypeformContactSalesWithVariantDataIfNeeded({
        contactSalesData: CONTACT_SALES_REGIONS[regionType],
        getNewVariantForTest: getNewVariantForTest
    });
};
module.exports = {
    getTypeformContactSalesData: getTypeformContactSalesData
};


/***/ }),

/***/ 15728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ap": function() { return /* binding */ shouldGetTypeformExperience; }
/* harmony export */ });
/* unused harmony exports getTestIsNewVariantByRegion, isEligibleToGetTypeform */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var services_ab_tests_acquisition_ab_test_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77784);
/* harmony import */ var services_ab_tests_acquisition_ab_test_service__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(services_ab_tests_acquisition_ab_test_service__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var constants_typeform_contact_sales__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13979);



var _obj;
var regionToTestMap = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_typeform_contact_sales__WEBPACK_IMPORTED_MODULE_1__/* .EMEA_GEO_REGION */ .ZZ, services_ab_tests_acquisition_ab_test_service__WEBPACK_IMPORTED_MODULE_0__.shouldGetContactSalesTypeformEmeaTest), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_typeform_contact_sales__WEBPACK_IMPORTED_MODULE_1__/* .AUSTRALIA_NEW_ZEALAND_GEO_REGION */ .hr, services_ab_tests_acquisition_ab_test_service__WEBPACK_IMPORTED_MODULE_0__.shouldGetContactSalesTypeformAnzTest), _obj);
var getTestIsNewVariantByRegion = function(param) {
    var region = param.region, abTests = param.abTests, sendBigBrainEvent = param.sendBigBrainEvent;
    var testByRegion = regionToTestMap[region] || function() {
        return false;
    };
    return testByRegion(abTests, sendBigBrainEvent);
};
var isEligibleToGetTypeform = function(region) {
    return region === constants_typeform_contact_sales__WEBPACK_IMPORTED_MODULE_1__/* .EMEA_GEO_REGION */ .ZZ || region === constants_typeform_contact_sales__WEBPACK_IMPORTED_MODULE_1__/* .AUSTRALIA_NEW_ZEALAND_GEO_REGION */ .hr || region === constants_typeform_contact_sales__WEBPACK_IMPORTED_MODULE_1__/* .AMERICA_GEO_REGION */ .Ux;
};
var shouldGetTypeformExperience = function(param) {
    var abTests = param.abTests, isTypeformDisabled = param.isTypeformDisabled, cloudfrontViewerCountry = param.cloudfrontViewerCountry, testTypeformContactSales = param.testTypeformContactSales, forceTypeformContactSalesExperience = param.forceTypeformContactSalesExperience, _sendBigBrainEvent = param.sendBigBrainEvent, sendBigBrainEvent = _sendBigBrainEvent === void 0 ? false : _sendBigBrainEvent;
    if (isTypeformDisabled) return false;
    if (forceTypeformContactSalesExperience) return true;
    if ((0,constants_typeform_contact_sales__WEBPACK_IMPORTED_MODULE_1__/* .isTypeformDisabledForRegion */ .nk)(cloudfrontViewerCountry)) return false;
    if ((0,constants_typeform_contact_sales__WEBPACK_IMPORTED_MODULE_1__/* .isTypeformFullyReleasedForCountry */ .FC)(cloudfrontViewerCountry)) return true;
    var region = (0,constants_typeform_contact_sales__WEBPACK_IMPORTED_MODULE_1__/* .getContactSalesRegionByCountry */ .Wz)(cloudfrontViewerCountry);
    return isEligibleToGetTypeform(region) && (testTypeformContactSales || getTestIsNewVariantByRegion({
        region: region,
        abTests: abTests,
        sendBigBrainEvent: sendBigBrainEvent
    }));
};


/***/ })

}]);